export default {
  upgrade: {
    title: 'Upgrade',
    heroTitle: 'Expand Intelligence – Learn Easier – Achieve More',
    supportedLabel: 'Supported',
    monthly: 'Monthly',
    yearly: 'Yearly',
    perMonth: '/month',
    freeButton: 'Free',
    upgradeButton: 'Upgrade',
    savingsBasic: 'Save 1,000,000 VND with yearly plan',
    savingsAdvanced: 'Save 15,000,000 VND with yearly plan',
    models: {
      gpt: 'GPT-5.2',
      deepseek: 'DeepSeek V3.2',
      grok: 'Grok 4.1',
      claude: 'Claude 3.7 Sonet',
      gemini: 'Gemini 3 Pro',
    },
    plans: {
      free: {
        name: 'Free',
        basicCredits: '20 basic credits/day',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        highlightsTitle: 'Q&A with AI models',
        highlights: [
          'Limited trial of AI image generation',
          'Create lessons for students with AI',
          'Upload documents up to 100MB',
        ],
      },
      basic: {
        name: 'Basic',
        basicCredits: '2000 basic credits/month',
        advancedCredits: '500 advanced credits/month',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        advancedModels: ['GPT-5.2', 'Grok 4.1', 'DeepSeek v3.2', 'Gemini 3 Pro', 'Claude 3.7 Sonet'],
        highlightsTitle: 'Unlock features:',
        highlights: [
          'Advanced image generation',
          'Slide creation',
          'Content creation',
          'Data analysis',
          'Unlimited lesson creation',
          'Upload documents up to 15GB',
        ],
      },
      advanced: {
        name: 'Advanced',
        basicCredits: '9000 basic credits/month',
        advancedCredits: '2000 advanced credits/month',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        advancedModels: ['GPT-5.2', 'Grok 4.1', 'DeepSeek v3.2', 'Gemini 3 Pro', 'Claude 3.7 Sonet'],
        highlightsTitle: 'Unlock features:',
        highlights: [
          'Advanced image generation',
          'Slide creation',
          'Content creation',
          'Data analysis',
          'Unlimited lesson creation',
          'Unlimited document uploads',
        ],
      },
    },
  },
  documentDetail: {
    pptx: {
      notSupportedTitle: 'PPTX preview is not supported in the browser.',
      notSupportedDescription: 'Please download or open with Microsoft PowerPoint.',
    },
    xmind: {
      notSupportedTitle: 'XMind preview is not supported in the browser.',
      notSupportedDescription: 'Please download or open with the XMind application.',
    },
    download: {
      notFound: 'File not found to download',
    },
    docx: {
      previewError: 'Error while previewing DOCX file.',
    },
    imagePreviewAlt: 'Image Preview',
  },
  common: {
    upload: 'Upload',
    add: 'Add',
    addFile: 'Add File',
    addChild: 'Add Child',
    addToFolder: 'Add to folder',
    addSuccess: 'Add Success',
    edit: 'Edit',
    editSuccess: 'Edit Success',
    error: 'Error',
    retry: 'Retry',
    delete: 'Delete',
    remove: 'Remove',
    deleteSuccess: 'Delete Success',
    confirmDelete: 'Are you sure you want to delete this record?',
    save: 'Save',
    saveSuccess: 'Save Success',
    reset: 'Reset',
    action: 'Action',
    export: 'Export',
    exportSuccess: 'Export Success',
    import: 'Import',
    importSuccess: 'Import Success',
    search: 'Search',
    searching: 'Searching...',
    clear: 'Clear',
    clearSuccess: 'Clear Success',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    download: 'Download',
    noData: 'No Data',
    wrong: 'Something went wrong, please try again later.',
    success: 'Success',
    failed: 'Failed',
    verify: 'Verify',
    unauthorizedTips: 'Unauthorized, please verify first.',
    stopResponding: 'Stop Responding',
    cancel: 'Cancel',
    rename: 'Rename',
    pin: 'Pin',
    unpin: 'Unpin',
    configuration: 'Configuration',
    view: 'View',
    pull: 'Add assistant',
    next: 'Next',
    previous: 'Previous',
    viewAll: 'View All',
    back: 'Back',
    publish: 'Publish',
    unpublish: 'Unpublish',
    move: 'Move',
    share: 'Share',
    settings: 'Settings',
    promoteAdmin: 'Promote Admin',
    logout: 'Log out',
    index: 'No',
    dataChanged: 'Data changed',
    dataChangedDescription: 'Are you sure you want to leave this page?',
    dataChangedButton: 'Leave',
    dataChangedCancel: 'Cancel',
    uploadSuccess: 'Upload Success',
    uploadFailed: 'Upload Failed',
    copy: 'Copy',
    shareQR: 'Share by QR',
    scanQR: 'Scan QR',
    createQR: 'Generate QR',
    embedded: 'Embedded',
    embeddedWeb: 'Embedded Web',
    information: 'Information',
    close: 'Close',
    filter: 'Filter',
    reload: 'Reload',
    returnToLogin: 'Return to Login',
    downloadSuccess: 'Download Success',
    downloadFailed: 'Download Failed',
    unsupported_format: 'This file format is not supported or an error occurred while previewing.',
    result: 'Result',
    newest: 'Newest',
    creationDate: 'Creation Date',
    alphabet: 'Alphabet',
    notifications: 'Notifications',
    announcements: 'Announcements',
    swapWorkspace: 'Swap Workspace',
    showMore: 'Show More',
    showLess: 'Show Less',
    loading: 'Loading',
    selectedText: 'Selected Text',
    attachments: 'Attachments',
    aiResponse: 'AI Response',
    aiThinking: 'AI is thinking',
    role: 'Role',
    approved: 'Approved',
    waiting: 'Waiting',
    correct: 'Correct',
    incorrect: 'Incorrect',
    correctAnswerIs: 'Correct answer is',
    check: 'Check',
    all: 'All',
    starOn: 'Star on',
    underDevelopment: 'Under Development',
    page: 'Page',
    of: 'of',
    duplicate: 'Duplicate',
    basicCredit: 'Basic',
    advancedCredit: 'Advanced',
    actions: 'Actions',
    enabled: 'Enabled',
    disabled: 'Disabled',
    showing: 'Showing',
    results: 'results',
    accept: 'Accept',
    recall: 'Recall',
    assignNow: 'Assign Now',
    assign: 'Assign',
    hide: 'Hide',
    agree: 'Agree',
    checkAll: 'Check All',
    options: 'Options',
    addAll: 'Add All',
    approveAll: 'Approve All',
    reject: 'Reject',
    addNew: 'Add',
    light: 'Light theme',
    dark: 'Dark theme',
    sort: 'Sort by',
    cancelSort: 'cancel Sort',
    create: 'Create',
    exportExcel: 'Export excel',
    more: 'More',
    basic: 'Basic',
    advanced: 'Advanced',
    updateSuccess: 'Update Success',
    updateFailed: 'Update Failed',
    deleteFailed: 'Delete Failed',
    createSuccess: 'Create Success',
    createFailed: 'Create Failed',
    saveFailed: 'Save Failed',
    loadSuccess: 'Load Success',
    loadFailed: 'Load Failed',
    aiModel: 'AI Model',
    admin: 'Admin',
    headmaster: 'Headmaster',
    viceHeadmaster: 'Vice Headmaster',
    teacher: 'Teacher',
    student: 'Student / Parent',
    syncData: 'Sync data',
    syncDataSuccess: 'Sync data successfully',
    unknown: 'Unknown',
    true: 'True',
    false: 'False',
    errorOccurred: 'An error occurred',
    justNow: 'Just now',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    ago: 'ago',
    done: 'Done',
  },
  aiModel: {
    title: 'AI Models',
    editTitle: 'Edit model',
    addTitle: 'Add model',
    logoCode: 'Logo code',
    modelCode: 'Model code',
    modelName: 'Model name',
    description: 'Description',
    provider: 'Provider',
    type: 'Type',
    creditCost: 'Credit cost',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    typeBasic: 'Basic',
    typeAdvanced: 'Advanced',
    providerAll: 'All',
    isPinned: 'Priority',
    viewMore: 'Other Models',
  },
  maintenance: {
    updateSystem: 'Update System',
    updatingSystem: 'Updating System',
    maintenanceSystem: 'Maintenance System',
    systemStatus: 'System Status',
    maintenanceTitle: 'Maintenance',
    maintenanceDescription: 'We are currently performing maintenance on the system. Please try again later.',
    maintenanceExtraDescription: 'The system will soon be back online. Thank you for your patience!',
    backToHome: 'Back to Home',
    contactSupport: 'For support, please contact',
    status: 'System status',
    expectedTime: 'Expected time',
  },
  billing: {
    title: 'Billing/Credit System Configuration',
    serviceName: 'Service Name',
    serviceId: 'Service ID (Optional)',
    method: 'Method',
    path: 'API Path',
    billingEnabled: 'Billing Enabled',
    requiredCreditType: 'Required Credit Type',
    fallbackCreditType: 'Fallback Credit Type',
    billingUnit: 'Billing Unit',
    baseCreditCost: 'Base Credit Cost',
    advanceCreditCost: 'Advance Credit Cost',
    creditPerToken: 'Credit Per Token',
    creditPerMb: 'Credit Per MB',
    minimumCreditCost: 'Minimum Credit Cost',
    rateLimit: 'Rate Limit',
    burstLimit: 'Burst Limit',
    targetType: 'Target Type',
    targetKey: 'Target Key',
    description: 'Description',
    tags: 'Tags',
    tierConfig: 'Tier Config',
    codeConfig: 'Code Config',
    enterServiceName: 'Enter service name',
    enterServiceIdOptional: 'Enter service ID (optional for create)',
    selectMethod: 'Select HTTP method',
    enterPath: 'Enter API path',
    selectCreditType: 'Select credit type',
    selectFallbackCreditType: 'Select fallback credit type',
    selectBillingUnit: 'Select billing unit',
    enterBaseCreditCost: 'Enter base credit cost',
    enterAdvanceCreditCost: 'Enter advance credit cost',
    enterCreditPerToken: 'Enter credit per token',
    enterCreditPerMb: 'Enter credit per MB',
    enterMinimumCreditCost: 'Enter minimum credit cost',
    enterRateLimit: 'Enter rate limit',
    enterBurstLimit: 'Enter burst limit',
    selectTargetType: 'Select target type',
    enterTargetKey: 'Enter target key',
    enterDescription: 'Enter description',
    enterTierConfig: 'Enter tier configuration (JSON)',
    enterCodeConfig: 'Enter code configuration (JSON)',
    saveConfiguration: 'Save Configuration',
    loadMockData: 'Load Mock Data',
    configurationSaved: 'Configuration saved successfully!',
    mockDataLoaded: 'Mock data loaded successfully!',
    formReset: 'Form reset to default values',
    checkFormErrors: 'Please check the form for errors',
    baseCredit: 'Base Credit',
    advanceCredit: 'Advance Credit',
    premiumCredit: 'Premium Credit',
    perRequest: 'Per Request',
    perToken: 'Per Token',
    perMb: 'Per MB',
    perHour: 'Per Hour',
    user: 'User',
    organization: 'Organization',
    project: 'Project',
    apiKey: 'API Key',
    // Billing configuration list
    configList: {
      title: 'Billing Configuration List',
      description: 'Manage billing configurations for API services',
      addNew: 'Add New',
      searchServiceName: 'Search by service name',
      filterByBillingUnit: 'Filter by billing unit',
      filterByTargetType: 'Filter by target type',
      noData: {
        title: 'No configurations found',
        description: 'Start by creating your first billing configuration',
      },
      deleteConfirm: 'Are you sure you want to delete this configuration?',
      deleteSuccess: 'Configuration deleted successfully',
      deleteError: 'Error deleting configuration',
      fetchError: 'Error loading configuration list',
    },
    // Data table
    table: {
      serviceName: 'Service Name',
      apiPath: 'API Path',
      billingUnit: 'Billing Unit',
      creditCost: 'Credit Cost',
      targetType: 'Target Type',
      targetKey: 'Target Key',
      status: 'Status',
    },
    // Billing units
    units: {
      perRequest: 'Per Request',
      perToken: 'Per Token',
      perMb: 'Per MB',
      perHour: 'Per Hour',
    },
    // Target types
    targetTypes: {
      user: 'User',
      organization: 'Organization',
      project: 'Project',
      apiKey: 'API Key',
    },
    validation: {
      serviceName: 'Please enter service name',
      serviceId: 'Please enter service ID',
      method: 'Please select HTTP method',
      path: 'Please enter API path',
      requiredCreditType: 'Please select required credit type',
      billingUnit: 'Please select billing unit',
      baseCreditCost: 'Base credit cost must be non-negative',
      advanceCreditCost: 'Advance credit cost must be non-negative',
      creditPerToken: 'Credit per token must be non-negative',
      creditPerMb: 'Credit per MB must be non-negative',
      minimumCreditCost: 'Minimum credit cost must be non-negative',
    },
  },
  mindmap: {
    // Default text
    defaultText: 'Mind Map',
    newMindMap: 'New Mind Map',

    // Menu actions
    openMenu: 'Open Menu',
    hideMenu: 'Hide Menu',
    showMenu: 'Show Menu',

    // Theme section
    theme: 'Theme',
    default: 'Default',
    classic: 'Classic',
    minions: 'Minions',
    pinkGrape: 'Pink Grape',
    mint: 'Mint',
    gold: 'Gold',
    vitalityOrange: 'Vitality Orange',
    greenLeaf: 'Green Leaf',
    dark2: 'Dark 2',
    skyGreen: 'Sky Green',
    classic2: 'Classic 2',
    classic3: 'Classic 3',
    classic4: 'Classic 4',
    classicGreen: 'Classic Green',
    classicBlue: 'Classic Blue',
    blueSky: 'Blue Sky',
    brainImpairedPink: 'Brain Impaired Pink',
    dark: 'Dark',
    earthYellow: 'Earth Yellow',
    freshGreen: 'Fresh Green',
    freshRed: 'Fresh Red',
    romanticPurple: 'Romantic Purple',
    simpleBlack: 'Simple Black',
    courseGreen: 'Course Green',
    coffee: 'Coffee',
    redSpirit: 'Red Spirit',
    blackHumour: 'Black Humour',
    lateNightOffice: 'Late Night Office',
    blackGold: 'Black Gold',
    avocado: 'Avocado',
    autumn: 'Autumn',
    orangeJuice: 'Orange Juice',

    // Layout section
    layout: 'Layout',
    logicalStructure: 'Logical Structure',
    logicalStructureLeft: 'Logical Structure Left',
    mindMap: 'Mind Map',
    catalogOrganization: 'Catalog Organization',
    organizationStructure: 'Organization Structure',
    timeline: 'Timeline',
    timeline2: 'Timeline 2',
    fishbone: 'Fishbone',
    fishbone2: 'Fishbone 2',
    rightFishbone: 'Right Fishbone',
    rightFishbone2: 'Right Fishbone 2',
    verticalTimeline: 'Vertical Timeline',
    verticalTimeline2: 'Vertical Timeline 2',
    verticalTimeline3: 'Vertical Timeline 3',

    // View options
    viewOptions: 'View Options',
    showConnections: 'Show Connections',
    showIcons: 'Show Icons',
    fullscreenMode: 'Fullscreen Mode',
    showGrid: 'Show Grid',

    // Export section
    exportFile: 'Export File',
    exportPNG: 'Export PNG',
    exportSVG: 'Export SVG',
    exportJSON: 'Export JSON',
    toggleMiniMap: 'Toggle Mini Map',
    exportModal: {
      title: 'Export File',
      exportType: 'Export Type',
      fileName: 'File Name',
      formatOptions: 'Format Options',
      paddingX: 'Padding X',
      paddingY: 'Padding Y',
      transparent: 'Transparent Background',
      fitBg: 'Fit Background (effective when using background image)',
      configOptions: 'Configuration Options',
      includeConfig: 'Include Configuration (layout, theme, etc.)',
      footerText: 'Add Footer Text',
      footerTextPlaceholder: 'Example: From simple-mind-map',
      cancel: 'Cancel',
      export: 'Export',
      exportTypes: {
        smm: {
          name: 'Document',
          description: 'Original document format of Simple Mind Map',
        },
        png: {
          name: 'Image',
          description: 'Common image format, suitable for viewing and sharing',
        },
        svg: {
          name: 'SVG',
          description: 'Vector format, editable and scalable',
        },
        pdf: {
          name: 'PDF',
          description: 'Common document format, easy to print and share',
        },
        md: {
          name: 'Markdown',
          description: 'Structured text format, easy to read and edit',
        },
        xmind: {
          name: 'XMind',
          description: 'Format compatible with XMind',
        },
        txt: {
          name: 'TXT',
          description: 'Simple text format',
        },
        json: {
          name: 'JSON',
          description: 'Structured data format',
        },
      },
    },

    // Toolbar buttons
    undo: 'Undo (Ctrl+Z)',
    redo: 'Redo (Ctrl+Y)',
    drawMode: 'Draw Mode',
    insertSibling: 'Insert Sibling Node (Enter)',
    insertChild: 'Insert Child Node (Tab)',
    deleteNode: 'Delete Node (Delete)',
    insertImage: 'Insert Image',
    insertIcon: 'Insert Icon',
    insertLink: 'Insert Link',
    insertNote: 'Insert Note',
    insertTag: 'Insert Tag',
    insertSummary: 'Insert Summary (Ctrl+G)',
    insertConnection: 'Insert Connection',
    insertFormula: 'Insert Formula',
    insertOutline: 'Insert Outline',
    demonstrate: 'Demonstrate',
    aiContinue: 'AI Continue',
    openFolder: 'Open Folder',
    newFile: 'New File',
    openFile: 'Open File',
    saveAs: 'Save As',
    importFile: 'Import File',
    exportFileToolbar: 'Export File',

    // Popover form labels
    insertImageTitle: 'Insert Image',
    imageUrl: 'Image URL:',
    imageTitle: 'Title:',
    imageWidth: 'Width:',
    imageHeight: 'Height:',
    insertIconsTitle: 'Insert Icons',
    icons: 'Icons:',
    addIcon: 'Add Icon',
    insertLinkTitle: 'Insert Link',
    url: 'URL:',
    text: 'Text:',
    insertNoteTitle: 'Insert Note',
    noteContent: 'Note Content:',
    insertTagsTitle: 'Insert Tags',
    tags: 'Tags:',
    addTag: 'Add Tag',
    insertSummaryTitle: 'Insert Summary',
    summaryText: 'Summary Text:',
    insertFormulaTitle: 'Formula',
    formulaPlaceholder: 'Please enter LaTeX syntax',
    confirm: 'Confirm',
    commonFormulas: 'Common Formulas',
    formula: 'Formula',
    latex: 'LaTeX',
    cancel: 'Cancel',
    insert: 'Insert',
    enterTagName: 'Enter tag name',

    // Bottom bar
    zoomOut: 'Zoom Out',
    zoomIn: 'Zoom In',
    scale: 'Scale',
    language: 'Language',
    vietnamese: 'Vietnamese',
    english: 'English',

    // Node context menu
    insertSiblingNode: 'Insert Sibling Node',
    insertChildNode: 'Insert Child Node',
    insertParentNode: 'Insert Parent Node',
    insertSummaryNode: 'Insert Summary',
    moveNodeUp: 'Move Node Up',
    moveNodeDown: 'Move Node Down',
    collapseAllChildren: 'Collapse All Children',
    expandAllChildren: 'Expand All Children',
    deleteCurrentNode: 'Delete Node',
    deleteCurrentNodeOnly: 'Delete Current Node Only',
    copyNode: 'Copy Node',
    cutNode: 'Cut Node',
    pasteNode: 'Paste Node',
    clearCustomStyle: 'Clear Custom Style',
    exportNodeAsPng: 'Export Node as PNG',
    aiContinueNode: 'AI Continue',
    removeNote: 'Remove Note',
    removeLink: 'Remove Link',
    removeTag: 'Remove Tag',
    // Canvas context menu
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    reformat: 'Reformat',
    returnToMainNode: 'Return to Main Node',
    fitToScreen: 'Fit to Screen',
    addRootNode: 'Add Root Node',

    // Right side menu
    openMenuTooltip: 'Open Menu',
    hideMenuTooltip: 'Hide Menu',
    showMenuTooltip: 'Show Menu',
    themeTooltip: 'Theme',
    layoutTooltip: 'Layout',
    viewOptionsTooltip: 'View Options',
    exportFileTooltip: 'Export File',

    // Main page content
    title: 'AI Mind Map Generator',
    description: 'In just a few seconds, scattered ideas will be transformed into clear, understandable, and visual mind maps, helping you grasp and implement every plan effectively.',
    placeholder: 'Describe what you want to create...',
    startGenerating: 'Start Generating',
    languageOptions: {
      vietnamese: 'Vietnamese',
      english: 'English',
    },
    suggestedPrompts: 'Suggested Examples',
    suggestedPromptsList: {
      option1: 'Market penetration strategy for social software',
      option2: 'Effective communication tips',
      option3: 'How to read a book',
      option4: '5-day Thailand travel itinerary',
    },
    createdMindmaps: 'Created Mind Maps',
    noMindmaps: 'No mind maps yet',
    noMindmapsDescription: 'Create your first mind map by entering a request above',
    viewDetails: 'View Details',
    completed: 'Completed',
    tokens: 'tokens',
    deleteMindmap: 'Delete Mind Map',
    deleteMindmapConfirm: 'Are you sure you want to delete this mind map?',
    deleteMindmapSuccess: 'Mind map deleted successfully!',
    deleteMindmapError: 'An error occurred while deleting the mind map',
    pleaseEnterRequest: 'Please enter a request to create a mind map',
    workspaceNotFound: 'Workspace ID not found',
    defaultDescription: 'Mind map automatically generated from your request.',

    // Detail page
    loadingMindmap: 'Loading mind map...',
    noMindmapData: 'No mind map data available',
    backToMainPage: 'Back to main page',
    cannotLoadMindmap: 'Cannot load mind map',
    errorLoadingMindmap: 'An error occurred while loading the mind map',
    errorGeneratingMindmap: 'An error occurred while generating the mind map',
    noDataToGenerate: 'No data available to generate mind map',
    newAssociativeLine: 'New Associative Line',
    newAssociativeLineText: 'New Associative Line',

    // components
    newNode: 'New Node',
    newChildNode: 'New Child Node',
    newParentNode: 'New Parent Node',
    newSummaryNode: 'New Summary',
    newConnectionNode: 'New Connection',
    newFormulaNode: 'New Formula',
    newOutlineNode: 'New Outline',
    from: 'From',
    nodes: 'Nodes',

    // placeholder
    noteContentPlaceholder: 'Enter note content...',
    summaryContentPlaceholder: 'Enter summary content...',

    // line style options
    lineStyleOptions: {
      curve: 'Curve',
      straight: 'Straight',
      direct: 'Direct',
    },

    // node shape options
    nodeShapeOptions: {
      rectangle: 'Rectangle',
      circle: 'Circle',
      diamond: 'Diamond',
    },

    // font weight options
    fontWeightOptions: {
      normal: 'Normal',
      bold: 'Bold',
      bolder: 'Bolder',
      lighter: 'Lighter',
    },

    // text decoration options
    textDecorationOptions: {
      none: 'None',
      underline: 'Underline',
      lineThrough: 'Line Through',
      overline: 'Overline',
    },

    // theme options
    themeOptions: {
      default: 'Default',
      classic: 'Classic',
      minions: 'Minions',
      pinkGrape: 'Pink Grape',
      mint: 'Mint',
      gold: 'Gold',
      vitalityOrange: 'Vitality Orange',
      greenLeaf: 'Green Leaf',
      dark2: 'Dark 2',
      redSpirit: 'Red Spirit',
      coffee: 'Coffee',
      orangeJuice: 'Orange Juice',
      avocado: 'Avocado',
      autumn: 'Autumn',
      classicGreen: 'Classic Green',
      classicBlue: 'Classic Blue',
      dark: 'Dark',
      earthYellow: 'Earth Yellow',
      freshGreen: 'Fresh Green',
      freshRed: 'Fresh Red',
      romanticPurple: 'Romantic Purple',
      simpleBlack: 'Simple Black',
      courseGreen: 'Course Green',
      blackHumour: 'Black Humour',
      lateNightOffice: 'Late Night Office',
      blackGold: 'Black Gold',
      brainImpairedPink: 'Brain Impaired Pink',
      blueSky: 'Blue Sky',
      classic2: 'Classic 2',
      classic3: 'Classic 3',
      classic4: 'Classic 4',
      skyGreen: 'Sky Green',
    },
  },
  rightSideMenu: {
    openMenu: 'Open Menu',
    hideMenu: 'Hide Menu',
    showMenu: 'Show Menu',
    theme: 'Theme',
    layout: 'Layout',
    viewOptions: 'View Options',
    showConnections: 'Show Connections',
    showIcons: 'Show Icons',
    fullscreenMode: 'Fullscreen Mode',
    showGrid: 'Show Grid',
    export: 'Export',
    lineStyle: 'Line Style',
    lineColor: 'Line Color',
    lineWidth: 'Line Width',
    lineDasharray: 'Line Pattern',
    generalizationLineColor: 'Summary Line Color',
    generalizationLineWidth: 'Summary Line Width',
    associativeLineColor: 'Connection Line Color',
    associativeLineWidth: 'Connection Line Width',
    associativeLineActiveColor: 'Active Connection Color',
    associativeLineActiveWidth: 'Active Connection Width',
    moreDetailOptions: 'More Detail Options',
    customizeStyle: 'Customize Style',
    connectionLine: 'Connection Line',
    lineThickness: 'Line Thickness',
    color: 'Color',
    customOption: 'Custom Option',
    node: 'Node',
    shape: 'Shape',
    font: 'Font',
    fontSize: 'Font Size',
    fontWeight: 'Font Weight',
    textDecoration: 'Text Decoration',
    textColor: 'Text Color',
    backgroundColor: 'Background Color',
    borderColor: 'Border Color',
    border: 'Border',
    borderWidth: 'Border Width',
    borderRadius: 'Border Radius',
    spacing: 'Spacing',
    horizontalSpacing: 'Horizontal Spacing',
    verticalSpacing: 'Vertical Spacing',
  },
  table: {
    quickSearchPlaceholder: 'quick search',
  },
  chat: {
    newChatButton: 'New chat',
    newChat: 'New chat',
    newFolder: 'New Folder',
    placeholder: 'Ask me anything',
    placeholderMobile: 'Ask me anything',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    downloaded: 'Downloaded',
    urlCopied: 'URL copied',
    copyCode: 'Copy Code',
    clearChat: 'Clear Chat',
    clearChatConfirm: 'Are you sure to clear this chat?',
    exportImage: 'Export Image',
    exportImageConfirm: 'Are you sure to export this chat to png?',
    exportSuccess: 'Export Success',
    exportFailed: 'Export Failed',
    usingContext: 'Context Mode',
    turnOnContext: 'In the current mode, sending messages will carry previous chat records.',
    turnOffContext: 'In the current mode, sending messages will not carry previous chat records.',
    deleteMessage: 'Delete Message',
    deleteMessageConfirm: 'Are you sure to delete this message?',
    deleteHistoryConfirm: 'Are you sure to clear this history?',
    clearHistoryConfirm: 'Are you sure to clear chat history?',
    preview: 'Preview',
    showRawText: 'Show as raw text',
    thinking: 'Thinking...',
    chatHistory: 'Chat history',
    version: 'Version',
    searchChat: 'Search Chat',
    pleaseUploadImage: 'Only allowed to upload image files (JPG, PNG, GIF, etc.)',
    fileSizeTooLarge: 'File size must not exceed 10MB',
    loading: 'AI is thinking  ...',
    table: {
      title: 'Chat History',
      name: 'Name',
      description: 'Description',
      action: 'Action',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      status: 'Status',
      agent: 'Agent',
      chatHistory: 'Chat History',
      chatHistoryDescription: 'Chat history will be displayed here',
      chatHistoryAction: 'View Chat History',
      chatHistoryCreatedAt: 'Created At',
      chatHistoryUpdatedAt: 'Updated At',
      chatHistoryStatus: 'Status',
      titleDeleteHistory: 'Delete this conversation',
      contentDeleteHistory: 'This action will delete all chat history with the learning assistant. You will not be able to recover the messages after deletion.',
      deleteHistorySuccess: 'Chat history deleted successfully',
      deleteHistoryFailed: 'Failed to delete chat history',
    },
    shareChat: {
      shareChatDescription: 'Hello! How can I help you?',
      suggestedQuestions: 'Suggested Questions',
      suggestedQuestionsDescription: 'Suggested questions will be displayed here',
      suggestedQuestionsAction: 'View suggested questions or pick a question below',
      pickAQuestion: 'Pick a question',
      orTypeAQuestion: 'Or type a question in the box below',
      typeAQuestion: 'Type a question in the box below',
      youCanAskMeQuestion: 'You can ask me some questions like',
    },
    statisticalAnalysis: 'Statistical Analysis',
    fileAttached: 'file attached',
    filesAttached: 'files attached',
    filePasted: 'File pasted',
    fileDropped: 'File dropped',
    dropFilesHere: 'Drop files here',
    supportedFormats: 'Supports images, PDF, Word, Excel, PowerPoint and many other formats',
    defaultWelcomeMessage: 'Hello! How can I help you?',
    suggestionsTitle: '💡 You can ask me:',
    orEnterQuestion: 'Or enter your question below',
    enterQuestion: 'Enter your question below',
    tableAnalysisPrompt: 'Please present all tables in the result description according to the format below, ensuring:\n- Has title\n- Has separator lines above and below the table\n- Each variable is separated, sub-values indented by 1 tab\n- Numbers are right-aligned, variable names are left-aligned\n- There are footnotes at the end of the table (e.g.: ¹ n (%))\n- Keep the correct number of dashes and format as template\n- All numbers display in the same font size\n- Only output tables, no introduction.',
    onlyImagesAllowed: 'Only image files are allowed',
    documentsNotAllowed: 'Document uploads are not allowed for this assistant',
    uploadsNotAllowed: 'File uploads are not allowed for this assistant',
    fileNotAllowed: 'File type not allowed',
    submitError: 'Failed to send message. Please try again.',
    titleUpdateNameChat: 'Rename conversation',
    nameHistoryChat: 'Conversation name',
    nameHistoryChatPlaceholder: 'Enter conversation name',
  },
  workspace: {
    letStart: 'Let\'s get started',
    createWorkspace: 'Create Workspace',
    chooseWorkspace: 'Choose your workspace',
    createNewWorkspace: 'Create New Workspace',
    updateWorkspace: 'Update Workspace',
    workspaceName: 'Workspace Name',
    description: 'Description',
    sector: 'Sector',
    guest: 'Guest',
    createSuccess: 'Create Workspace Success',
    createError: 'Create Workspace Error',
    updateSuccess: 'Update Workspace Success',
    updateError: 'Update Workspace Error',
    deleteSuccess: 'Delete Workspace Success',
    deleteError: 'Delete Workspace Error',
    deleteWorkspace: 'Delete Workspace',
    deleteWorkspaceDescription: 'Are you sure you want to delete this workspace?',
    workspace: 'Workspace',
    workspaceList: 'Workspace List',
    workspaceListEmpty: 'No workspace found',
    workspaceListEmptyDescription: 'Create your first workspace to start collaborating with your team',
    workspaceListEmptyButton: 'Create Workspace',
    createdBy: 'Created by',
    ownerBy: 'Owned by',
    workspaceManagement: 'Workspace Management',
    workspaceManagementDescription: 'Create and manage your workspaces to work more efficiently with your team',
    welcomeBonus: 'Welcome Bonus! 🎉',
    welcomeBonusDescription: 'Congratulations! You\'ve received welcome credits for your new account.',
    welcomeBonusSubDescription: 'You can now start using our AI services with your free credits.',
    welcomeBonusAmount: 'You received:',
    welcomeBonusBasic: '1,000 Basic Credits',
    welcomeBonusAdvanced: '500 Advanced Credits',
    welcomeBonusUpgrade: 'To use more credits, please upgrade to Pro.',
    modal: {
      validate: {
        workspace_name: 'Workspace name cannot be empty.',
        industry: 'Sector cannot be empty.',
      },
    },
  },
  setting: {
    setting: 'Setting',
    general: 'General',
    advanced: 'Advanced',
    config: 'Config',
    avatarLink: 'Avatar Link',
    name: 'Name',
    description: 'Description',
    role: 'Role',
    temperature: 'Temperature',
    top_p: 'Top_p',
    resetUserInfo: 'Reset UserInfo',
    chatHistory: 'ChatHistory',
    theme: 'Theme',
    language: 'Language',
    api: 'API',
    reverseProxy: 'Reverse Proxy',
    timeout: 'Timeout',
    socks: 'Socks',
    httpsProxy: 'HTTPS Proxy',
    balance: 'API Balance',
    monthlyUsage: 'Monthly Usage',
    openSource: 'This project is open sourced at',
    freeMIT: 'free and based on the MIT license, without any form of paid behavior!',
    stars: 'If you find this project helpful, please give me a Star on GitHub or give a little sponsorship, thank you!',
    colorTheme: 'Color Theme',

  },
  store: {
    siderButton: 'Prompt Store',
    local: 'Local',
    online: 'Online',
    title: 'Title',
    description: 'Description',
    clearStoreConfirm: 'Whether to clear the data?',
    importPlaceholder: 'Please paste the JSON data here',
    addRepeatTitleTips: 'Title duplicate, please re-enter',
    addRepeatContentTips: 'Content duplicate: {msg}, please re-enter',
    editRepeatTitleTips: 'Title conflict, please revise',
    editRepeatContentTips: 'Content conflict {msg} , please re-modify',
    importError: 'Key value mismatch',
    importRepeatTitle: 'Title repeatedly skipped: {msg}',
    importRepeatContent: 'Content is repeatedly skipped: {msg}',
    onlineImportWarning: 'Note: Please check the JSON file source!',
    downloadError: 'Please check the network status and JSON file validity',
  },
  knowledge: {
    title: 'Knowledge',
    create: 'Create knowledge',
    extraction: 'Text Extraction',
    search: 'Search knowledge',
    import: ' Import knowledge',
    edit: 'Edit knowledge',
    createEmptyKnowledge: 'Create an empty knowledge',
    emptyKnowledge: 'I want to create an empty Knowledge',
    name: 'Knowledge name',
    description: 'Knowledge description',
    titleDelete: 'Delete this Knowledge?',
    contentDeleteAgent: 'This knowledge base is currently used by the {agent} assistant. If you proceed, it will be deleted and automatically removed from all associated agents.\nDo you want to continue?',
    contentDelete: 'This knowledge base will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
    titleErrorDelete: 'Failed to Delete',
    contentErrorDelete: 'The assistant using this knowledge base has already been published to the store. Please unpublish the assistant before deleting the knowledge base.',
    document: {
      title: 'Documents',
      description: 'All files of the knowledge base {name} are displayed here.',
      create: 'Add file',
      search: 'Search file',
      name: 'Name ',
      docs: 'Docs',
      words: 'Words',
      linkedApps: 'Linked Agent',
      titleDelete: 'Are you sure Delete?',
      contentDelete: 'This knowledge has been linked to educational assistants. If you delete it, the assistants using this knowledge may perform less accurately. Are you sure you want to delete it?',
      documentInfo: 'Document Information',
    },
    steps: {
      dataSource: 'Data Source',
      documentProcessing: 'Document Processing',
      executeFinish: 'Execute & Finish',
      next: 'Next',
      saveProcess: 'Save & Process',
      previous: 'Previous step',
      goToDocument: 'Go To Document',
      uploadFile: 'Upload File',
      uploadImage: 'Text from image',
      importFromUrl: 'Import From Url',
      inputText: 'Input Text',
      knowledgeCreated: 'Knowledge created',
      knowledgeCreatedDes: 'We automatically named the Knowledge, you can modify it at any time.',
      embeddingCompleted: 'Embedding completed',
      embeddingError: 'Embedding error',
      guide: 'What\'s next',
      guideDes: 'After the document finishes indexing, the Knowledge can be integrated into the application as context, you can find the context setting in the prompt orchestration page. You can also create it as an independent ChatGPT indexing plugin for release.',
    },
    importFromUrl: {
      placeholder: 'https://www.example.com',
      supportedUrls: 'Supported URLs:',
      webPage: 'Web page: content will be downloaded as .html file',
      fileFormats: 'File with format:',
      googleDocs: 'Public Google Docs, Slides',
      maxSize: 'Maximum file size:',
      importing: 'Importing from URL:',
    },
    inputText: {
      title: 'Input your content',
      contentLabel: 'Content',
      contentPlaceholder: 'Paste or input your content here. Maximum 10,000 words.',
      words: 'words',
      fileNameLabel: 'New file name',
      fileNamePlaceholder: 'Example document',
      importing: 'Importing content',
    },
    chunk: {
      chunkSetting: 'Section Settings',
      chunkingSetting: 'Chunking Settings',
      general: 'General',
      generalDescription: 'The text will be divided into multiple paragraphs with similar processing. Suitable for relatively uniform text: continuous content, without clear section or subsection structures, etc. (e.g., articles, books, reports)',
      hierarchical: 'Parent-child',
      hierarchicalDescription: 'The text will be divided into "parent paragraphs" and within each parent paragraph there will be "child paragraphs" for searching or retrieving. Keep the "parent paragraph" as the broad context, and use the "child paragraph" to answer precisely. This is suitable for texts with a large section structure containing many small sections (e.g., textbooks, contracts, ...).',
      removeExtraSpaces: 'Remove extra spaces, empty lines, and consecutive tabs',
      removeUrlsEmails: 'Remove all URLs and email addresses',
      chunkQAFormat: 'Split each Q&A pair into separate sections',
      chunkQAFormatDescription: 'Enable this option will consume more tokens',
      detectLanguage: 'Detection language',
      delimiter: 'Split by',
      maximumChunkLength: 'Maximum section length',
      maximumChunkLengthSuffix: 'characters',
      chunkOverlap: 'Overlap between sections',
      chunkOverlapSuffix: 'characters',
      previewChunk: 'Preview Chunk',
      textPreprocessingRules: 'Text Pre-processing Rules',
      parentChunkForContext: 'Parent-chunk for Context',
      childChunkForRetrieval: 'Child-chunk for Answer',
      paragraph: 'Divide the text into paragraphs',
      paragraphDescription: 'This mode splits the text in to paragraphs based on delimiters and the maximum chunk length, using the split text as the parent chunk for retrieval.',
      custom: 'Custom',
      fullDoc: 'Full Doc',
      fullDocDescription: 'The entire document is used as the parent chunk and retrieved directly. Please note that for performance reasons, text exceeding 10000 tokens will be automatically truncated.',
      indexMethod: 'Search mode',
      highQuality: 'High Quality',
      highQualityDescription: 'Smarter and more precise search',
      highQualitySubDescription: 'The educational assistant can perform semantic search and understand the meaning of questions. Answers are more accurate, especially for long or complex queries.',
      highQualityNote: 'Once finishing embedding in High Quality mode, reverting to Economical mode is not available.',
      embeddingModel: 'Embedding Model',
      economy: 'Economical',
      economyDescription: 'Faster search, suitable for simple lookups',
      economySubDescription: 'Educational assistant equipped with knowledge can search faster, suitable for cases requiring simple lookups',
      retrievalSetting: 'Retrieval Setting',
      retrievalSettingNote: 'Learn more about retrieval method, you can change this at any time in the Knowledge settings.',
      semanticSearch: 'Semantic Search',
      semanticSearchDes: 'Generate query embeddings and search for the text chunk most similar to its vector representation.',
      fullTextSearch: 'Full-Text Search',
      fullTextSearchDes: 'Index all terms in the document, allowing users to search any term and retrieve relevant text chunk containing those terms.',
      hybridSearch: 'Hybrid Search',
      hybridSearchDes: 'Execute full-text search and vector searches simultaneously, re-rank to select the best match for the user\'s query. Users can choose to set weights or configure to a Rerank model.',
      rerankModel: 'Rerank Model',
      scoreThreshold: 'Score Threshold',
      topK: 'Top K',
      recommend: 'Recommend',
      weightedScore: 'Weighted Score',
      weightedScoreDes: 'By adjusting the weights assigned, this rerank strategy determines whether to prioritize semantic or keyword matching.',
      rerankModelDes: 'Rerank model will reorder the candidate document list based on the semantic match with user query, improving the results of semantic ranking',
      semantic: 'Semantic',
      keyword: 'Keyword',
      invertedIndex: 'Inverted Index',
      invertedIndexDes: 'Inverted Index is a structure used for efficient retrieval. Organized by terms, each term points to documents or web pages containing it.',
      preview: 'Preview',
      estimatedChunks: 'Estimated chunks',
      clickPreviewChunk: ' Click the \'Preview Chunk\' button on the left to load the preview',
      chunks: 'Chunks',
      sections: 'sections',
      parentChunks: 'Parent chunks',
      childChunks: 'Child Chunks',
      result: 'Result',
      chunk: 'Section',
      character: 'characters',
      inputText: 'Input Text',
      keywords: 'Keyword',
      addKeyword: 'Add keyword',
      addAnotherOne: 'Add Another One',
      addParameter: 'Add Section',
      all: 'All',
      search: 'Search',
      edit: 'Edited',
      query: 'Query',
      active: 'Active',
      inactive: 'Inactive',
      enabled: 'Enable',
      disabled: 'Disable',
      addChunk: 'Add Section',
      addChildChunk: 'Add Child Section',
      newChunk: 'New Section',
      newChildChunk: 'New Child Section',
      editChunk: 'Edit Section',
      originalFileName: 'Original File Name:',
      originalFileSize: 'Original File Size:',
      uploadDay: 'Upload Date:',
      lastUpdateDay: 'Last Updated Date:',
      source: 'Source',
      technicalParameters: 'Technical Parameters',
      paraSpec: 'Section mode:',
      paraLength: 'Max section length:',
      avarageLength: 'Avarage section length:',
      paraNumber: 'Number of sections:',
      paragraphs: 'paragraphs',
      retrievalCount: 'AI queries',
      timesUsed: 'Times used:',
      immersionTime: 'Embedding Time',
      embededCost: 'Embedding Cost',
      name: 'File Name',
      chunkMode: 'Chunking Mode',
      words: 'Words',
      uploadTime: 'Upload Time',
      status: 'Status',
      action: 'Action',
      available: 'Available',
      titleDelete: 'Delete this chunk?',
      times: 'times',
      lineBreak: '{n} line break',
      identifyParentParagraph: 'How to identify the parent paragraph',
      searchMethod: 'Search Method',
      arrangementResults: 'Automatically select and rank the most relevant results',
      numberSegmentsAnalysis: 'Number of segments used for analysis',
      displayResultsRelatedQuestion: 'Show results only if relevant to the question',
      uploadedBy: 'Uploaded by:',
      numberOfCharacters: 'Number of characters:',
      collapse: 'Collapse',
    },
    metadata: {
      name: 'Name',
      metadata: 'Metadata',
      addMetadata: 'Add Metadata',
      description: 'You can manage all metadata in this knowledge here. Modifications will be synchronized to every document.',
      note: 'Metadata serves as a critical filter that enhances the accuracy and relevance of information retrieval. You can modify and add metadata for this document here.',
      startLabel: 'Start Labeling',
      newMetadata: 'Add New Metadata',
      manage: 'Manage',
      titleDelete: 'Confirm to delete',
      contentDelete: 'Are you sure you want to delete the metadata "{name}"',
    },
    extract: {
      title: 'Extract text from image',
      extraction: 'Extract',
      download: 'Download',
      createNew: 'Create new knowledge base',
      addToKnowledge: 'Add to existing knowledge base',
    },
    languageOptions: {
      vietnamese: 'Vietnamese',
      english: 'English',
    },
  },
  upload: {
    steps: {
      chooseDataFile: 'Choose data file',
      checkAndFinish: 'Review & finish',
    },
    drag_instruction: 'Click to upload, or drag and drop',
    supported_format: 'Supported formats',
    support_format: 'Support format',
    max_size: 'Maximum file size: {size}',
    chooseFile: 'Choose Files',
    uploadYourFile: 'Upload your files',
    uploadYourImages: 'Upload your images',
    uploadYourPDFFiles: 'Upload your PDF',
    uploadFileForAssistant: 'Upload knowledge for assistant',
    error: {
      invalid_type: 'Invalid file type',
      too_large: 'File is too large. Max: {size} MB',
      too_many: 'Too many files. Max allowed: {max}',
    },
    previewDocument: 'Preview Document',
  },
  menu: {
    home: 'Home',
    dashboard: 'Dashboard',
    folder: 'Folder',
    monitor: 'Monitor',
    chat: 'Chat',
    agent: 'Agent',
    knowledges: 'Knowledge',
    knowledge: 'Knowledge',
    document: 'Document',
    tasks: 'Tasks',
    settings: 'Settings',
    agentStore: 'NextSchool Store',
    userProfile: 'Profile',
    configuration: 'Configuration',
    transaction: 'Transaction',
    helpCommunity: 'Help & community',
    tool: 'Tools',
    userGuide: 'User guide',
    forum: 'Forum',
    contactSupport: 'Contact support',
    elearning: 'Elearning',
    aiElearning: 'AI eLearning',
    slide: 'Slide',
    addAgent: 'Add Agent',
    updateAgent: 'Update Agent',
    uploadAgent: 'Upload Agent',
    viewAgent: 'View Agent',
    configureAgent: 'Configure Agent',
    assignAgent: 'Assign Agent',
    imageGeneration: 'AI Image Generation',
    createKnowledge: 'Create Knowledge',
    knowledgeDetail: 'Knowledge Detail',
    createDocument: 'Create Document',
    documentDetail: 'Document Detail',
    documentSettings: 'Document Settings',
    textExtraction: 'Text Extraction',
    brandVoices: 'Brand Voices',
    parameterConfiguration: 'Parameter Configuration',
    paymentSystem: {
      title: 'Payment System',
      tabs: {
        packages: 'Package Management',
        modelPricing: 'Model Pricing',
        transactions: 'Transaction Management',
      },
      packages: {
        title: 'Package List',
        packageName: 'Package Name',
        price: 'Price',
        status: 'Status',
        createdAt: 'Created At',
        actions: 'Actions',
        active: 'Active',
        inactive: 'Inactive',
        activate: 'Activate',
        deactivate: 'Deactivate',
        edit: 'Edit',
        delete: 'Delete',
        searchPlaceholder: 'Search package name',
        statusPlaceholder: 'Status',
        all: 'All',
        free: 'Free',
        perMonth: '/month',
        features: {
          '10 questions/day': '10 questions/day',
          'Basic chatbot support': 'Basic chatbot support',
          'Unlimited questions': 'Unlimited questions',
          'Advanced chatbot support': 'Advanced chatbot support',
          'Detailed reports': 'Detailed reports',
          'API access': 'API access',
          'User management': 'User management',
          'Priority support': 'Priority support',
          'Custom customization': 'Custom customization',
        },
      },
      modelPricing: {
        title: 'Model Pricing List',
        search: 'Search',
        provider: 'Provider',
        type: 'Type',
        changeParams: 'Change Exchange Rate',
        exportToExcel: 'Export to Excel',
        exportToPDF: 'Export to PDF',
        print: 'Print',
        serialNumber: 'No.',
        modelName: 'Model Name',
        inputPrice: 'Input Price ($)',
        outputPrice: 'Output Price ($)',
        lastUpdated: 'Last Updated',
        edit: 'Edit',
        delete: 'Delete',
        addNew: 'Add New',
        editTitle: 'Edit Model Price',
        modelCode: 'Model Code',
        creditType: 'Type',
        changeReason: 'Change Reason',
        cancel: 'Cancel',
        save: 'Save',
        rateTitle: 'Convert $ to Credit (Rate)',
        markupTitle: 'Profit Margin Factor M (requires >1)',
        markupFactor: 'Hệ số M',
        minimumTitle: 'Minimum credit (credit)',
        changeReasonPlaceholder: 'Enter the reason for changing the payment',
        validation: {
          modelNameRequired: 'Please enter model name',
          providerRequired: 'Please select provider',
          typeRequired: 'Please select type',
          inputPriceRequired: 'Input price must be >= 0',
          outputPriceRequired: 'Output price must be >= 0',
          changeReasonRequired: 'Please enter change reason',
          rateBasicRequired: 'Basic credit must be > 0',
          rateAdvanceRequired: 'Advanced credit must be > 0',
          markupRequired: 'M factor must be greater than 1',
          minimumRequired: 'Minimum credit must be > 0',
        },
        rateModal: {
          title: 'Change USD to Credit Exchange Rate',
          description: 'Exchange rate of $1 to basic and advanced credits of the system',
          basicCredit: 'Basic Credit',
          advancedCredit: 'Advanced Credit',
        },
        markupModal: {
          title: 'Change Profit Margin Factor',
          description: 'Multiplication factor to calculate operating costs',
          markupFactor: 'Profit Margin Factor M (requires >1)',
          increasePercent: '=> Increase by {percent}% compared to original cost',
        },
        minimumModal: {
          title: 'Change Minimum Fee',
          description: 'Minimum credit fee when user performs any action',
          minimumCredit: 'Minimum Credit (credit)',
        },
        providers: {
          openai: 'OpenAI',
          anthropic: 'Anthropic',
          google: 'Google',
          azure: 'Azure',
        },
        creditTypes: {
          token: 'Token',
          request: 'Request',
          time: 'Time',
        },
      },
      transactions: {
        title: 'Transaction History',
        user: 'User',
        plan: 'Plan',
        amount: 'Amount',
        method: 'Method',
        status: 'Status',
        time: 'Time',
        actions: 'Actions',
        viewDetails: 'View Details',
        exportInvoice: 'Export Invoice',
        searchPlaceholder: 'User',
        planPlaceholder: 'Plan',
        statusPlaceholder: 'Status',
        dateRange: 'Select date range',
        success: 'Success',
        failed: 'Failed',
        processing: 'Processing',
        creditCard: 'Credit Card',
        bankTransfer: 'Bank Transfer',
        ewallet: 'E-wallet',
        free: 'Free',
        exportExcel: 'Export Excel',
      },
    },
    writer: 'Writer',
    writerUpdate: 'Bài viết',
    writerTemplates: 'Template Library',
    whiteboard: 'Whiteboard',
    classroom: 'Classroom',
    classroomDetail: 'Classroom Detail',
    classroomDetailSubject: 'Learning Space',
    classroomUploadDocument: 'Document',
    classroomCreatePractice: 'Practice',
    classroomCreateFlashcard: 'Flashcard',
    classroomCreateExercise: 'Exercise',
    classroomPracticeExercise: 'Practice Exercise',
    classroomExerciseDetail: 'Exercise Detail',
    classroomFlashcardPractice: 'Flashcard Practice',
    classroomExamPaper: 'Library',
    classroomQuestionBank: 'Question Bank',
    classroomCreateExamPaper: 'Create Exam Paper',
    classroomConfigureScore: 'Configure Score',
    classroomList: 'Classrooms',
    classroomQuestionLibrary: 'Question Bank',
    classroomLearningResources: 'Learning Resources',
    classroomTeachBoard: 'Learning Started',
    classroomLearningHub: 'Learning Hub',
    startLesson: 'Start Lesson',
    classAI: 'AI in Classroom',
    classroomSpace: 'Learning Spaces',
    learningAssistant: 'Learning Assistant',
    classMembers: 'Class Members',
    teaching: 'Teaching',
    moreTools: 'More Tools',
    backgroundRemoval: 'Background Removal',
    removeText: 'Remove Text',
    inpaint: 'Inpaint',
    upscaleImage: 'Upscale Image',
    removeObject: 'Remove Object',
    changeBackground: 'Change Background',
    aiTranslator: 'AI Translator',
    imageTranslator: 'Image Translator',
    videoSummarizer: 'Video Summarizer',
    chatPdf: 'Chat PDF',
    mindmap: 'Mindmap',
    detailMindmap: 'Mindmap Detail',
    deepResearch: 'Deep Research',
    agentPdf: 'Chat PDF',
    agentPdfDetail: 'Chat PDF Detail',
    imageToWord: 'Image To Word',
    pdfToWord: 'PDF To Word',
    transactionUpload: 'Upload file',
    uploadWorksheet: 'Upload Worksheet',
    group: {
      agent: 'Agent',
      community: 'Community',
      image: 'Image',
      video: 'Video',
      document: 'Document',
      text: 'Text',
      audio: 'Audio',
      other: 'OTHER',
      tool: 'Tool',
      school: 'School',
      ocr: 'OCR',
      store: 'Store',
      systemSettings: 'SYSTEM SETTINGS',
      agentStore: 'AGENT & STORE',
    },
    creditAndUsers: 'Credit & Users',
    approval: 'approval',
    workspace: 'Workspace',
    image: 'image',
    notifications: 'notifications',
    bookSetup: 'Book Setup',
    uploadManagement: 'Upload Management',
    writerUploadTemplate: 'Upload template',
    writerBlankTemplate: 'Create blank template',
    writerEditTemplate: 'Edit template',
    writerLibrary: 'Writer library',
    writerTemplateSelector: 'Template Selector',
    writerContentLibrary: 'Content Library',
    writerBlankContent: 'Create blank content',
    writerEditContent: 'Edit content',
    school: 'School Management',
    classroomResult: 'Learning Outcomes',
    classroomStudentDetail: 'Student Detail',
    viewEducationalResource: 'View Educational Resource',
    classroomExerciseProgressDetail: 'Exercise Progress Detail',
    classroomUploadLessonPlanTool: 'Upload Lesson Plan Tool',
    classroomUploadTeachingPlanTool: 'Upload Teaching Plan Tool',
    classroomUploadLessonPlan: 'Upload Lesson Plan',
    classroomUploadTeachingPlan: 'Upload Teaching Plan',
    classroomStudentExerciseResult: 'Exercise Result',
    classroomExamProgressDetail: 'Exam Progress',
    classroomStudentExamResult: 'Exam Result',
    classroomExamManage: 'Assessment',
    classroomExam: 'Schedule',
    classroomExamStudents: 'Student List',
    classroomExamGrade: 'Grade Exam',
    classroomExamDetail: 'Exam Detail',
    classroomDocument: 'Learning Materials',
    classroomFlashcard: 'Flashcards',
    // classroomPractice: 'Practice',
    classroomExercise: 'Exercises',
    classroomAssignments: 'Assignments',
    subjectMore: 'More',
    classroomNoSubject: 'No subject',
    classroomNoSubjectDescription: 'Currently, there are no subjects in this class. Please contact the teacher for support.',
    classroomAssessments: 'Assessments',
    classroomLearningOutcomes: 'Learning Outcomes',
  },
  learningResources: {
    title: 'Learning Resources',
    searchPlaceholder: 'Search learning resources',
    tabs: {
      teachingDocuments: 'Teaching Documents',
      worksheets: 'Worksheets',
      slides: 'Slides',
    },
    teachingDocuments: {
      featured: 'Featured Teaching Documents',
      all: 'All Teaching Documents',
      noData: 'No teaching documents available',
    },
    worksheets: {
      featured: 'Featured Worksheets',
      all: 'All Worksheets',
      noData: 'No worksheets available',
    },
    slides: {
      featured: 'Featured Slides',
      all: 'All Slides',
      noData: 'No slides available',
    },
    loading: 'Loading...',
    hot: 'Hot',
  },
  agent: {
    search: 'Find assistant',
    create: 'Create assistant',
    monitor: 'Monitor',
    historyChat: 'Your recent chats',
    searchChat: 'Find chat',
    edit: 'Edit assistant',
    view: 'View assistant',
    urlShare: 'URL Share',
    delete: 'Delete assistant',
    deleteMessage: 'Do you want to delete this assistant?',
    deleteSuccess: 'Delete assistant success',
    deleteError: 'Delete assistant error',
    publish: 'Publish',
    publishMessage: 'Are you sure you want to publish this assistant?',
    publishSuccess: 'Publish assistant success',
    publishError: 'Publish assistant error',
    unpublish: 'Unpublish',
    unpublishMessage: 'Are you sure you want to unpublish this assistant?',
    unpublishSuccess: 'Unpublish assistant success',
    unpublishError: 'Unpublish assistant error',
    addAgent: {
      title: 'Create assistant',
      quickAddAgent: 'Quick Add Agent',
      name: 'Name assistant',
      welcomeMessage: 'Welcome message',
      descriptionMessage: 'Configure the welcome message and suggested messages for your assistant',
      suggestedMessages: 'Suggested messages',
      messagePlaceholder: 'Message placeholder',
      save: 'Save',
      addFolder: 'Add folder',
      folder: 'Folder',
      position: 'Position',
      language: 'Language',
      description: 'Description',
      instruction: 'Instruction',
      instructionDescription: 'Instruction of assistant',
      avatar: 'Avatar',
      generalInformation: 'General information',
      agentModel: 'Agent model',
      message: 'Message',
      addMessage: 'Add message',
      askAgent: 'Ask your Agent',
      addSuccess: 'Add assistant success',
      modelParam: 'Response style',
      selectModel: 'Select model',
      modelDescription: 'Description',
      modelPrice: 'Price',
      addError: 'Add assistant failed',
      addRequired: 'Please enter all required fields!',
      tab: {
        instruction: 'General information',
        interface: 'Interface',
        tasks: 'Tasks',
        publish: 'Publish',
        message: 'Message',
      },
      validation: {
        nameRequired: 'Please enter your name!',
        folderRequired: 'Please enter your folder!',
        positionRequired: 'Please enter your position!',
        languageRequired: 'Please enter your language!',
        descriptionRequired: 'Please enter your description!',
        instructionRequired: 'Please enter your instruction!',
        modelParamRequired: 'Please enter your how to response!',
        modelRequired: 'Please select your model!',
      },
      modal: {
        changeAvatar: 'Change Avatar',
        pickAvatar: 'Pick Avatar',
        uploadAvatar: 'Upload',
        categories: {
          animal: 'Animals',
          human: 'Humans',
          robot: 'Robots',
          sticker: 'Stickers',
        },
      },
      modelParamOptions: {
        exactly: 'Exactly',
        balanced: 'Balanced',
        creative: 'Creative',
        myPreset: 'Customs',
        temperature: 'Creativity',
        topP: 'Idea diversity',
        presencePenalty: 'Repetition control',
        frequencyPenalty: 'Encourage novelty',
        maxTokens: 'Response length limit',
        tooltip: {
          temperature: 'Controls randomness. Lower temperature results in less random completions. Higher temperature means more randomness.',
          top_p: 'Controls diversity via nucleus sampling: e.g. 0.5 means considering the top 50% probable options.',
          presence_penalty: 'Applies a penalty to the log-probability of tokens already present in the text to encourage new words.',
          frequency_penalty: 'Applies a penalty to the log-probability of tokens appearing multiple times to reduce repetition.',
          max_tokens: 'Specifies the maximum length of generated tokens; increase to allow longer outputs.',
        },
      },
    },
    update: {
      features: 'Features',
      featuresDescription: 'Enhance web app user experience',
      vision: 'Vision',
      tool: 'Tool',
      memory: 'Memory',
      visionDescription: 'Ability to read and process images',
      toolDescription: 'Enable tool processing capabilities.',
      memoryDescription: 'Enable memory processing capabilities.',
      document: 'Document',
      documentDescription: 'Ability to upload and process documents',
      chat: 'Chat',
      welcomeMessage: 'Welcome message',
      descriptionMessage: 'Configure the welcome message and suggested messages for your assistant',
      suggestedMessages: 'Suggested messages',
      messagePlaceholder: 'Input message',
      save: 'Save',
      addMessage: 'Add message',
      add: 'Add',
      message: 'Message',
      interface: 'Interface',
      tasks: 'Tasks',
      publish: 'Publish',
      agentInformation: 'Agent information',
      agentInformationSubtitle: 'Configure basic details and persona for your assistant',
      agentModel: 'Agent model',
      assistantModel: 'Assistant model',
      persona: 'Persona',
      position: 'Position',
      positionPlaceholder: 'Enter assistant position or role (e.g., Marketing Specialist, Data Analyst)',
      language: 'Language',
      description: 'Description',
      descriptionPlaceholder: 'Describe what your assistant does and its main purpose',
      instruction: 'Instruction',
      instructionDescription: 'Agent Instructions & Behavior',
      instructionSubtitle: 'Define your assistant\'s personality, tone, and response style',
      instructionPlaceholder: 'Example:\n\nYou are a professional marketing expert with over 10 years of experience.\n\nYour role:\n- Provide marketing strategy consulting\n- Analyze market and competitors\n- Suggest creative solutions\n\nCommunication style:\n- Friendly but professional\n- Give specific, actionable advice\n- Use real examples for illustration\n\nAlways ask for more information if the question is unclear.',
      avatar: 'Avatar',
      generalInformation: 'General information',
      agentName: 'Agent name',
      agentNamePlaceholder: 'Enter a memorable name for your assistant',
      folder: 'Folder',
      selectFolder: 'Select a folder',
      file: 'File',
      addFile: 'Add file',
      knowledge: 'Knowledge',
      payment: 'Payment',
      addKnowledge: 'Add knowledge',
      descriptionAddKnowledge: 'Add knowledge bases to enhance capabilities',
      searchKnowledge: 'Search knowledge',
      noKnowledgeAvailable: 'No knowledge available',
      noTaskAvailable: 'No task available',
      itemSelected: 'Items selected',
      total: 'Total',
      paymentMethod: 'Payment method',
      paymentValue: 'Payment value',
      paymentCurrency: 'Payment currency',
      addPaymentMethod: 'Add payment method',
      paymentMethodDescription: 'Display when user selects the following values: Hourly, Monthly, Sell assistant',
      paymentValueDescription: 'Allow input numbers at the input field',
      paymentCurrencyDescription: 'Allow select values: VND, USD',
      expiredDate: 'Expired Date Link',
      colorTheme: 'Color Theme',
      sharedLink: 'Shared Link',
      sharedLinkSubtitle: 'Create a share link for users to access your assistant',
      openLink: 'Open Link',
      selectType: 'Select type',
      avatarApp: 'Avatar App',
      avatarUploaded: 'Avatar uploaded',
      uploadAvatar: 'Upload avatar',
      configShareLink: 'Config Share Link',
      configShareLinkSubtitle: 'Configure your share link',
      nameApp: 'Name App',
      descriptionApp: 'Description',
      copyright: 'Copyright',
      type: 'Type Link Share',
      copyrightBy: 'Copyright By',
      fileDescription: 'Allow upload image file',
      updateSuccess: 'Update assistant success',
      modelConfiguration: 'Model Configuration',
      modelConfigurationSubtitle: 'Configure your assistant\'s model',
      settings: 'Current Settings',
      modelParam: 'How to response',
      selectModel: 'Select model',
      modelDescription: 'Description',
      modelPrice: 'Price',
      skill: 'Skill',
      descriptionSkill: 'Configure specialized skills to expand assistant abilities.',
      addSkill: 'Add skill',
      descriptionAddSkill: 'Select skills to enhance your assistant\'s capabilities',
      searchSkill: 'Search skill',
      descriptionKnowledge: 'Manage knowledge bases to enhance assistant capabilities.',
      emptyKnowledge: 'Add the first piece of knowledge for the assistant.',
      task: 'Task',
      descriptionTask: 'Set up tasks so the assistant can perform them more quickly.',
      addTask: 'Add task',
      addTaskDescription: 'Add tasks for the assistant to perform quickly.',
      editTask: 'Edit task',
      emptyTask: 'Add the first task for the assistant.',
      chatAppearance: {
        tab: {
          chatAppearance: 'Chat Appearance',
          theme: 'Themes',
          custom: 'Custom',
        },
        saveChanges: 'Save changes',
        saveChangesSuccess: 'Save changes successfully',
        title: 'Chat Appearance Settings',
        description: 'Customize your chat interface with themes and colors',
        chooseTheme: 'Choose a Theme',
        cool: 'Cool',
        background: 'Background',
        customColors: 'Custom Colors',
        color: 'Color',
        image: 'Image',
        uploadBackgroundImage: 'Upload Background Image',
        textColor: 'Text Color',
        chatBubbleColors: 'Chat Bubble Colors',
        gradientColor1: 'First Color',
        gradientColor2: 'Second Color',
        userMessage: 'User Message',
        aiMessage: 'AI Message',
        livePreview: 'Live Preview',
        preview: 'Preview',
        seeHowYourChatWillLook: 'See how your chat will look',
        desktop: 'Desktop',
        mobile: 'Mobile',
        aiAssistant: 'AI Assistant',
        onlineNow: 'Online now',
        heyThere: 'Hey there!',
        coolDesign: 'Cool design!',
        youCanSeeAllTheDesignChangesHereInRealTime: 'You can see all the design changes here in real-time!',
        typeYourMessageHere: 'Type your message here...',
        aiAssistantMobile: 'AI Assistant',
        onlineNowMobile: 'Online',
        unsavedChangesWarning: 'You have unsaved changes in Chat Appearance. Please save your changes first.',
        unsavedChangesTitle: 'Unsaved Changes',
        unsavedChangesContent: 'You have unsaved changes in Chat Appearance settings. What would you like to do?',
        saveBeforeMainSave: 'You have unsaved changes in Chat Appearance. Do you want to save them before proceeding?',
        saveAndContinue: 'Save and continue',
        discardChanges: 'Discard changes',
        discardAndContinue: 'Discard and continue',
      },
      tab: {
        instruction: 'General information',
        interface: 'Interface',
        tasks: 'Tasks',
        publish: 'Publish',
        message: 'Message',
        file: 'File',
        author: 'Author',
        knowledge: 'Knowledge',
        payment: 'Payment',
        shareLink: 'Share link',
        chatAppearance: 'Chat Appearance',
        knowledgeSkill: 'Knowledge & Skill',
        task: 'Task',
      },
      validation: {
        nameRequired: 'Please enter your name!',
        folderRequired: 'Please enter your folder!',
        positionRequired: 'Please enter your position!',
        languageRequired: 'Please enter your language!',
        descriptionRequired: 'Please enter your description!',
        instructionRequired: 'Please enter your instruction!',
        modelParamRequired: 'Please enter your how to response!',
        modelRequired: 'Please select your model!',
        expiration_dateRequired: 'Expiration date cannot be empty.',
      },
      modal: {
        pickAvatar: 'Pick avatar',
        uploadAvatar: 'Upload avatar',
        changeAvatar: 'Change avatar',
      },
      modelParamOptions: {
        exactly: 'Exactly',
        balanced: 'Balanced',
        creative: 'Creative',
        myPreset: 'My Preset',
        temperature: 'Creativity',
        topP: 'Idea diversity',
        presencePenalty: 'Repetition control',
        frequencyPenalty: 'Encourage novelty',
        maxTokens: 'Response length limit',
        tooltip: {
          temperature: 'Increase for more expressive responses, decrease for more instruction-following behavior.',
          top_p: 'Increase to make responses more diverse.',
          presence_penalty: 'Increase to reduce repeated words or sentences.',
          frequency_penalty: 'Increase to encourage the model to generate newer or less common content.',
          max_tokens: 'Increase to allow longer and more detailed responses.',
        },
      },
      coAuthor: {
        title: 'Co-author',
        descriptionAuthor: 'Configure co-authors for your assistant',
        name: 'Name',
        position: 'Position',
        description: 'Description',
        avatar: 'Avatar',
        addCoAuthor: 'Add co-author',
        namePlaceholder: 'Enter name',
        positionPlaceholder: 'Enter position',
        descriptionPlaceholder: 'Enter description',
        coAuthorInfo: 'Co-author information',
        removeCoAuthor: 'Remove co-author',
        removeCoAuthorContent: 'Are you sure you want to remove this co-author?',
        removeCoAuthorSuccess: 'Remove co-author success',
        removeCoAuthorError: 'Remove co-author error',
        validation: {
          name: 'Please enter your name!',
          position: 'Please enter your position!',
          description: 'Please enter your description!',
          avatar: 'Please enter your avatar!',
        },
      },
    },
    configuration: {
      enterChat: 'Enter chat',
      tab: {
        instruction: 'Instruction',
        interface: 'Interface',
        tasks: 'Tasks',
        publish: 'Publish',
      },
      interface: {
        title: 'Chat Interface',
        welcomeMessage: {
          title: 'Welcome Message',
          preview: 'Preview',
          edit: 'Edit',
          placeholder: 'Enter welcome message',
          description: 'Welcome message will be displayed when users start a new conversation',
        },
        suggestedMessages: {
          title: 'Suggested Messages',
          add: 'Add message',
          placeholder: 'Enter suggested message',
          description: 'Suggested messages will be displayed to users to help them start conversations more easily',
        },
        messagePlaceholder: {
          title: 'Message Placeholder',
          placeholder: 'Enter placeholder',
          description: 'Placeholder will be displayed in the message input box',
          characterCount: '{count}/50',
        },
        save: 'Save',
      },
      instruction: {
        // Section Headers
        agentInformation: 'Agent information',
        brandInformation: 'Brand information',
        avatar: 'Avatar',
        persona: 'Persona',
        instruction: 'Instruction',

        // Form Labels
        position: 'Position',
        jobBrief: 'Job brief',
        language: 'Language',
        brand: 'Brand',
        businessType: 'Business type',
        location: 'Location',
        description: 'Description',
        name: 'Name',
        gender: 'Gender',
        department: 'Department',
        agentModel: 'Agent model',

        // Buttons & UI Text
        regenerate: 'Re-generate',
        preview: 'Preview',
        edit: 'Edit',
        save: 'Save',

        // Instruction Section
        systemPrompt: 'System prompt',
        instructionDescription: 'The instruction of assistant is generated based on assistant and brand information. Tips: type @agent_name to mention your assistant dynamically.',

        // Fixed content
        itManagerTitle: 'Quản lý CNTT',
        itManagerDescription: 'Giám sát việc phát triển, triển khai và duy trì các hệ thống và cơ sở hạ tầng CNTT.',

        // Select Options
        male: 'Male',
        female: 'Female',
        informationTechnology: 'Information Technology',
        marketing: 'Marketing',
        sales: 'Sales',
        english: 'English',
        vietnam: 'Vietnam',
      },
    },
    rateAgent: {
      title: 'Rating',
      description: 'Please share your thoughts about this Agent...',
      ratingLabel: 'Rate assistant',
      commentLabel: 'Write review',
      commentPlaceholder: 'Share your thoughts about this Agent! Did it meet your expectations?',
      cancel: 'Cancel',
      submit: 'Submit',
      validation: {
        ratingRequired: 'Rating is required',
        commentRequired: 'Comment is required',
      },
      reviewSuccess: 'Review assistant success',
      daysAgo: 'days ago',
      hoursAgo: 'hours ago',
      minutesAgo: 'minutes ago',
      filterByRating: 'Filter by rating',
    },
    marketPlace: {
      backToMarket: 'Agent stores',
      publishAgent: 'Publish Agent',
      featuredAgents: 'Featured Agents',
      allAgents: 'All Agents',
      searchPlaceholder: 'Search',
      uploadButton: 'Upload',
      areaFilter: 'Area',
      ratingFilter: 'Rating',
      paymentFilter: 'Payment',
      noAgent: 'No assistant',
      noExperience: 'No experience',
      priceFilter: 'Price',
      users: 'Users',
      rating: 'Rating',
      description: 'Description',
      position: 'Position',
      name: 'Name',
      workplace: 'Workplace',
      uploadToMarket: 'Upload to Market',
      uploadSuccess: 'Upload Success',
      uploadFailed: 'Upload Failed',
      confirmUpload: 'Are you sure you want to upload this assistant?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addToFolder: 'Add to Folder',
      free: 'Free',
      paid: 'Paid',
      author: 'Author',
      totalReviews: 'Total Reviews',
      writeReview: 'Write Review',
      yourAgent: 'Your Agent',
      totalUsage: 'times used',
      pushBackSuccess: 'Remove assistant from folder success',
      pushBackError: 'Remove assistant from folder error',
      sector: 'Sector',
      tabDetail: {
        overview: 'Overview',
        experience: 'Experience',
        attachments: 'Attachments',
        reviews: 'Reviews',
        author: 'Author',
      },
      // Tab
      tab: {
        discoverByCategory: 'Discover by category',
        educationalAssistant: 'Educational Assistant',
        lessonPlan: 'Lesson Plan',
        eLessonPlan: 'E-Lesson Plan',
        worksheet: 'Worksheet',
        video: 'Video',
        slide: 'Slide',
        image: 'Image',
      },
      educationalAssistant: {
        featured: 'Featured Educational Assistants',
        all: 'All Educational Assistants',
        noData: 'No educational assistants found',
        paid: 'Paid',
        free: 'Free',
      },
      lessonPlan: {
        featured: 'Featured Lesson Plans',
        all: 'All Lesson Plans',
        noData: 'No lesson plans found',
        paid: 'Paid',
        free: 'Free',
      },
      eLessonPlan: {
        featured: 'Featured E-Lesson Plans',
        all: 'All E-Lesson Plans',
        noData: 'No e-lesson plans found',
        paid: 'Paid',
        free: 'Free',
      },
      worksheet: {
        featured: 'Featured Worksheets',
        all: 'All Worksheets',
        noData: 'No worksheets found',
        paid: 'Paid',
        free: 'Free',
        weeks: 'WEEKS',
      },
      video: {
        featured: 'Featured Videos',
        all: 'All Videos',
        noData: 'No videos found',
        paid: 'Paid',
        free: 'Free',
        // Modal content
        videoInfo: 'Video Information',
        subject: 'Subject',
        status: 'Status',
        views: 'Views',
        rating: 'Rating',
        description: 'Description',
        author: 'Author',
        teacher: 'Teacher',
        addToClassroom: 'Add to Classroom',
        download: 'Download',
        videoNotAvailable: 'Video not available',
        yourBrowserNotSupport: 'Your browser does not support the video tag.',
        // Modal actions
        close: 'Close',
        play: 'Play',
        pause: 'Pause',
        downloadSuccess: 'Download successful!',
        downloadError: 'Error downloading video',
        addToClassroomSuccess: 'Add to classroom feature is under development',
      },
      slide: {
        featured: 'Featured Presentations',
        all: 'All Presentations',
        noData: 'No presentations found',
        paid: 'Paid',
        free: 'Free',
      },
      image: {
        featured: 'Featured Images',
        all: 'All Images',
        noData: 'No images found',
        paid: 'Paid',
        free: 'Free',
        // Modal content
        imageInfo: 'Image Information',
        status: 'Status',
        views: 'Views',
        description: 'Description',
        info: 'Image Information',
        resolution: 'Resolution',
        aspectRatio: 'Aspect Ratio',
        model: 'Model',
        createdAt: 'Created At',
        defaultDescription: 'An anime-style girl sitting on a train listening to music, and the camera has moved to the side angle',
        author: 'Author',
        teacher: 'Teacher',
        addToClassroom: 'Add to Classroom',
        download: 'Download',
        // Modal actions
        close: 'Close',
        downloadSuccess: 'Download successful!',
        downloadError: 'Error downloading image',
        addToClassroomSuccess: 'Add to classroom feature is under development',
      },
    },
    detail: {
      title: 'Author Details',
      overview: 'Overview',
      experience: 'Experience',
      attachments: 'Attachments',
      reviews: 'Reviews',
      mainFunctions: 'Main Functions',
      language: 'Language',
      model: 'Model',
      chatAgent: 'Start Chat',
      contactInfo: {
        title: 'Contact Information',
        email: 'Email',
        phone: 'Phone',
        workplace: 'Workplace',
      },
      workExperience: {
        title: 'Work Experience',
        company: 'Company',
        position: 'Position',
        period: 'Period',
        description: 'Description',
      },
      certificates: {
        title: 'Certificates & Qualifications',
        name: 'Certificate Name',
        issuer: 'Issued By',
        year: 'Year Issued',
        viewDocument: 'View Document',
      },
      reviewSection: {
        title: 'Reviews & Comments',
        totalReviews: 'Total Reviews',
        averageRating: 'Average Rating',
        writeReview: 'Write Review',
        rating: 'Rating',
        time: 'Time',
        comment: 'Comment',
      },
      attachmentSection: {
        title: 'Attachments',
        name: 'File Name',
        type: 'File Type',
      },
      coAuthorSection: {
        title: 'Co-Author',
        name: 'Name',
        position: 'Position',
        description: 'Description',
      },
      awards: {
        title: 'Awards',
        name: 'Award Name',
        issuer: 'Issued By',
        year: 'Year Issued',
        viewDocument: 'View Document',
      },
    },
    uploadAgent: {
      title: 'Upload Agent',
      tabTitle: 'Agent Management',
      uploadAgentWarning: 'Are you sure you want to upload this assistant?',
      noAgent: 'There are no agents',
      addToFolder: 'Add to folder',
      addToFolderSuccess: 'Add to folder success',
      addToFolderError: 'Add to folder error',
      buttonAddPlaceHolder: 'Select folder',
      tabs: {
        uploadAgent: 'Upload Agent',
        uploadAgentDescription: 'Upload your assistant to the market',
        uploadAgentButton: 'Upload',
        uploadedAgent: 'Uploaded Agent',
        uploadedAgentDescription: 'Uploaded assistant will be displayed in the market',
        uploadedAgentButton: 'View',
      },
      uploadAgentButton: 'Upload',
      uploadedAgentButton: 'View',
      editAgentButton: 'Edit',
      uploadDrawer: {
        overview: 'Overview',
        title: 'Upload Agent',
        description: 'Description of assistant',
        descriptionPlaceholder: 'Enter description of assistant',
        language: 'Language',
        model: 'Model',
        modelPlaceholder: 'Select model',
        experience: 'Experience',
        experiencePlaceholder: 'Enter experience',
        validation: {
          description: 'Description is required',
          language: 'Language is required',
          model: 'Model is required',
          experience: 'Experience is required',
        },
        success: 'Update assistant success',
        error: 'Update assistant error',
      },
      modal: {
        validation: {
          folderId: 'Folder is required',
        },
      },
    },
    languageOptions: {
      vietnamese: 'Vietnamese',
      english: 'English',
    },
  },
  chatAgent: {
    greetingTitle: 'Hello!',
    greetingIntroPrefix: 'I am',
    defaultWelcomeMessage: 'How can I help you today?',
    suggestionsTitle: 'Suggested Messages',
    orEnterQuestion: 'Or type your question below.',
    enterQuestion: 'Type your question or request below.',
  },
  slideGeneration: {
    title: 'Create Slides',
    description: 'Create professional presentations with AI — just describe your topic and let AI generate beautiful and structured slides!',
    quickSlideGeneration: {
      title: 'AI Slide Generation',
      promptPlaceholder: 'Describe your presentation topic...',
      promptRequired: 'Please enter a description for the slide',
      generateSlide: 'Generate Slide',
      dictate: 'Voice Input',
      generationStarted: 'Slide generation started!',
      slideCount: {
        title: 'Number of Slides',
      },
      language: {
        title: 'Language',
      },
    },
  },
  imageGeneration: {
    title: 'Image Generation',
    dropFilesHere: 'Drop files here',
    description: 'Express your thoughts through art—just share what\'s on your mind, and see your ideas transform into stunning images! For example, a lovely sunset over a serene lake.',
    exampleImages: 'Example Images',
    examplePrompts: 'Example Prompts',
    exploreIdeas: 'Explore these ideas to get started:',
    generate: 'Generate',
    generateImage: 'Generate Image',
    generateNewImage: 'Generate New Image',
    generateImageDescription: 'Generate image based on your prompt',
    generateImageButton: 'Generate',
    generateImagePlaceholder: 'Enter your prompt',
    generateImageError: 'Please enter your prompt!',
    generateImageSuccess: 'Generate image success',
    generatedImages: 'Generated Images',
    generating: 'Generating...',
    history: 'History',
    generateSettings: 'Generate Settings',
    regenerate: 'Regenerate',
    copyPrompt: 'Copy Prompt',
    usePrompt: 'Use Prompt',
    downloadImage: 'Download Image',
    deleteImage: 'Delete Image',
    deleteImageConfirm: 'Are you sure you want to delete this image?',
    deleteImageSuccess: 'Delete image success',
    shareImage: 'Share Image',
    pleaseWait: 'Please wait',
    generatingImage: 'Generating image...',
    imageDetails: 'Image Details',
    deleteMessage: 'Delete Message',
    requiresFileUpload: 'Image editing model requires you to upload at least one image.',
    // Quick Image Generation Component
    quickImageGeneration: {
      title: 'AI Image Generation',
      promptPlaceholder: 'Describe the image you want to create...',
      promptRequired: 'Please enter a description for the image',
      generateImage: 'Generate Image',
      artStyle: {
        title: 'Choose Art Style',
        cinematic: 'Cinematic',
        natural: 'Natural',
        cinematicTooltip: 'Cinematic style creates dramatic and surreal images',
        naturalTooltip: 'Natural style creates natural and less surreal images',
      },
      background: {
        title: 'Background',
        auto: 'Auto',
        opaque: 'Opaque',
        transparent: 'Transparent',
        autoTooltip: 'Auto background',
        opaqueTooltip: 'Opaque background',
        transparentTooltip: 'Transparent background',
      },
      aspectRatio: {
        title: 'Aspect Ratio',
      },
      negativePrompt: {
        title: 'Elements to Remove',
        placeholder: 'Enter elements to remove from the image',
      },
      numberOfImages: 'Number of images:',
      tools: {
        removeBackground: 'Remove Background',
        deleteObject: 'Delete Object',
        changeObject: 'Change Object',
        sharpen: 'Sharpen Image',
        scale: 'Scale Image',
      },
    },
    // Quick MindMap Component
    quickMindMap: {
      title: 'Create Mindmap',
      promptPlaceholder: 'Describe the topic to create a mind map...',
      promptRequired: 'Please enter a description for the mindmap',
      generateMindMap: 'Create Mindmap',
    },
    // AI Image Tool
    aiImageTool: 'AI Image Tool',
    aiImageToolTitle: 'Generate AI Image (UNI_IMAGE)',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe the image you want to generate...',
    negativePrompt: 'Negative Prompt',
    negativePromptPlaceholder: 'What you don\'t want...',
    style: 'Style',
    aspectRatio: 'Aspect Ratio',
    portrait: 'Portrait',
    square: 'Square',
    landscape: 'Landscape',
    deleteMessageConfirm: 'Are you sure you want to delete this message?',
    deleteMessageSuccess: 'Delete message success',
    deleteMessageError: 'Delete message error',
    poweredBy: 'Powered by',
    uploadImagesForEdit: 'Upload Images for Editing',
    uploadImages: 'Upload Images',
    clickOrDragToUpload: 'Click or drag files to upload',
    supportedFormats: 'PNG, JPG, WEBP up to 10MB',
    uploading: 'Uploading...',
    images: 'images',
    maximumImagesAllowed: 'Maximum 3 images allowed.',
    selectFilesToReplace: 'Select files to replace existing ones',
    clearAll: 'Clear All',
    addMoreImages: 'Add More Images',
    replaceImages: 'Replace Images',
    uploadedImages: 'Uploaded Images',
    removeImage: 'Remove Image',
    replaceImage: 'Replace Image',
    imageToImage: 'Image to Image',
    switchToImageEdit: 'Switch to Image Edit',
    popover: {
      title: 'Image Generation',
      description: 'Generate image based on your prompt',
      generate: 'Generate',
      cancel: 'Cancel',
      chooseArtStyle: 'Choose Art Style',
      vivid: 'Vivid',
      vividDescription: 'Creates hyper-real and dramatic images with vibrant colors and bold contrasts',
      natural: 'Natural',
      naturalDescription: 'Produces more natural, less hyper-real looking images with softer tones',
      aspectRatio: 'Aspect Ratio',
      numberOfImages: 'Number of Images',
      showExamplePrompts: 'Show Example Prompts',
      keepPrompt: 'Keep Prompt',
      optimizePrompt: 'Optimize Prompt',
      optimizePromptDescription: 'Optimize your prompt to get better results',
      optimizePromptButton: 'Optimize',
      optimizePromptSuccess: 'Optimize prompt success',
      optimizePromptError: 'Optimize prompt error',
      optimizePromptLoading: 'Optimizing your prompt...',
      optimizePromptRegenerate: 'Regenerate',
      optimizePromptCopy: 'Copy',
      optimizePromptCopySuccess: 'Copy prompt success',
      optimizePromptCopyError: 'Copy prompt error',
      optimizePromptCopyConfirm: 'Are you sure you want to copy this prompt?',
      optimizePromptCopyConfirmSuccess: 'Copy prompt success',
      optimizePromptCopyConfirmError: 'Copy prompt error',
      outputLanguage: 'Output Language',
      yourPrompt: 'Your Prompt',
      enterPromptToOptimize: 'Enter your prompt to optimize...',
      optimizePromptUse: 'Use',
      optimizedPrompt: 'Optimized Prompt',
      clear: 'Clear',
      optimizePromptWarning: 'Dall-E 2 may not support Vietnamese well, leading to sometimes incorrect results with the requested content. To get better results with Vietnamese, you should use Dall-E 3.',
      addMoreImages: 'Add More Images',
      // bg
      backgroundImage: 'Background Image',
      auto: 'Auto',
      autoDescription: 'Automatically choose the best background',
      opaque: 'Opaque',
      opaqueDescription: 'Solid background, no transparency',
      transparent: 'Transparent',
      transparentDescription: 'Transparent background',
      imageResolution: 'Image Resolution',
      imageResolutionPlaceholder: 'Select image resolution',
      // NS 1.1
      pages: 'Number of images',
      pagesDescription: 'Number of images generated',
      pagesPlaceholder: 'Select number of images',
      negativePrompt: 'Negative Prompt',
      negativePromptPlaceholder: 'Enter negative prompt, e.g. red, green, ...',
      pagesOptions: [
        {
          label: '1 image',
          value: 1,
        },
        {
          label: '2 images',
          value: 2,
        },
        {
          label: '4 images',
          value: 4,
        },
      ],
    },
    drawer: {
      title: 'History',
      prompt: 'Prompt',
      image: 'Image',
      artStyle: 'Art Style',
      aspectRatio: 'Aspect Ratio',
      numberOfImages: 'Number of Images',
      showExamplePrompts: 'Show Example Prompts',
      createdAt: 'Created At',
      noHistory: 'No history available',
      generationTime: 'Generation Time',
      delete: 'Delete',
      deleteSuccess: 'Delete image success',
      deleteError: 'Delete image error',
      usePrompt: 'Use Prompt',
      usePromptSuccess: 'Use prompt success',
      usePromptError: 'Use prompt error',
      usePromptConfirm: 'Are you sure you want to use this prompt?',
      usePromptConfirmSuccess: 'Use prompt success',
      usePromptConfirmError: 'Use prompt error',
      conversationName: 'Conversation Name',
      deleteConversation: 'Delete Conversation',
      deleteConversationConfirm: 'Are you sure you want to delete this conversation?',
      deleteConversationSuccess: 'Delete conversation success',
      deleteConversationError: 'Delete conversation error',
    },
    modal: {
      title: 'Image Details',
      prompt: 'Prompt',
      model: 'Model',
      size: 'Size',
      style: 'Style',
      generationTime: 'Generation Time',
      createdAt: 'Created',
      imageInfo: 'Image Info',
      download: 'Download',
      variations: 'Variations',
      negativePrompt: 'Negative Prompt',
      createdTime: 'Created Time',
      aspectRatio: 'Aspect Ratio',
      share: 'Share',
      findSimilarImage: 'Find Similar Image Prompt',
      findSimilarImageDescription: 'Find similar image based on text',
      describeYourImage: 'Describe your image',
      describeYourImagePlaceholder: 'Enter your image description. Example: A beautiful sunset over a serene lake.',
      searchingYourImage: 'Searching your image...',
      pleaseWait: 'Please wait',
      startSearching: 'Start searching',
      startSearchingDescription: 'Enter your image description and press the "Search" button',
      noResults: 'No results',
      noResultsDescription: 'No results found',
      noResultsButton: 'Try again',
      noResultsButtonDescription: 'Change the search keyword or describe the image more detail',
      result: 'Result',
      resultDescription: 'Result of your image',
      resultButton: 'View',
      resultButtonDescription: 'View the result of your image',
      similarityScore: 'Similarity Score',
      detail: 'Detail',
      clickImageToSeeDetail: 'Click image to see detail',
      totalFound: 'Total found',
      image: 'image',
      usePrompt: 'Use prompt',
    },
  },
  folder: {
    create: 'Create folder',
    folderName: 'Folder name',
    empty: 'Empty folder',
    titleDelete: 'Delete folder',
    contentDeleteTopLeft: 'By deleting this folder you will also delete ',
    contentDeleteTopRight: ' in it.',
    contentDeleteBottom: 'This action can\'t be undone, are you sure?',
  },
  settings: {
    title: 'Workspace Setup',
    orgUnit: 'Organization information',
    workspaceInfo: 'Workspace information',
    workspaceInfoTab: {
      title: 'Workspace Information',
      subTitle: 'General workspace information',
      workspaceName: 'Workspace name',
      workspaceNamePlaceholder: 'Enter workspace name',
      sector: 'Sector',
      description: 'Description',
      location: 'Location',
      url: 'Website, fanpage, ...',
      language: 'Language',
      updateSuccess: 'Update workspace information success',
      updateError: 'Update workspace information error',
      address: 'Address',
      addressPlaceholder: 'Enter address',
      educationalLevel: 'Educational level',
      educationalLevelPlaceholder: 'Select educational level',
      website: 'Website (optional)',
      websitePlaceholder: 'Enter website (optional)',
      gradingScale: 'Grading scale used',
      gradingScalePlaceholder: 'Select grading scale',
      userRole: 'Role in the unit',
      userRolePlaceholder: 'Enter role in the unit',
      urlDescription: 'Unit logo image',
      submitEdit: 'Edit information',
      submitSave: 'Save information',
      adminInfoTitle: 'workspace Manager Information',
      changeAdmin: 'Change Administrator',
      changeAdminDescription: 'Select a new administrator for the unit. <br/><strong>Note</strong>: After the transfer, the new administrator will have full control over the unit’s information.',
    },
    operationHistory: 'Operation History',
    operationHistoryTab: {
      title: 'Operation History',
      fromDate: 'From Date',
      toDate: 'To Date',
      refresh: 'Refresh',
      table: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        detail: 'Detail',
        time: 'Time',
      },
    },
    orgUnitEdit: 'Edit Organization',
    userManagement: 'User Management',
    userManagementTab: {
      member: 'Member',
      roleSetting: 'Role Setting',
      title: 'User Management',
      addUser: 'Add member',
      editUser: 'Edit member',
      deleteUser: 'Delete member',
      userName: 'User Name',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      action: 'Action',
      phone: 'Phone number',
      selectUsers: 'Select Users',
      emailInstructions: 'Enter multiple emails',
      addEmail: 'Add Email',
      howTypeEmailDescription: 'Enter multiple emails separated by spaces, commas, or new lines and press Enter',
      invalidEmail: 'Invalid email addresses',
      invalidEmailDescription: 'You can edit these email addresses after closing this notification.',
      invalidEmailModal: 'Invalid email addresses',
      duplicateEmails: 'Duplicate emails',
      duplicateEmailsDescription: 'These emails are already in the list',
      closeToFix: 'Close to fix',
      emailValidationIssues: 'Email validation issues',
      userList: 'User list',
      note: 'Note',
      selectRole: 'Select Role',
      createdBy: 'Created by',
      updateRole: 'Update user role',
      currentRole: 'Current role',
      newRole: 'New role',
      noRole: 'No role',
      userGroup: 'User Group',
      addUserGroup: 'Create user Group',
      editUserGroup: 'Edit user Group',
      setupUserGroup: 'Setup User Group',
      chooseSetupGroup: 'Choose group user',
      groupList: 'Group List',
      addUserGroupButton: 'Add User Group',
      nameGroup: 'Group name',
      nameGroupPlaceholder: 'Enter group name',
      titleDeleteGroup: 'Delete User Group',
      contentDeleteGroup: 'The system will delete this user group from the configuration list. All users currently in the group will be removed from the group, but their accounts will remain and can be assigned to other groups.',
      contentDeleteGroupConfirm: 'This action cannot be undone. Are you sure you want to continue?',
      requestJoin: 'Join request',
      requestTitle: 'Request to Join Organization',
      requestDescription: 'A teacher’s request to join your organization is awaiting your approval.<br/>You can update the list later in the User Management section.',
      approve: 'Approve',
      fullName: 'User name',
      titleApprove: 'Approve Organization Join Request',
      contentApprove: 'The user will be added to the organization and it will be visible in the system. Do you want to approve this request?',
      titleReject: 'Reject Organization Join Request',
      contentReject: 'The request to join the organization will be rejected. Do you want to reject this request?',
      emailUser: 'User email',
    },
    userManagementDropdown: {
      userInfo: 'User information',
      roleSetting: 'Role setting',
      securitySettings: 'Security settings',
      logout: 'Log Out',
      classInfo: 'Class Information',
      workspaceInfo: 'Workspace Information',
      setPassword: 'Set Password',
      systemSettings: 'System Settings',
      textbook: 'Textbook',
      teacherBook: 'Teacher Book',
      toolManagement: 'Tool Management',
      decreeCircular: 'Decree & Circular',
    },
    textbookDetail: {
      backToList: 'Back to list',
      grade: 'Grade',
      publishBook: 'Publish book',
      addBook: 'Add book',
      editBook: 'Edit book',
      searchPlaceholder: 'Search book, lesson...',
      unit: 'Unit',
      lesson: 'Lesson',
      chapter: 'Chapter',
      statusPublished: 'Published',
      statusProgress: 'Updating',
      addLesson: 'Add lesson',
      editLesson: 'Edit lesson',
      addChildLesson: 'Add child lesson',
      editChildLesson: 'Edit child lesson',
      deleteBook: 'Delete book',
      deleteLesson: 'Delete lesson',
      deleteChildLesson: 'Delete child lesson',
      deleteBookContent: 'When deleting the book set, all uploaded files including textbooks and teacher\'s books corresponding to the book set will be deleted.',
      deleteLessonContent: 'When deleting the lesson, all uploaded files including textbooks and teacher\'s books corresponding to the lesson will be deleted.',
      deleteChildLessonContent: 'When deleting the child lesson, all uploaded files including textbooks and teacher\'s books corresponding to the child lesson will be deleted.',
      deleteBookConfirm: 'Are you sure you want to delete the book set?',
      deleteLessonConfirm: 'Are you sure you want to delete the lesson?',
      deleteChildLessonConfirm: 'Are you sure you want to delete the child lesson?',
      addUnit: 'Add unit',
      viewPdf: 'View PDF',
      preview: 'Preview',
      edit: 'Edit',
      more: 'More',
      // Textbook List Table
      order: 'Order',
      name: 'Name',
      subject: 'Subject',
      textbookSet: 'Textbook Set',
      listGrades: 'List Grades',
      lastSystemPublish: 'Last System Publish',
      lastUpdate: 'Last Update',
      loading: 'Loading...',
      loadTextbookStructureError: 'Failed to load textbook structure',
      note: 'Note',
      lessonName: 'Lesson name',
      lessonNamePlaceholder: 'Enter lesson name',
      bookInfoMessage: 'The book set after adding will be displayed simultaneously in the textbook and teacher\'s book.',
      lessonInfoMessage: 'The lesson after adding will be displayed simultaneously in the textbook and teacher\'s book.',
      childLessonInfoMessage: 'The child lesson after adding will be displayed simultaneously in the textbook and teacher\'s book.',
      lessonNameRequired: 'Please enter lesson name',
      addAgentDocument: 'Add assistant document',
      addPdfDocument: 'Add PDF document',
      pdfOnly: 'Only PDF files are supported',
      missingGradeSubject: 'Missing grade or subject information',
      missingTextbookStructureId: 'Missing textbook structure information',
      creatingAgentDocument: 'Creating assistant document',
      pleaseWait: 'Please wait',
      addAgentDocumentSuccess: 'Add assistant document successfully',
      closingAutomatically: 'Closing automatically after 2 seconds',
      unpublishBook: 'Unpublish book',
      published: 'Published',
      notPublished: 'Not Published',
      publishSuccess: 'Publish book successfully',
      unpublishSuccess: 'Unpublish book successfully',
      noStructuresToPublish: 'No structures to publish',
      publishConfirmMessage: 'Apply the book sets of {subject} {grade} to the entire system. The application may affect textbook parameters of tools.',
      publishConfirmQuestion: 'Are you sure you want to publish the book set?',
      // Decree Circular
      missingGradeSubjectId: 'Missing grade_subject_id information',
      pleaseUploadFile: 'Please upload a file',
      fileNotUploadedSuccessfully: 'File has not been uploaded successfully',
      uploadDecreeCircularSuccess: 'Upload decree circular successfully',
      uploadingDecreeCircular: 'Uploading decree circular...',
      closingAutomaticallyDecreeCircular: 'Closing automatically...',
      viewDecreeCircularTooltip: 'View decree circular {name}',
      addDecreeCircularTooltip: 'Add decree circular',
      addFileViewPdf: 'Add file view (PDF)',
    },
    roleManagementTab: {
      title: 'Role Details',
      addRole: 'Add Role',
      editRole: 'Edit Role',
      deleteRole: 'Delete Role',
      roleName: 'Role Name',
      roleCode: 'Role Code',
      description: 'Description',
      permissions: 'Permissions',
      functionName: 'Function Name',
      functionCode: 'Function Code',
      status: 'Status',
      action: 'Action',
      active: 'Active',
      inactive: 'Inactive',
      createSuccess: 'Role created successfully',
      updateSuccess: 'Role updated successfully',
      deleteSuccess: 'Role deleted successfully',
      createError: 'Failed to create role',
      updateError: 'Failed to update role',
      deleteError: 'Failed to delete role',
      confirmDelete: 'Are you sure you want to delete this role?',
      selectFunctions: 'Select Functions',
      noFunctionsSelected: 'No functions selected',
      validation: {
        roleName: 'Please enter role name',
        roleCode: 'Please select role code',
        description: 'Please enter description',
        functions: 'Please select at least one function',
      },
      searchPlaceholder: 'Search role',
    },
    workspaceSettings: {
      title: 'Workspace Settings',
      workspaceInfo: 'Workspace information',
      workspaceApprove: 'Approve Workspace ',
      activity: 'Activity',
      notification: 'Notification Configuration',
      userManagement: 'User Management',
      roleManagement: 'Role Details',
      parameterConfiguration: 'Parameter Configuration',
      apiServiceConfiguration: 'Billing/Credit System Configuration',
      interface: 'Interface',
      pendingApproval: 'Pending Approval',
      approved: 'Approved',
      rejected: 'Rejected',
      revocationRequest: 'Revocation request',
      email: 'Email',
      phone: 'Phone',
      organizationName: 'Organization name',
      requestDate: 'Request date',
      approvalDate: 'Approval date',
      requestRevocationDate: 'Request revocation date',
      approve: 'Approve',
      titleApprove: 'Approve New Organization',
      contentApprove: 'The organization will be added and visible to users in the system. Do you want to approve this request?',
      titleReject: 'Reject New Organization',
      contentReject: 'The registration request for this organization will be rejected. Do you want to cancel this request?',
      imageApprove: 'Approve image',
      aiModel: 'AI Models',
      systemSettings: 'System Settings',
      notificationConfig: {
        columns: {
          id: 'ID',
          featureCluster: 'Feature Cluster',
          displayType: 'Display type',
          channel: 'Channel',
          notificationName: 'Notification Name',
          eventType: 'Event type',
          eventKey: 'Event key',
          target: 'Target',
          effectiveTime: 'Effective Time',
          status: 'Status',
          lastUpdated: 'Last Updated',
          actions: 'Actions',
        },
        filters: {
          featureCluster: 'Feature Cluster',
          displayType: 'Display type',
          eventType: 'Event type',
          status: 'Status',
          filter: 'Filter',
          apply: 'Apply',
          clear: 'Clear filter',
        },
        featureClusters: {
          system: 'System',
          credit: 'Credit',
          lesson: 'Lesson',
          test: 'Test',
          member: 'Member',
        },
        displayTypes: {
          banner: 'Banner',
          notiBell: 'Noti-bell',
        },
        eventTypes: {
          autoScheduleBased: 'Auto - Schedule based',
          manualOnLogin: 'Manual – On login',
          autoEventBased: 'Auto - Event based',
        },
        statuses: {
          active: 'Active',
          waiting: 'Waiting',
          expired: 'Expired',
          paused: 'Paused',
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete',
          addBanner: 'Add Banner',
          addNotiBell: 'Add Noti-bell',
          addNew: 'Add New',
          deleteSuccess: 'Delete banner notification successfully',
          deleteError: 'Failed to delete banner notification',
          deleteConfirm: 'Are you sure you want to delete this banner notification?',
        },
        messages: {
          errorLoading: 'An error occurred while loading data',
          realtime: 'Realtime',
        },
        bannerForm: {
          title: {
            create: 'Banner Notification',
            edit: 'Edit Banner Notification',
          },
          fields: {
            id: 'ID',
            featureCluster: 'Feature Cluster',
            channel: 'Channel',
            notificationType: 'Notification Type',
            notificationName: 'Notification Name',
            eventType: 'Event type',
            reDisplayAfter: 'Re-display banner after',
            targetUsers: 'Target Audience',
            workspaces: 'List of approved workspaces',
            startDate: 'Start Date',
            endDate: 'End Date',
            redirectUrl: 'Redirect',
            image: 'Attachment',
            attach: 'Attachment',
            status: 'Status',
          },
          placeholders: {
            featureCluster: 'Select feature cluster',
            channel: 'Select channel',
            notificationType: 'Select notification type',
            notificationName: 'Enter notification name',
            reDisplayAfter: 'Select re-display time',
            targetUsers: 'Select target audience',
            workspaces: 'Select workspace',
            startDate: 'Select start date',
            endDate: 'Select end date',
            redirectUrl: 'Enter redirect URL',
            status: 'Select status',
          },
          reDisplayAfter: {
            'nextLogin': 'Next login',
            '1day': '1 day',
            '3days': '3 days',
            '7days': '7 days',
            'noRedisplay': 'Do not re-display during campaign period',
          },
          targetUsers: {
            all: 'All',
            admin: 'Admin',
            teacher: 'Teacher',
            student: 'Student',
          },
          validation: {
            featureCluster: 'Please select feature cluster',
            channel: 'Please select channel',
            notificationType: 'Please select notification type',
            notificationName: 'Please enter notification name',
            targetUsers: 'Please select at least one target audience',
            startDate: 'Please select start date',
            endDate: 'Please select end date',
            dateRange: 'Please select date range',
            endDateAfterStartDate: 'End date must be after start date',
            image: 'Please attach banner image',
          },
          actions: {
            create: 'Create',
            uploadImage: 'Upload Image',
          },
          messages: {
            createSuccess: 'Banner created successfully',
            createError: 'Failed to create banner',
            updateSuccess: 'Banner updated successfully',
            updateError: 'Failed to update banner',
            submitError: 'An error occurred while submitting form',
            loadError: 'An error occurred while loading banner information',
            imageUploadSuccess: 'Image uploaded successfully',
            imageUploadError: 'Failed to upload image',
            invalidImageType: 'Only image files are accepted (JPEG, PNG, GIF, WebP)',
            imageTooLarge: 'File size must not exceed 10MB',
          },
        },
        bellForm: {
          title: {
            create: 'Notification Bell',
            edit: 'Edit Notification Bell',
          },
          fields: {
            id: 'ID',
            featureCluster: 'Feature Cluster',
            channel: 'Channel',
            notificationType: 'Notification Type',
            notificationName: 'Notification Name',
            eventType: 'Event type',
            eventKey: 'Event key',
            sendTiming: 'Send timing',
            groupWindow: 'Aggregate notifications within',
            scheduleType: 'Schedule type',
            bannerId: 'Banner ID',
            deadline: 'Deadline',
            messageVi: 'Message (Vietnamese)',
            messageEn: 'Message (English)',
            redirect: 'Redirect',
            targetUsers: 'Target Audience',
            workspaces: 'List of approved workspaces',
            status: 'Status',
            startDate: 'Start Date',
            endDate: 'End Date',
          },
          placeholders: {
            featureCluster: 'Select feature cluster',
            channel: 'Select channel',
            notificationType: 'Select notification type',
            notificationName: 'Enter notification name',
            eventKey: 'Enter event key to determine when event occurs',
            sendTiming: 'Select send timing',
            groupWindow: 'Select aggregation window',
            scheduleType: 'Select schedule type',
            bannerId: 'Select banner ID',
            deadline: 'Select deadline',
            messageVi: 'Enter Vietnamese message',
            messageEn: 'Enter English message',
            redirect: 'Enter redirect URL',
            targetUsers: 'Select target audience',
            workspaces: 'Select workspace',
            status: 'Select status',
            startDate: 'Select start date',
            endDate: 'Select end date',
          },
          validation: {
            featureCluster: 'Please select feature cluster',
            channel: 'Please select channel',
            notificationType: 'Please select notification type',
            notificationName: 'Please enter notification name',
            eventType: 'Please select event type',
            eventKey: 'Please enter event key',
            sendTiming: 'Please select send timing',
            groupWindow: 'Please select aggregation window',
            scheduleType: 'Please select schedule type',
            bannerId: 'Please select banner ID',
            deadline: 'Please select deadline',
            messageVi: 'Please enter Vietnamese message',
            messageEn: 'Please enter English message',
            targetUsers: 'Please select at least one target audience',
          },
          actions: {
            create: 'Create',
          },
          messages: {
            createSuccess: 'Notification bell created successfully',
            createError: 'Failed to create notification bell',
            updateSuccess: 'Notification bell updated successfully',
            updateError: 'Failed to update notification bell',
            loadError: 'An error occurred while loading notification bell information',
          },
        },
      },
    },
    aiModel: {
      title: 'AI Models',
      editTitle: 'Edit model',
      addTitle: 'Add model',
      logoCode: 'Logo code',
      modelCode: 'Model code',
      modelName: 'Model name',
      description: 'Description',
      provider: 'Provider',
      type: 'Type',
      creditCost: 'Credit cost',
      status: 'Status',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      typeBasic: 'Basic',
      typeAdvanced: 'Advanced',
      providerAll: 'All',
    },
    systemSettings: {
      creditBonus: 'Credit Bonus',
      systemUsers: 'System Users',
      baseCredit: 'Basic Credit',
      baseCreditPlaceholder: 'Enter basic credit',
      advanceCredit: 'Advanced Credit',
      advanceCreditPlaceholder: 'Enter advanced credit',
      addUser: 'Add User',
      bulkEditCredit: 'Bulk edit credits',
      editCreditMultipleUsers: 'Multiple users',
      editCreditMultipleUsersTitle: 'Bulk edit credits multiple users',
      editCreditByWorkspace: 'By workspace',
      editCreditByWorkspaceTitle: 'Bulk edit credits by workspace',
      editCredit: 'Edit credit',
      addUserSuccess: 'User added successfully',
      addUserFail: 'Add user failed',
      titleDelete: 'Delete user',
      contentDelete: 'This user will be permanently deleted and cannot be undone. Are you sure you want to proceed?',
      deleteUserSuccess: 'User deleted successfully',
      deleteUserFail: 'Failed to delete user',
      updateUserSuccess: 'User updated successfully',
      updateUserFail: 'Failed to update user',
      emailUser: 'Email user',
      emailUserPlaceholder: 'Choose email user',
    },
  },
  auth: {
    title: 'Assemble your AI squad',
    signup_google: 'Sign up with Google',
    login_google: 'Log in with Google',
    continue_google: 'Continue with Google',
    or: 'Or',
    name: 'Name',
    account: 'Account',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    password: 'Password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    confirm_new_password: 'Confirm new password',
    agree_terms: 'By registration, you agree to our terms and conditions',
    signup: 'Sign up',
    have_account: 'You already have an account?',
    no_account: 'You don\'t have an account?',
    login: 'Log in',
    forgot_password: 'Forgot password',
    reset_password: 'Reset Password',
    recover_password: 'Recover password',
    submit: 'Submit',
    registerAccount: 'Create an account',
    firstName: 'First Name',
    lastName: 'Last Name',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    verifyEmailDescription: 'We’ve sent a verification code to your email.<br/>Please check your <strong>inbox</strong> or <strong>spam </strong> folder, then enter the code below to get started.',
    verifyEmailDescriptionStudent: 'We’ve sent a verification code to your email.<br/>Please check your <strong>inbox</strong> or <strong>spam </strong> folder, then enter the code below to get started.',
    verifyCodePlaceholder: 'Enter verification code',
    getStarted: 'Get Started now',
    next: 'Next',
    continue: 'Continue',
    useNextSchoolTitle: 'Choose how you want to get started with NextSchool',
    useNextSchoolDescription: 'NextSchool can be used by your school, or you can use it independently.',
    individual: 'Individual',
    individualDescription: 'Create your own classes and lessons. Use NextSchool flexibly and independently.',
    organization: 'School',
    organizationDescription: 'You will be assigned to classes by the Principal or Vice Principal.',
    chooseOrganization: 'Select a school',
    chooseOrganizationJoin: 'Select a school to join',
    addOrganization: 'Add a new school',
    startClass: 'Get started with your first class',
    start: 'Get started',
    organizationNewTitle: 'Register your school',
    organizationNewDescription: 'After you submit the request, the system will send your information to NextSchool for approval. Once your organization is verified, you’ll receive an email to complete registration and start using the system.',
    organizationName: 'School name',
    organizationNamePlaceholder: 'Enter school name',
    organizationPhone: 'Phone number',
    organizationPhonePlaceholder: 'Enter phone number',
    submitRegistrationRequest: 'Send request',
    submitRegistrationRequestSuccess: 'School registration successful',
    registrationRequestTitle: 'NextSchool has received your school registration request',
    registrationRequestDescription: 'Once your school is approved, you’ll receive an email to complete registration and start using the system.',
    startTrial: 'Get started now',
    cancelBack: 'Cancel registration request and return',
    cancelJoinBack: 'Cancel request and return',
    registrationFail: 'School registration unsuccessful',
    registrationFailTitle: 'Your organization registration request was not approved based on the provided information.',
    registrationFailDescription: 'You can switch to your personal space to continue using NextSchool, or contact NextSchool’s support team for assistance.',
    registrationUnitSuccess: 'School registration successful',
    registrationUnitSuccessTitle: 'Your school has been approved and successfully registered on NextSchool.',
    registrationUnitSuccessDescription: 'You now have full access to all NextSchool features.',
    createPersonalSpace: 'Create your own class',
    continueGoogleTitle: 'This email is already associated with a Google login.',
    continueGoogleDescription: 'Your account already exists. Please log in with Google to continue. If you need to use a password, you can add one after logging in.',
    continueGoogleDescriptionStudent: 'Your account already exists. Please log in with Google to continue. If you need to use a password, you can add one after logging in.',
    emailRestoreDescription: 'We’ll send a verification code to your email. Please enter the email address you want to recover your password for.',
    emailRestoreDescriptionStudent: 'We’ll send a verification code to your email. Please enter the email address you want to recover your password for.',
    getVerificationCode: 'Send verification code',
    emailRestorePlaceholder: 'Enter your email address to receive a verification code',
    emailRestoreVerifyCodeDescription: 'Enter verification code to reset your password.',
    emailRestoreVerifyCodePlaceholder: 'Enter the verification code sent to your email.',
    forgotPasswordDescription: 'Please reset your password.',
    updatePasswordSuccess: 'Password updated successfully',
    updatePasswordSuccessDescription: 'The system has successfully updated your password. Please log in again to continue.',
    updatePasswordSuccessDescriptionStudent: 'The system has successfully updated your password. Please log in again to continue.',
    setup_password: 'Set up password',
    setupPasswordDescription: 'After completing password setup, you can use this email as your system login account.',
    login_email: 'Login email',
    change_password: 'Change password',
    current_password: 'Current password',
    changePasswordSuccess: 'Password changed successfully',
    changePasswordFailed: 'Failed to change password',
    personal_information: 'Personal Information',
    update_personal_information: 'Update Personal Information',
    full_name: 'Full Name',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter phone number',
    address: 'Address',
    addressPlaceholder: 'Enter address',
    skip: 'Skip',
    update: 'Update',
    updateProfileSuccess: 'Profile updated successfully',
    updateProfileFailed: 'Failed to update profile',
    registrationSuccessTitle: 'Account registration successful',
    registrationDescription: 'You’ve successfully registered your account. You can start using the system right away.',
    registrationDescriptionStudent: 'You’ve successfully registered your account. You can start using the system right away.',
    backLogin: 'Back to Log in',
    noVerificationCode: 'Didn’t receive the verification code?',
    noVerificationCodeStudent: 'Didn’t receive the verification code?',
    resend: 'Resend',
    after: 'in',
    district: 'Commuce/Ward',
    districtPlaceholder: 'Select commuce/ward',
    province: 'Province/City',
    provincePlaceholder: 'Select province/city',
    joinWorkspaceFail: 'Your join request has been declined',
    joinWorkspaceFailTitle: 'Your request to join <strong>{name}</strong> has been declined.',
    joinWorkspaceFailSubtitle: 'You can send another request or switch to your personal space to continue using NextSchool with the best experience.',
    resendRequest: 'Send another request',
    backSpace: 'Back to get started',
    // Student onboarding
    useNextSchoolTitleStudent: 'Choose how you want to get started with NextSchool',
    useNextSchoolDescriptionStudent: 'NextSchool allows you to join classes created by teachers.',
    joinClass: 'Join Class',
    joinClassDescription: 'If a teacher sends you a class link, click it to join right away.',
    continueExplore: 'Continue exploring',
    continueExploreDescription: 'Explore the system, a teacher or your school will add you to a class later.',
    startJoinClass: 'Start Joining a Class',
    startJoinClassDescription: 'Enter the class link your teacher sent you. If you don’t have one yet, you can go back and continue using the system.',
    classLink: 'Class Link',
    joinClassButton: 'Join Class',
    joinClassSuccess: 'You’ve successfully requested to join the class',
    joinClassSuccessSent: 'Your request has been sent to the teacher.',
    joinClassSuccessPendingApproval: 'Please wait for approval to officially join the class.',
    joinClassFail: 'You’ve failed to request to join the class',
    joinClassWaiting: {
      title: 'Welcome to NextSchool',
    },
    joinClassFailModal: {
      title: 'Your join request has been declined',
      message: 'Your request to join <strong>{name}</strong> has been declined.',
      suggestion: 'You can send another request or switch to your personal space to continue using NextSchool with the best experience.',
      retry: 'Send another request',
      backToSpace: 'Back to get started',
    },
    joinClassPending: {
      title: 'Your join request is pending approval',
      message: 'Your request has been sent to the teacher.',
      suggestion: 'Once the teacher approves, you’ll be added to the class right away. In the meantime, you can explore some features or cancel your join request.',
      cancel: 'Cancel request',
      cancelTitle: 'Cancel joining request',
      cancelMessage: 'After canceling, you can join another class using a new link.',
      cancelSuggestion: 'Are you sure you want to cancel this request?',
      cancelButton: 'Cancel request',
      cancelJoinClassSuccess: 'Your joining request has been cancelled',
      cancelJoinClassFail: 'Cancel joining request failed',
    },

    validation: {
      required_name: 'Please enter your name!',
      required_email: 'Email cannot be empty.',
      invalid_email: 'Invalid email address.',
      required_password: 'Password cannot be empty.',
      required_new_password: 'New password cannot be empty.',
      min_length_password: 'Password must be at least 8 characters long.',
      max_length_password: 'Password must not exceed 30 characters.',
      uppercase_password: 'Password must contain at least one uppercase letter (A–Z).',
      number_password: 'Password must contain at least one number (0–9).',
      special_password: 'Password must contain at least one special character.',
      required_confirm: 'Confirm password cannot be empty.',
      password_mismatch: 'Passwords do not match!',
      required_current_password: 'Current password cannot be empty.',
      agree_terms: 'You must agree to the terms!',
      required_account: 'Account cannot be empty.',
      email_not_found: 'Email is not found in the system.',
      required_firstName: 'Information cannot be empty.',
      required_lastName: 'Information cannot be empty.',
      no_special_or_number: 'Information must not contain special characters and numbers.',
      email_already_exists: 'Email already exists.',
      required_otpCode: 'Invalid OTP. Please check and try again.',
      invalid_otpCode: 'OTP cannot be empty. Please enter the code to continue.',
      has_expired_otpCode: 'OTP has expired. Please request a new code.',
      required_school: 'School cannot be empty.',
      required_registered_school: 'Registered school\'s name cannot be empty.',
      registered_school_already_exists: 'Registered school\'s name already exists.',
      required_school_phone: 'Contact number cannot be empty.',
      invalid_school_phone: 'Invalid phone number.',
      required_district: 'Ward/Commune hệ  cannot be empty.',
      required_province: 'Province/City cannot be empty.',
    },
    loginStudent: {
      title: 'Login Student',
      welcome: 'Welcome to the student login',
      welcome1: 'Smart Learning - Simple Teaching',
      description: 'Please log in to continue',
    },
    loginTeacher: {
      title: 'Login Teacher',
      welcome: 'Welcome, Dear Teachers',
      welcome1: 'Smart Learning - Simple Teaching',
      description: 'Please log in to continue',
    },
    loginParent: {
      title: 'Login Parent',
      welcome: 'Welcome to the parent login',
      description: 'Please login to continue',
    },
    loginSuccessful: 'Login successful',
    loginFailed: 'Login failed',
    confirm: 'Confirm change',
  },
  transaction: {
    title: 'Transaction Management',
    searchPlaceholder: 'Search transactions...',
    statusFilter: 'Status',
    typeFilter: 'Type',
    dateFilter: 'Date',
    upload: 'Upload',
    uploaded: 'Uploaded',
    purchased: 'Purchased',
    noDataUploaded: 'No uploaded data',
    noDataPurchased: 'No purchased data',
    unsupportedType: 'Unsupported upload type',
    unsupportedTypeDescription: 'Type "{{type}}" does not have a corresponding component',
    tab: {
      discoverByCategory: 'Discover by Category',
      agent: 'Agent',
      history: 'History',
      settings: 'Settings',
    },
    tabs: {
      sold: 'Sold',
      bought: 'Bought',
      commission: 'Commission',
    },
    uploadTypes: {
      educationalAssistant: 'Educational Assistant',
      lessonPlan: 'Lesson Plan',
      eLessonPlan: 'E-Lesson Plan',
      worksheet: 'Worksheet',
      video: 'Video',
      image: 'Image',
      slide: 'Slide',
      description: {
        educationalAssistant: 'AI Assistant for educational content',
        lessonPlan: 'Create detailed lesson plans',
        eLessonPlan: 'Electronic lesson plans',
        worksheet: 'Educational worksheets and exercises',
        video: 'Video content for learning',
        image: 'Educational images and graphics',
        slide: 'Presentation slides',
      },
    },
    listResource: {
      title: 'List Resource',
      search: 'Search',
      classBlock: 'Class Block',
      subject: 'Subject',
      status: 'Status',
      action: 'Action',
      noData: 'No data',
      clear: 'Clear',
    },
    form: {
      cancel: 'Cancel',
      upload: 'Upload',
      uploadSuccess: 'Upload successful',
      uploadError: 'Upload failed',
      nameRequired: 'Exercise sheet name is required',
      classRequired: 'Grade is required',
      subjectRequired: 'Subject is required',
      thumbnailRequired: 'Sample display image is required',
      validation: {
        name: 'Name is required',
        class: 'Grade is required',
        subject: 'Subject is required',
        thumbnail: 'Sample display image is required',
        file: 'Document file is required',
        fileRequired: 'Document file is required',
        errorMessage: 'Please check the form again',
        description: 'Description must be at least 10 characters',
        images: 'Maximum 4 illustrative images are allowed',
      },
    },
    uploadComponent: {
      worksheet: {
        title: 'Upload Worksheet',
        configUpload: 'Setup upload worksheet',
        worksheetName: 'Worksheet Name',
        worksheetNamePlaceholder: 'Worksheet name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        descriptionPlaceholder: 'Enter detailed description of the worksheet',
        detailedDescription: 'Detailed Description',
        maxFileSize: 'Maximum file size: 30MB',
        justSupportedFormats: 'Just supported formats: .docx, .pdf',
      },
      slide: {
        title: 'Upload Slide',
        configUpload: 'Setup upload slide',
        slideName: 'Slide Name',
        slideNamePlaceholder: 'Slide name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        descriptionPlaceholder: 'Enter detailed description of the slide',
        detailedDescription: 'Detailed Description',
        maxFileSize: 'Maximum file size: 30MB',
        justSupportedFormats: 'Just supported formats: .pptx, .ppt',
      },
      lessonPlan: {
        title: 'Upload Lesson Plan',
        configUpload: 'Setup upload lesson plan',
        lessonPlanName: 'Lesson Plan Name',
        lessonPlanNamePlaceholder: 'Lesson plan name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        descriptionPlaceholder: 'Enter detailed description of the lesson plan',
        detailedDescription: 'Detailed Description',
        maxFileSize: 'Maximum file size: 30MB',
        justSupportedFormats: 'Just supported formats: .pptx, .ppt',
      },
      eLessonPlan: {
        title: 'Upload E-Lesson Plan',
        configUpload: 'Setup upload e lesson plan',
        eLessonPlanName: 'E-Lesson Plan Name',
        eLessonPlanNamePlaceholder: 'E-lesson plan name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        descriptionPlaceholder: 'Enter detailed description of the e lesson plan',
        detailedDescription: 'Detailed Description',
        maxFileSize: 'Maximum file size: 30MB',
        justSupportedFormats: 'Just supported formats: .pptx, .ppt',
      },
      video: {
        title: 'Upload Video',
        configUpload: 'Setup upload video',
        videoName: 'Video Name',
        videoNamePlaceholder: 'Video name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        videoSource: 'Video Source',
        videoSourcePlaceholder: 'Enter video source',
        descriptionPlaceholder: 'Enter detailed description of the video',
        maxFileSize: 'Maximum file size: 30MB',
        chooseFile: 'Choose video',
        justSupportedFormats: 'Just supported formats: .mp4, .mkv, .mov, .webm',
      },
      image: {
        title: 'Upload Image',
        configUpload: 'Setup upload image',
        imageName: 'Image Name',
        imageNamePlaceholder: 'Image name',
        fileUploaded: 'File uploaded successfully',
        deleteFile: 'Delete file',
        description: 'Description',
        descriptionPlaceholder: 'Enter detailed description of the image',
        imageSource: 'Image Source',
        imageSourcePlaceholder: 'Enter image source',
        maxFileSize: 'Maximum file size: 30MB',
        chooseFile: 'Choose file',
        justSupportedFormats: 'Just supported formats: .jpg, .jpeg, .png, .gif, .bmp, .webp',
      },
      generalInfo: 'General Information',
      sampleImage: 'Sample Display Image',
      uploadSampleImage: 'Upload sample display image',
      illustrativeImages: 'Illustrative Images (Optional)',
      exerciseName: 'Exercise Sheet Name',
      exerciseNamePlaceholder: 'Exercise sheet name',
      grade: 'Grade',
      selectGrade: 'Select grade',
      subject: 'Subject',
      selectSubject: 'Select subject',
      language: 'Language',
      selectLanguage: 'Select language',
      resourceSource: 'Resource/Document Source',
      uploadYourFile: 'Upload your file',
      supportedFormats: 'Supported formats:',
      maxFileSize: 'Maximum file size: 30MB',
      chooseFile: 'Choose file',
      description: 'Description',
      detailedDescription: 'Detailed Description',
      descriptionPlaceholder: 'Enter detailed description of the exercise sheet',
      fileUploaded: 'File uploaded successfully',
      deleteFile: 'Delete file',
      deleteThumbnail: 'Delete thumbnail',
      deleteImage: 'Delete image',
      download: 'Download',
    },
    dialog: {
      delete: {
        title: 'Delete',
        content: 'Are you sure you want to delete this resource?',
        positiveText: 'Delete',
        negativeText: 'Cancel',
        success: 'Delete resource successfully',
      },
    },
    stats: {
      purchases: {
        title: 'Number of Purchases',
        icon: 'ion:cube-outline',
      },
      revenue: {
        title: 'Revenue',
        icon: 'ion:wallet-outline',
      },
      cost: {
        title: 'Cost',
        icon: 'ion:card-outline',
      },
      profit: {
        title: 'Profit',
        icon: 'ion:trending-up-outline',
      },
    },
    table: {
      title: 'Profit',
      columns: {
        agent: 'Agent',
        purchases: 'Purchases',
        revenue: 'Revenue',
        cost: 'Cost',
        profit: 'Profit',
      },
    },
  },
  user: {
    userManagement: {
      title: 'User Management',
      changeButton: 'Change',
      user: 'User',
      workExperience: 'Work Experience',
      position: 'Position',
      workplace: 'Workplace',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      website: 'Website',
      certificates: 'Certificates',
      awards: 'Awards',
      coAuthor: 'Co-Author',
      reviews: 'Reviews',
      attachments: 'Attachments',
      noInformation: 'No information',
      recoveryEmail: 'Recovery Email',
      addRecoveryEmail: 'Add Recovery Email',
      issuedBy: 'Issued By',
      year: 'Year',
      password: 'Password',
      edit: {
        title: 'Edit User Information',
        name: 'Name',
        position: 'Position',
        workplace: 'Workplace',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        recoveryEmail: 'Recovery Email',
        addRecoveryEmail: 'Add Recovery Email',
        noInformation: 'No information',
        certificateName: 'Certificate Name',
        issuedBy: 'Issued By',
        yearIssued: 'Year Issued',
        attachment: 'Attachment',
        certificate: 'Certificate',
        from: 'From',
        to: 'To',
        unit: 'Unit',
        description: 'Description',
        addWorkExperience: 'Add Work Experience',
        addAwards: 'Add Awards',
        addCertificate: 'Add Certificate',
        addWorkExperienceDescription: 'Add work experience',
        addAwardsDescription: 'Add awards',
        addCertificateDescription: 'Add certificate',
        upload: 'Upload',
        viewAttachment: 'View attachment',
        success: 'User information updated successfully!',
        error: 'Failed to update user information.',
        validation: {
          avatar: 'Please select an image!',
          name: 'Please enter your name!',
          position: 'Please enter your position!',
          workplace: 'Please enter your workplace!',
          email: 'Please enter your email!',
          phone: 'Please enter your phone!',
          certificateName: 'Please enter your certificate name!',
          issuedBy: 'Please enter your issued by!',
          yearIssued: 'Please enter your year issued!',
          attachment: 'Please enter your attachment!',
          certificate: 'Please enter your certificate!',
          from: 'Please enter your from!',
          to: 'Please enter your to!',
          unit: 'Please enter your unit!',
          description: 'Please enter your description!',
          addWorkExperience: 'Please enter your add work experience!',
          addAwards: 'Please enter your add awards!',
          addCertificate: 'Please enter your add certificate!',
          addWorkExperienceDescription: 'Please enter your work experience description!',
          addAwardsDescription: 'Please enter your awards description!',
          addCertificateDescription: 'Please enter your certificate description!',
          invalidYear: 'Please enter a valid year!',
          yearToLessThanFrom: 'The year to must be greater than the year from!',
        },
      },
    },
  },
  forum: {
    title: 'Community Forum of next AI',
    tabs: {
      whatNew: 'What\'s new',
      newPost: 'New post',
      newPostOnProfile: 'New post on profile',
      newActivity: 'New activity',
    },
  },
  monitor: {
    hint1: 'Daily AI conversations count, prompt engineering / debugging excluded.',
    hint2: 'Unuique users engaging in Q&A with AI: prompt engineering / debugging excluded',
    hint3: 'Daily AI interaction count',
    hint4: 'Continuous user - AI communication count; for conversation - base apps.',
    hint5: 'Measure the performance of the LLM. Count the Tokens output speed of LLM from the beginning of the request to the completion of the output',
    hint6: 'Reflects the daily token usage of the language model for the application, useful for cost control purposes',
    hint7: ' ',

  },

  globalList: {
    title: 'System Parameter Configuration',
    update: 'Update Configuration',
    create: 'Add New Configuration',
    code: 'Code',
    name: 'Name',
    description: 'Description',
    errorRequired: '{field} is required',
    errorMaxLength: '{field} must be at most {max} characters',
    prompt_value: 'Prompt value',
    validator: {
      codeInvalid: 'Invalid code',
    },
  },

  globalListDetail: {
    title: 'List of Parameter Values',
    update: 'Update Value',
    create: 'Add New Value',
    code: 'Code',
    name: 'Name',
    value: 'Value',
    order: 'Order',
    description: 'Description',
    errorRequired: '{field} is required',
    errorMaxLength: '{field} must be at most {max} characters',
    validator: {
      codeInvalid: 'Invalid code',
    },
  },

  task: {
    title: 'Task',
    create: 'Create Task',
    view: 'View Task',
    edit: 'Edit Task',
    search: 'Search Task',
    nameTask: 'Task Name',
    namePlaceholderTask: 'Example: Translate documents, Write Facebook post,...',
    descriptionTask: 'Task Description',
    descriptionPlaceholderTask: 'A brief description of the purpose of this task',
    contentPromptTask: 'Prompt Content',
    contentPromptGuideTask: 'Use [variables] as parameters to make the prompt more flexible and usable with dynamic inputs',
    contentPromptPlaceholderTask: 'Example: "Translate the document from [language 1] to [language 2]. Ensure the [language 2] translation is concise and in-depth"',
    tag: 'Tag',
    nameTag: 'Tag Name',
    manageTag: 'Manage Tags',
    createTag: 'Create Tag',
    editTag: 'Edit Tag',
    searchTag: 'Search Tag',
    configureTag: 'Configure Tag',
    assignAgent: 'Gán assistant',
    agentExecuted: 'Agent Executed',
    titleDelete: 'Delete Task',
    titleErrorDelete: 'Failed to Delete',
    contentDelete: 'This task will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
    contentErrorDelete: 'An assistant currently using this task has been published to the store. Please unpublish the assistant before deleting the task.',
    contentDeleteLeft: 'This task is currently associated with',
    contentDeleteRight: 'If you proceed, the task will be removed from all agents using it. Are you sure you want to delete it?',
    titleDeleteTag: 'Confirm Tag Deletion',
    contentDeleteTag: 'The tag will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
    contentDeleteTagLeft: 'is currently used by',
    contentDeleteTagCenter: 'If you proceed, this tag will be deleted and',
    contentDeleteTagBold: 'automatically removed ',
    contentDeleteTagRight: 'from all associated tasks. Do you want to continue?',
    configureParameters: 'Configure Parameters',
    nameParameter: 'Name Parameter',
    typeParameter: 'Type Parameter',
    typeText: 'Text',
    typeDropdown: 'Dropdown',
    typeOptionList: 'Option List',
    parameterOptionsList: 'ParameterList',
    allowMultiple: 'Allow multiple selection',
    parameterExists: 'Parameter {parameter} already exists',
    action: 'Action',
    execute: 'Execute',
    additionalRequest: 'Additional request',
    additionalRequestPlaceholder: 'Enter additional request',
    parameterPlaceholder: 'Enter parameter input',
    chooseParameters: 'Choose  parameters',
    parameterRequired: 'Please enter the parameter',
    addParameters: 'Add parameter',
  },

  validation: {
    required: 'Please enter your {name}!',
    greaterThanZero: 'Please enter a {name} greater than 0!',
  },

  writer: {
    title: 'Create content with Nextschool AI',
    create: 'Create content',
    edit: 'Edit content',
    search: 'Search content',
    name: 'Content name',
    description: 'Share what you want to say, and let AI create inspiring stories',
    placeholder: 'Describe your topic or paste your content here. Our AI will structure it into an engaging presentation.',
    ideaInput: {
      title: 'What do you want to present?',
      creating: 'Creating...',
      create: 'Create',
      language: 'Language',
      articleType: 'Article type',
      articleTypePlaceholder: 'Select type',
      languagePlaceholder: 'Select language',
      authorName: 'Author Name',
      authorNamePlaceholder: 'Enter author name (optional)',
      workplace: 'Workplace',
      workplacePlaceholder: 'Enter workplace (optional)',
      year: 'Publication Year',
      yearPlaceholder: 'Enter publication year (optional)',
      researchScope: 'Research Scope',
      researchScopePlaceholder: 'Enter research scope (optional)',
      placeholder: 'Describe your topic or paste your content here. Our AI will structure it into an engaging presentation.',
      optimize: 'Optimize',
      optimizeTooltip: 'Optimize content with AI',
      messages: {
        creating: 'Creating document...',
        created: 'Document created, generating content...',
        error: 'Failed to create document',
        generalError: 'An error occurred while creating document',
        optimizing: 'Optimizing text...',
        optimized: 'Text optimized successfully!',
        optimizeError: 'Failed to optimize text',
      },
    },
    ideaList: {
      title: 'Ideas created',
      ago: 'ago',
      emptyState: {
        title: 'No ideas yet',
        description: 'Create your first idea!',
      },
      messages: {
        creating: 'Creating new idea...',
        created: 'New idea created successfully!',
        error: 'Failed to create new idea',
        generalError: 'An error occurred while creating new idea',
      },
    },
    ideaCard: {
      startFromBlank: 'Start from a blank page',
      ago: 'ago',
      delete: 'Delete',
      articleTypes: {
        report: 'Report',
        research: 'Research',
        article: 'Article',
        paragraph: 'Paragraph',
        blog: 'Blog',
        creativeResearch: 'TEI (Teaching experience initiative)',
      },
      languages: {
        vietnamese: 'Vietnamese',
        english: 'English',
      },
    },
    aiAssistant: {
      title: 'AI Assistant',
      greeting: 'Hello! I can help you create content',
      description: 'Share what you want to say',
      placeholder: 'Enter your question...',
    },
    deleteIdea: {
      title: 'Delete Idea',
      content: 'Are you sure you want to delete this idea?',
      delete: 'Delete',
      cancel: 'Cancel',
    },
    detail: {
      streamingPlaceholder: 'Writing content',
      noTitle: 'No title',
      creatingTitle: 'Creating title...',
      error: 'An error occurred while creating content. Please try again.',
      success: 'Content created and saved successfully!',
      deleteSuccess: 'Idea deleted',
      copySuccess: 'Content copied',
      downloadSuccess: 'Downloaded DOCX file',
      downloadError: 'Downloaded as text',
      updateTitleSuccess: 'Title updated',
      placeholder: 'Write something...',
      askingAI: 'Asking AI...',
      creatingDiagram: 'Creating diagram...',
      noSelectedText: 'No text selected',
      creatingImage: 'Creating image...',
      creatingChart: 'Creating chart...',
      creatingEditor: 'Creating editor...',
      preparing: 'Preparing...',
      creatingCustomSuggestion: 'Creating custom suggestion...',
      tableOfContents: {
        title: 'Table of Contents',
        noHeadings: 'No headings yet',
        addHeadingsHint: 'Add headings to create table of contents',
      },
      replacingText: 'Replacing text...',
      applyingSuggestion: 'Applying suggestion...',
      predefinedSuggestion: 'Predefined suggestion (click to replace)',
      generalSuggestions: 'General suggestions',
      showSuggestions: 'Show suggestions',
      imageSuccess: 'Image created successfully!',
      imageError: 'An error occurred while creating image',
      noDocumentID: 'No document ID found',
      copyError: 'Cannot copy content',
      words: 'words',
      autoCompleteOn: 'Auto-complete enabled',
      autoCompleteOff: 'Auto-complete disabled',
      stopStreaming: 'Stop generating',
      accept: 'Accept',
      reject: 'Reject',
      tryAgain: 'Try again',
      tab: 'Tab',
      suggestion: 'Suggestion',
      suggestionDropdown: 'Suggestion dropdown',
      suggestionDropdownHeader: 'Suggestion for this part',
      suggestionDropdownClose: 'Close',
      customSuggestionInput: 'Enter custom request to rewrite this paragraph',
      customSuggestionInputPlaceholder: 'Example: Add specific examples, write shorter...',
      originalText: 'Original text',
      preparingContent: 'Preparing content...',
      pleaseWait: 'Please wait a moment',
      createTemplate: 'Create Template',
      createContent: 'Create Content',
      noContentToSave: 'No content to save',
      limitedAIInTemplateMode: 'AI features are limited in template mode',
      saveContentTemplate: 'Save Content Template',
      searchContentTemplate: 'Search Content Template',
      contentTemplateSaved: 'Content template saved successfully',
      contentTemplateSaveError: 'Cannot save content template',
      contentTemplateSaveErrorOccurred: 'An error occurred while saving content template',
      contentCopiedToClipboard: 'Content copied to clipboard',
      contentCopyError: 'Cannot copy content',
      noContentFound: 'No content templates found',
      contentTemplateTitle: 'Content Template Title',
      contentTemplateTitlePlaceholder: 'Enter title for content template...',
      contentTemplateGroup: 'Group',
      contentTemplateGroupPlaceholder: 'Select group...',
      contentTemplateSelectedContent: 'Selected content:',
      contentTemplateSearchByTitle: 'Search by title...',
      contentTemplateSelectGroup: 'Select group...',
      contentTemplateSearch: 'Search',
      contentTemplateClearFilter: 'Clear Filter',
      contentTemplateResults: 'Showing {count} / {total} results',
      contentTemplateCopy: 'Copy',
      contentTemplateApply: 'Apply',
      contentTemplateNoGroups: 'Cannot load group list',
      contentTemplateNoContents: 'Cannot load content list',
      contentTemplateNoSelectedText: 'Please select text to save',
      contentTemplateValidationTitle: 'Please enter title',
      contentTemplateValidationGroup: 'Please select group',
      contentAppliedToSelection: 'Content applied to selected text',
      contentApplyError: 'Cannot apply content',
      noEditorInstance: 'Editor not found',
      imageUrlModal: {
        title: 'Insert Image from URL',
        insert: 'Insert Image',
        cancel: 'Cancel',
        imageUrl: 'Image URL',
        imageUrlRequired: 'Image URL *',
        imageUrlPlaceholder: 'https://example.com/image.jpg',
        altText: 'Alt Text (Description)',
        altTextPlaceholder: 'Enter image description',
        imageTitle: 'Title (Optional)',
        titlePlaceholder: 'Enter image title',
        preview: 'Preview',
        error: {
          invalidUrl: 'Invalid image URL or image cannot be loaded.',
          loadFailed: 'Failed to load image. Please check the URL.',
        },
        validation: {
          urlRequired: 'Please enter a valid image URL',
          urlInvalid: 'Please enter a valid URL starting with http:// or https://',
        },
      },
      colorPicker: {
        titleText: 'Select text color',
        titleBackground: 'Select background color',
        textColor: 'Text color',
        backgroundColor: 'Background color',
        themeColors: 'Theme Colors',
        standardColors: 'Standard Colors',
        moreColors: 'More Colors...',
      },
      tableContextToolbar: {
        title: 'Table Operations',
        rows: 'Rows',
        columns: 'Columns',
        table: 'Table',
        addRowAbove: 'Add row above',
        addRowBelow: 'Add row below',
        deleteRow: 'Delete row',
        addColumnLeft: 'Add column left',
        addColumnRight: 'Add column right',
        deleteColumn: 'Delete column',
        deleteTable: 'Delete table',
        close: 'Close toolbar',
        shortcuts: {
          addRowAbove: 'Ctrl+Shift+Up',
          addRowBelow: 'Ctrl+Shift+Down',
          deleteRow: 'Ctrl+Shift+Delete',
          addColumnLeft: 'Ctrl+Shift+Left',
          addColumnRight: 'Ctrl+Shift+Right',
          deleteColumn: 'Ctrl+Delete',
          deleteTable: 'Ctrl+Shift+Backspace',
        },
      },
      tooltips: {
        back: 'Go back',
        createTemplate: 'Create template',
        searchContent: 'Search content',
        toggleAssistant: 'Toggle AI assistant',
        download: 'Download content',
        delete: 'Delete content',
      },
      menu: {
        downloadDocx: 'Download DOCX',
        saveToLesson: 'Save to lesson',
      },
    },
    blankTemplate: {
      title: 'Create Blank Template',
      properties: 'Template Properties',
      propertiesDesc: 'Configure information for your template',
    },
    editTemplate: {
      title: 'Edit Template',
      properties: 'Template Properties',
      propertiesDesc: 'Update information for your template',
      loadingTemplate: 'Loading template...',
      updateTemplate: 'Update Template',
    },
    toolbar: {
      askAI: 'Ask AI',
      diagramAI: 'Diagram AI',
      imageAI: 'Image AI',
      saveContent: 'Save Template',
      searchContent: 'Search Template',
      insertTable: 'Insert Table',
      charts: 'Charts',
      explain: 'Explain',
      insight: 'Insight',
    },
    quickActions: {
      title: 'Quick actions',
      addNew: 'Add new',
      chooseTemplate: 'Choose template',
      openLibrary: 'Library',
      chooseTemplateDesc: 'Use pre-made templates to get started quickly',
      libraryDesc: 'Browse saved documents',
      library: 'Library',
      writerTemplates: 'Writer templates',
      authorName: 'Author Name',
      authorNamePlaceholder: 'Enter author name (optional)',
      workplace: 'Workplace',
      workplacePlaceholder: 'Enter workplace (optional)',
      year: 'Publication Year',
      yearPlaceholder: 'Enter publication year (optional)',
      researchScope: 'Research Scope',
      researchScopePlaceholder: 'Enter research scope (optional)',
      templates: 'Templates',
      search: 'Search',
      all: 'All',
      addTemplate: 'Add template',
      business: 'Business',
      tryChangeSearch: 'Try changing the search keyword or filter',
      noTemplate: 'No template found',
      articleTitle: 'Article Title',
      articleTitlePlaceholder: 'Enter article title',
      cancel: 'Cancel',
      create: 'Create',
      content: 'Content',
      contentDesc: 'This feature will be updated soon',
      createFromTemplate: 'Create from template',
      outstandingTemplate: 'Outstanding template',
      uploadTemplate: 'Upload template',
      uploadTemplateDesc: 'Click to upload, or drag and drop file here',
      uploadTemplateFormat: 'Supported formats: .pdf | .doc | .docx',
      uploadTemplateConverting: 'Converting file to HTML...',
      uploadTemplateSuccess: 'File processed successfully!',
      imageExtract: 'Extract text from image',
      imageExtractDesc: 'This feature will be updated soon',
      next: 'Next',
      chooseDataSource: 'Choose data source',
      uploadFile: 'Upload file',
      writerLibrary: 'Writer library',
      contents: 'Contents',
      blank: 'Blank',
      upload: 'Upload',
      // ContentLibrary specific keys
      templateName: 'Template Name',
      templateNamePlaceholder: 'Enter template name to search',
      field: 'Field',
      fieldPlaceholder: 'Select field',
      writerType: 'Article Type',
      writerTypePlaceholder: 'Select type',
      language: 'Language',
      languagePlaceholder: 'Select language',
      clearFilter: 'Clear Filter',
      templateList: 'Template List',
      templateCount: 'results',
      loadingTemplates: 'Loading templates...',
      noTemplatesFound: 'No templates found',
      tryChangeSearchOrFilter: 'Try changing search keywords or filters',
      category: 'Category',
      writerTypeLabel: 'Article Type',
      languageLabel: 'Language',
      // Additional keys for ContentLibrary
      createNewArticle: 'Create New Article',
      contentFromFile: 'Content from file',
      useTemplate: 'Use Template',
      templatePreview: 'Template Preview',
      deleteTemplate: 'Delete Template',
      deleteTemplateContent: 'Are you sure you want to delete this template?',
      deleteTemplateSuccess: 'Template deleted successfully',
      // Content-related keys
      contentName: 'Content Name',
      contentNamePlaceholder: 'Enter content name to search',
      group: 'Group',
      groupPlaceholder: 'Select group',
      addContent: 'Add Content',
      contentList: 'Content List',
      contentCount: 'results',
      loadingContents: 'Loading contents...',
      noContentsFound: 'No contents found',
      deleteContent: 'Delete Content',
      deleteContentContent: 'Are you sure you want to delete this content?',
      deleteContentSuccess: 'Content deleted successfully',
      messages: {
        creating: 'Creating article...',
        created: 'Article created successfully',
        error: 'Failed to create article',
        generalError: 'An error occurred while creating article',
        processingFile: 'Processing file...',
        extractionError: 'Cannot extract content from file',
        fileProcessedSuccess: 'File processed successfully',
        fileProcessingError: 'Error processing file',
      },
      validation: {
        titleRequired: 'Please enter article title',
        fieldRequired: 'Please select field',
        languageRequired: 'Please select language',
        articleTypeRequired: 'Please select article type',
        contentRequired: 'Please upload file and wait for processing to complete',
        unsupportedFileType: 'Only PDF and DOC/DOCX files are supported',
        // Content validation
        groupRequired: 'Please select group',
        groupNameRequired: 'Please enter group name',
      },
      selectedTemplate: 'Selected template',
      selectTemplate: 'Select Template',
    },
    uploadContent: {
      title: 'Upload Template',
      back: 'Back',
      uploadNewFile: 'Upload Different File',
      fileUpload: 'Upload file',
      imageExtract: 'Extract Text from Image',
      chooseDataSource: 'Choose Data Source',
      uploadDescription: 'Click to upload, or drag and drop files here',
      supportedFormats: 'Supported formats: DOC, DOCX, PDF (max 10MB)',
      extractTextAuto: 'Extract text automatically',
      editBeforeSave: 'Edit before saving',
      processingFile: 'Processing file...',
      pleaseWait: 'Please wait a moment',
      comingSoon: 'Feature will be updated soon',
      fileInfo: {
        processedSuccessfully: 'Processed successfully',
      },
      form: {
        articleTitle: 'Article Title',
        articleTitlePlaceholder: 'Enter article title',
        field: 'Field',
        fieldPlaceholder: 'Select field',
        language: 'Language',
        languagePlaceholder: 'Select language',
        articleType: 'Article Type',
        articleTypePlaceholder: 'Select article type',
        contentLabel: 'Converted content (can be edited):',
        contentPlaceholder: 'Enter article content...',
        // Content form specific fields
        contentTitle: 'Content Title',
        contentTitlePlaceholder: 'Enter content title',
        group: 'Group',
        groupPlaceholder: 'Select group',
        groupName: 'Group Name',
        groupNamePlaceholder: 'Enter new group name',
      },
      validation: {
        titleRequired: 'Please enter article title',
        fieldRequired: 'Please select field',
        languageRequired: 'Please select language',
        articleTypeRequired: 'Please select article type',
      },
      messages: {
        processingFile: 'Processing file...',
        fileProcessedSuccess: 'File processed successfully',
        fileProcessedError: 'Error processing file: {error}',
        pdfNoTextError: 'This PDF file does not contain text (may be a scanned image). Please upload a PDF file that can copy text.',
        onlyPdfDocSupported: 'Only DOC/DOCX/PDF files are supported',
        creatingTemplate: 'Creating template...',
        templateCreatedSuccess: 'Template created successfully',
        templateCreatedError: 'Failed to create template',
        updatingTemplate: 'Updating template...',
        templateUpdatedSuccess: 'Template updated successfully',
        templateUpdatedError: 'Failed to update template',
        checkContentBeforeSave: 'Please check the content before saving',
        errorOccurred: 'An error occurred while creating template',
        // Content messages
        creatingContent: 'Creating content...',
        contentCreatedSuccess: 'Content created successfully',
        contentCreatedError: 'Failed to create content',
        updatingContent: 'Updating content...',
        contentUpdatedSuccess: 'Content updated successfully',
        contentUpdatedError: 'Failed to update content',
        loadContentError: 'Cannot load content',
        groupCreatedSuccess: 'Group created successfully',
        groupCreatedError: 'Failed to create group',
      },
      saveTemplate: 'Save Template',
      createGroup: 'Create New Group',
    },
    blankContent: {
      title: 'Create Blank Content',
      description: 'Create new content from blank page',
      properties: 'Content Properties',
      propertiesDesc: 'Configure information for your content',
      placeholder: 'Start writing your content...',
    },
    editContent: {
      title: 'Edit Content',
      properties: 'Content Properties',
      propertiesDesc: 'Update information for your content',
      loadingContent: 'Loading content...',
      updateContent: 'Update Content',
    },
  },

  classroom: {
    title: 'Class',
    create: 'Create class',
    add: 'Add class',
    view: 'View class',
    edit: 'Edit class',
    search: 'Search class',
    educationalAssistants: 'Educational Assistants',
    descriptionClassroom: 'Classroom Description',
    titleDelete: 'Delete class',
    contentDelete: 'The system will permanently delete this class along with all student learning results.  This action cannot be undone. Are you sure you want to delete it?',
    deleteConfirmCheckbox: 'I understand that student learning results will be permanently deleted.',
    name: 'Class Name',
    namePlaceholder: 'Enter class name',
    classBlock: 'Grade',
    classBlockPlaceholder: 'Select grade',
    description: 'Class description',
    descriptionPlaceholder: 'Enter class description',
    welcome: 'Welcome to Classroom',
    welcomeClassroom: 'Hello, welcome to {name}',
    welcomeTeacherBanner: 'Hello teacher! Why not connect with your apps?',
    welcomeStudentBanner: 'Hello student! Why not connect with your apps?',
    welcomeDescriptionTeacherBanner: 'Once connected, you can teach, share, and manage more conveniently than ever.',
    welcomeDescriptionStudentBanner: 'Once connected, you can learn, share, and manage more conveniently than ever.',
    messagePlaceholderTeacher: 'What do you need help with today, teacher?',
    messagePlaceholderStudent: 'How can I help you today?',
    connectNow: 'Connect now',
    setting: 'Setting classroom',
    configureGrade: 'Configure grading scale',
    titleConfigureGrade: 'Changing the grading scale will affect all classes in this unit',
    contentConfigureGrade: 'The new grading scale will be applied to all classes in all classes within this unit.\n'
			+ 'All graded assignments and assessments will be recalculated using the new grading scale.\n'
			+ 'This change may affect students’ current results.\n'
			+ 'Are you sure you want to continue?',
    saveToLesson: 'Save to lesson',
    saveContentToLesson: 'Save content to lesson',
    saveCreatedContentToLesson: 'Save created content to lesson',
    addLessonAssistant: 'Add lesson assistant',
    addCreatedAssistantSubject: 'Add created assistant to the subject',
    saveToLessonDesc: 'Save content to lesson',
    saveImageToLesson: 'Save image to lesson',
    saveImageToLessonDesc: 'Save image to lesson',
    saveToNewClass: 'Save to new class',
    saveToNewLesson: 'Save to new lesson',
    createAndSave: 'Create and save',
    classroomIdMissing: 'Classroom ID missing',
    planPlaceholder: 'Enter the content you want to present',
    planPlaceholderStudent: 'Enter the content you want to present',
    saveContentToNewClass: 'Save content to new class',
    classroomTeachBoard: '360° Assistant',
    createLesson: 'Add lesson',
    connectApps: 'Connect apps',
    connectAppsDescription: 'Connect apps to use in the classroom',
    imageToText: 'Image to text',
    pdfToText: 'PDF to text',
    deleteHistory: 'Delete document history',
    contentDeleteHistory: 'Are you sure you want to delete this document history?',
    dictate: 'Dictate',
    uploadDocument: 'Upload reference document',
    selectReportType: 'Select report type',
    selectReportTypePlaceholder: 'Select report type',
    addOtherFile: 'Add another file',
    filesExceedLimit: 'The following files exceed the 30MB limit: {files}',
    selectClassBlock: 'Select class block',
    selectSubject: 'Select subject',
    classLevel: {
      grade_1: 'Grade 1',
      grade_2: 'Grade 2',
      grade_3: 'Grade 3',
      grade_4: 'Grade 4',
      grade_5: 'Grade 5',
      grade_6: 'Grade 6',
      grade_7: 'Grade 7',
      grade_8: 'Grade 8',
      grade_9: 'Grade 9',
      grade_10: 'Grade 10',
      grade_11: 'Grade 11',
      grade_12: 'Grade 12',
    },
    toolManagement: {
      title: 'List Tool Management',
      addTool: 'Add Tool',
      editTool: 'Edit Tool',
      addConfig: 'Add Configuration',
      subject: 'Subject',
      grade: 'Grade Level',
      inUse: 'In Use',
      notInUse: 'Not In Use',
      setAsDefault: 'Set as Default',
      applyFrom: 'Apply From',
      template: 'Template',
      name: 'Tool Name',
      namePlaceholder: 'Enter tool name',
      nameRequired: 'Please enter tool name',
      nameMaxLength: 'Tool name must not exceed 255 characters',
      description: 'Description',
      descriptionPlaceholder: 'Enter tool description',
      descriptionMaxLength: 'Description must not exceed 1000 characters',
      configName: 'Configuration Name',
      configNamePlaceholder: 'Enter configuration name',
      configNameRequired: 'Please enter configuration name',
      configNameMaxLength: 'Configuration name must not exceed 255 characters',
      type: 'Type',
      typePlaceholder: 'Select type',
      typeRequired: 'Please select type',
      gradePlaceholder: 'Select grade level',
      gradeRequired: 'Please select grade level',
      subjectPlaceholder: 'Select subject',
      subjectRequired: 'Please select subject',
      selectToolFirst: 'Please select a tool first',
      createToolSuccess: 'Tool created successfully',
      createToolFailed: 'Failed to create tool',
      createToolError: 'An error occurred while creating tool',
      updateToolSuccess: 'Tool updated successfully',
      updateToolFailed: 'Failed to update tool',
      updateToolError: 'An error occurred while updating tool',
      deleteToolTitle: 'Confirm Delete',
      deleteToolConfirm: 'Are you sure you want to delete tool "{name}"?',
      deleteToolSuccess: 'Tool deleted successfully',
      deleteToolFailed: 'Failed to delete tool',
      deleteToolError: 'An error occurred while deleting tool',
      createConfigSuccess: 'Configuration created successfully',
      createConfigFailed: 'Failed to create configuration',
      createConfigError: 'An error occurred while creating configuration',
      editConfig: 'Edit Configuration',
      updateConfigSuccess: 'Configuration updated successfully',
      updateConfigFailed: 'Failed to update configuration',
      updateConfigError: 'An error occurred while updating configuration',
      deleteConfigTitle: 'Confirm Delete',
      deleteConfigConfirm: 'Are you sure you want to delete configuration "{name}"?',
      deleteConfigSuccess: 'Configuration deleted successfully',
      deleteConfigFailed: 'Failed to delete configuration',
      deleteConfigError: 'An error occurred while deleting configuration',
      status: 'Status',
      editing: 'Editing',
      published: 'Published',
      saveAndChangeStatus: 'Save and change status',
      upload: 'Upload',
      configNotFound: 'Configuration not found',
      loadConfigError: 'An error occurred while loading configuration content',
      noContentToSave: 'No content to save',
      saveSuccess: 'Saved successfully',
      saveError: 'An error occurred while saving',
      uploadFeature: 'Upload feature is under development',
      uploadTemplate: 'Upload Template',
      uploadFile: 'Upload File',
      selectFileFirst: 'Please select a file first',
      fileNotFound: 'File not found',
      invalidFileType: 'Invalid file type. Only .docx files are accepted',
      convertError: 'An error occurred while converting the file',
      editorNotReady: 'Editor is not ready',
      uploadSuccess: 'Upload and convert successfully',
      supportedFormat: 'Supported Format:',
      maxFileSize: 'Maximum file size:',
      selectFile: 'Select File',
      next: 'Next',
    },
    reportTypes: {
      weeklyMonthlySemester: 'Weekly / Monthly / Semester Report',
      professional: 'Professional Report',
      annualSummary: 'Annual Summary Report',
      educationQuality: 'Education Quality Report',
      accreditation: 'Accreditation Report',
      teacherStudentWork: 'Teacher-Student Work Report',
      educationDepartment: 'Education Department Report',
      incidentEmergency: 'Incident / Emergency Report',
    },

    articleType: {
      TEACHING_PLAN: 'Teaching plan',
      TEI: 'Teaching experience initiative',
      REPORT: 'Report',
      ELECTRONIC_LESSON_PLAN: 'Lesson plan',
      RESEARCH: 'Research article',
    },

    addNewLesson: 'Create new lesson',
    gradeChangeDialog: {
      title: 'Changing the grading scale will affect the entire system',
      description: 'The new grading scale will be applied to all classes in the system.',
      impact1: 'Assignments and tests that have already been graded will be recalculated according to the new scale.',
      impact2: 'This change may affect students’ current results.',
      question: 'Are you sure you want to continue?',
      cancel: 'Cancel',
      confirm: 'Confirm Change',
    },
    confirm: 'Confirm',
    averageScore: 'AverageScore:',
    member: {
      search: 'Search member',
      add: 'Add member',
      addStudent: 'Add student',
      share: 'Share class',
      shareHint: 'Temporary link (no API yet). Will be replaced with a real share link when backend is ready.',
      joinRequestsLabel: 'Join requests',
      joinRequestsEmpty: 'No join requests',
      title: 'Class Members',
      name: 'Members name',
      nameStudent: 'Student name',
      email: 'Email',
      action: 'Action',
      chooseMember: 'Choose members to add to the class',
      titleDelete: 'Delete member',
      contentDelete: 'This member will be removed from the class.<br/>All related data, including assignments, assessments, and grades, will be permanently deleted and cannot be recovered.<br/>Are you sure you want to continue?',
      chooseGroup: 'Choose by group',
      addSuccess: 'Successfully added {count} members',
      addFailed: 'Failed to add member.',
      shareSub: 'Share class with students and parents',
      shareTo: 'Share to',
      ungrouped: 'Ungrouped',
      shareLinkLabel: 'Share link',
      shareClassroomHint: 'Temporary link (no API yet). Will be replaced with a real share link when backend is ready.',
      joinRequests: {
        title: 'Class Join Requests',
        subtitle: 'Student requests to join the class are waiting you approval.',
        classPlaceholder: 'Select class',
        columns: {
          fullname: 'Full name',
          phone: 'Phone number',
          approval: 'Approval status',
        },
        status: {
          approved: 'Approved',
          rejected: 'Rejected',
        },
        message: {
          approveAllSuccess: 'Approved all requests successfully',
          approveSuccess: 'Approved request successfully',
          rejectSuccess: 'Rejected request successfully',
          approveAllFailed: 'Failed to approve all requests',
          approveFailed: 'Failed to approve request',
          rejectFailed: 'Failed to reject request',
          updateError: 'An error occurred',
        },
      },
      emptyHint: 'Add members to the classroom to start tracking student progress',
      copied: 'Copied',
      copyFailed: 'Copy failed',
    },
    subject: {
      title: 'Learning Spaces',
      create: 'Create Learning Space',
      createv2: 'Create',
      creatorSubmit: 'Create',
      search: 'Search',
      edit: 'Edit Learning Space',
      titleDelete: 'Delete Learning Space',
      contentDelete: 'The learning space will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      name: 'Learning Space Name',
      namePlaceholder: 'Enter the name of the learning space',
      avatar: 'Avatar',
      subject: 'Subject',
      subjectPlaceholder: 'Select the main subject of the space',
      note: 'Automatically create a separate space for each subject',
      createTeachingPlan: 'Create teaching plan',
      info: 'Info',
      delete: 'Delete',
      noTeachingPlan: 'No teaching plan',
      searchPlan: 'Search teaching plan',
      uploadTeachingPlan: 'Upload teaching plan',
      uploadTeachingPlanDescription: 'Click to upload, or drag and drop file here',
      uploadTeachingPlanDescription2: 'Upload your teaching plan',
      supportedFormats: 'Supported formats:',
      bestSupportForPdf: 'Best support for .pdf files',
      maxSize: 'Maximum file size: 30MB',
      next: 'Next',
      selectDataSource: 'Select data source',
      complete: 'Complete',
      back: 'Back',
      teachingPlanCreated: 'Teaching plan created',
      teachingPlanCreatedDescription: 'We have automatically named the teaching plan based on the file you uploaded. You can rename it at any time.',
      teachingPlanCreatedDesc: 'Teaching plan has been created successfully and is ready to use.',
      teachingPlanFiles: 'Teaching plan files',
      uploadTeachingPlanFiles: 'Upload teaching plan files',
      uploadTeachingPlanDesc: 'Select teaching plan files to upload. Supports PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX formats.',
      teachingPlanName: 'Teaching plan name',
      teachingPlanNamePlaceholder: 'Enter teaching plan name',
      copyTeachingPlan: 'Copy teaching plan',
      copyTeachingPlanDescription: 'Select teaching plan from another class to use.',
      selectAll: 'Select all',
      selected: 'Selected',
      total: 'Total',
      cancel: 'Cancel',
      add: 'Add',
      overview: 'Overview',
      teachingPlan: 'Teaching plan',
      // Subject names
      mathematics: 'Mathematics',
      vietnamese: 'Vietnamese',
      english: 'English',
      physics: 'Physics',
      chemistry: 'Chemistry',
      biology: 'Biology',
      history: 'History',
      geography: 'Geography',
      civic_education: 'Civic Education',
      technology: 'Technology',
      informatics: 'Informatics',
      physical_education: 'Physical Education',
      music: 'Music',
      art: 'Art',
      literature: 'Literature',
      natural_science: 'Natural Science',
      social_science: 'Social Science',
      lessonPlan: 'Lesson plan',
      createLessonPlan: 'Create lesson plan',
      noLessonPlan: 'No lesson plan',
      uploadLessonPlan: 'Upload lesson plan',
      uploadLessonPlanDescription: 'Upload a lesson plan saved on your device.',
      lessonPlanCreated: 'Lesson plan created',
      lessonPlanCreatedDescription: 'We have automatically named the lesson plan based on the file you uploaded. You can rename it at any time.',
      lessonPlanName: 'Lesson plan name',
      enterLessonPlanName: 'Enter lesson plan name',
      copyLessonPlan: 'Copy lesson plan',
      copyLessonPlanDescription: 'Select a lesson plan from another class to use.',
      selectTool: 'Select from tool',
      lesson: 'Lesson',
      practice: 'Practice',
      flashcard: 'Flashcard',
      document: 'Document',
      lessonPlanSize: 'Size',
      lessonPlanUploadDate: 'Upload date',
      lessonPlanAuthor: 'Author',
      titleDeleteLessonPlan: 'Delete lesson plan',
      contentDeleteLessonPlan: 'The lesson plan will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      titleDeleteTeachingPlan: 'Delete teaching plan',
      contentDeleteTeachingPlan: 'The teaching plan will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      teachingPlanSize: 'Size',
      teachingPlanUploadDate: 'Upload date',
      teachingPlanAuthor: 'Author',
      close: 'Close',
      lessonPlanFiles: 'Lesson plan files',
      subjectDescription: 'Overview of knowledge and learning objectives for {subject}',
      assignAgentTitle: 'Add support assistant',
      infoLessonPlan: 'Lesson plan information',
      infoTeachingPlan: 'Teaching plan information',
      download: 'Download',
      noTeachingPlanDesc: 'Add a teaching plan to start building the learning path and tracking results',
      noLessonPlanDesc: 'Add a lesson plan to start building the learning path and tracking results',
      emptyHint: 'Start with the first learning space',
    },
    exercise: {
      title: 'Exercise',
      question: 'Enter question',
      answer: 'Enter answer',
      add: 'Add question',
      delete: 'Delete',
      complete: 'Complete',
      placeholder: 'Enter value',
      correct: 'True',
      incorrect: 'False',
      essayPlaceholder: 'Enter essay answer',
      enterYourAnswer: 'Enter your answer...',
      // Assignment modal keys
      assignConfirmTitle: 'Confirm Exercise Assignment',

      assignConfirmMessage: 'Exercise will be assigned to students in the class.',
      assignConfirmDescription: 'Are you sure you want to assign this exercise?',
      assignButton: 'Assign Now',
      recallConfirmTitle: 'Confirm Exercise Recall',
      recallConfirmMessage: 'Exercise will no longer be visible to students and only you can view and use it. The results of students who have completed <strong>will be cancelled</strong>. Are you sure you want to recall this exercise?',
      draftConfirmTitle: 'Exercise Not Assigned',
      draftConfirmMessage: 'You need to assign the exercise to track the progress and results of the students.',
      draftConfirmDescription: 'Students will not be able to see the exercise until you assign it.',
      expireTime: 'Due Date',
      noExpireTime: 'No Limit',
      blankPlaceholder: 'Blank',
      orderPlaceholder: 'Order item {n}',
      // Exam grading modal keys
      aiGradingTitle: 'Auto-grade with AI',
      aiGradingDescription: 'AI will automatically grade the exam based on the answers you have set up previously. Questions that have been manually graded before will not be changed. Do you want to continue grading with AI?',
      completeGradingTitle: 'Complete grading',
      completeGradingDescription: 'After completion, the system will automatically calculate scores based on the correct answers you have graded. Do you want to continue?',
      remainingQuestionsTitle: '{count} questions remaining to be graded',
      remainingQuestionsDescription: 'You still have {count} questions that have not been graded. Do you want AI to automatically grade the remaining questions and complete the grading, or continue manual grading?',
      gradeButton: 'Grade',
      completeButton: 'Complete',
      continueManualGrading: 'Continue grading',
      useAiAndComplete: 'Use AI and complete',
      aiGradingStarted: 'AI grading has started',
      gradingCompleted: 'Grading completed',
      aiGradingAndCompleted: 'AI has been used to grade the remaining questions and completed',
      // Student exercise result keys
      aiGradingButton: 'AI Grade',
      correctAnswersCount: 'Correct answers: {percentage}%',
      resultQuestionNumber: 'Question {number}',
      resultCorrect: 'Correct',
      resultIncorrect: 'Incorrect',
      keywordLabel: 'Keyword:',
      sampleAnswerLabel: 'Sample answer:',
      studentAnswerLabel: 'Student answer:',
      scoreDisplay: '{current}/{max}',
      accuracyPercentage: 'Accuracy: {percentage}%',
      regradeLabel: 'Regrade',
      editAnswerLabel: 'Teacher comment',
      editAnswerPlaceholder: 'Enter teacher comment here...',
      quickGradingLabel: 'Quick grading',
      resultCompleteButton: 'Complete',
      updateResultTitle: 'Update submission results',
      updateResultContent: 'The system will save score changes for the student and synchronize them to all related exercises. Are you sure you want to save?',
      type: {
        multipleChoice: 'Multiple Choice',
        trueFalse: 'True/False',
        essay: 'Essay',
        ordering: 'Ordering',
        fillBlank: 'Fill in the blank',
      },
      addQuestion: 'Add question',
      added: 'Question added',
      deleted: 'Question deleted',
      completed: 'Exercise completed',
      enterQuestion: 'Please enter a question',
      correctAnswer: 'Correct answer',
      orderList: 'List to order:',
      orderCorrect: 'Correct order:',
      questionNumber: 'Question {n}',
      questionSample1: 'What is statistics?',
      questionSample2: 'Fill in the blank ____ Answer below',
      questionSample3: 'True/False question',
      questionSample4: 'Essay question',
      questionSample5: 'Ordering question',
      answerSample1: 'Sample wrong answer',
      answerSample2: 'Sample wrong answer',
      answerSample3: 'Sample correct answer',
      answerSample4: 'Sample wrong answer',
      titleDelete: 'Delete exercise',
      contentDelete: 'The exercise will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      single: 'Single',
      all: 'All',
      result: 'Result',
      progress: 'Progress',
      next: 'Next',
      back: 'Back',
      remaining: 'Remaining',
      totalQuestions: 'Total questions',
      score: 'Score',
      correctAnswers: 'Correct answers',
      incorrectAnswers: 'Incorrect answers',
      retry: 'Retry',
      close: 'Close',
      not_completed: 'Not completed',
      questions: 'Questions',
      questionType: {
        multipleChoice: 'Multiple Choice',
        trueFalse: 'True/False',
        fillBlank: 'Fill in the blank',
        shortAnswer: 'Short Answer',
        openEnded: 'Open Ended',
        ordering: 'Ordering',
      },
      resultMessage: 'You have completed {correct} out of {total} questions',
      shareConfirmation: 'Confirm share',
      shareConfirmationDescription: 'The exercise will be assigned to students in the class to perform.',
      unshareConfirmation: 'Confirm unshare',
      unshareConfirmationDescription: 'The exercise will no longer be assigned to students and only you can view and use them.',
      share: 'Assign exercise',
      unshare: 'Unassign exercise',
      deadline: 'Deadline',
      cancel: 'Cancel',
      probability: 'Probability',
      createdDate: 'Created date',
      completedDate: 'Completed date',
      waitingForCompletion: 'Waiting for completion',
      notSubmitted: 'Not submitted',
      completionPercentage: 'Completion percentage',
      searchStudent: 'Search student...',
      incomplete: 'Incomplete',
      preview: 'Preview',
      resultsError: 'Cannot display results',
      keyword: 'Keyword',
      aiComment: 'AI and teacher comment',
      detailedComment: 'Detailed comment',
      structure: 'Structure',
      content: 'Content',
      language: 'Language',
      improvementSuggestions: 'Improvement suggestions',
      students: 'students',
      deadlineNear: 'Deadline near',
      correctAnswerLabel: 'Correct answer',
      incorrectAnswerLabel: 'Incorrect answer',
      submitConfirmDesc: 'There is still time to complete the exam. Are you sure you want to submit?',
      submitConfirmTitle: 'Confirm submission',
      assignExerciseConfirm: 'The exercise will be assigned to all class members.',
      assignExerciseConfirm2: 'Are you sure you want to assign this exercise?',
      recallExerciseConfirm1: 'The exercise will no longer be visible to class members and students will no longer be able to view and use it.',
      recallExerciseConfirm2: 'Are you sure you want to recall this exercise?',
      score_breakdown: 'Score',
      completion_progress: 'Completion progress',
      shareConfirm: 'Confirm assignment',
      shareConfirmDescription: 'The assignment will be assigned to class members.',
      shareConfirmDescriptionBottom: 'Are you sure you want to assign this assignment?',
      unShareConfirm: 'Withdraw assignment',
      unShareConfirmDescription: 'The assignment will no longer be visible to class members, and only you will be able to view and use it. The results of members who have completed it <strong>will be cancelled</strong>.',
      unShareConfirmDescriptionBottom: 'Are you sure you want to withdraw this assignment?',
      improvements: 'Improvements',
      strengths: 'Strengths',
      noData: 'No data',
      completedSummary: 'Completed',
      resultSummary: 'Result summary',
      generalEvaluation: 'General evaluation',
      assign: 'Assign',
      recall: 'Recall',
      assignSuccess: 'Exercise assigned successfully',
      assignError: 'An error occurred while assigning the exercise',
      recallSuccess: 'Exercise unassigned',
      recallError: 'An error occurred while unassigning the exercise',
      statusAssigned: 'Assigned',
      statusDraft: 'Draft',
      statusCompleted: 'Completed',
      statusExpired: 'Expired',
      exerciseInfo: 'Enter exercise information',
      addNote: 'Add note',
      evaluation: {
        strengths: {
          multipleChoice: 'Accurate answer recognition',
          trueFalse: 'Clear true/false distinction',
          fillBlank: 'Strong understanding of terms and concepts',
          shortAnswer: 'Concise idea presentation',
          essay: 'Detailed analysis and explanation',
          ordering: 'Good logical ordering',
          keyword: 'Strong keyword recognition',
          default: 'Performed well on this question type',
          generalGood: 'Good understanding of basic knowledge',
          applyFormula: 'Correct application of formulas',
          completed: 'Completed the test',
        },
        improvements: {
          multipleChoice: 'Read questions more carefully',
          trueFalse: 'Improve understanding of basic concepts',
          fillBlank: 'Memorize correct terminology',
          shortAnswer: 'Practice expressing ideas more clearly',
          essay: 'Develop analytical skills',
          ordering: 'Improve logical sequencing',
          keyword: 'Focus more on key terms',
          default: 'Needs improvement in this skill',
          reviewBasic: 'Review basic knowledge',
          practiceMore: 'Practice more exercises',
          continueImprove: 'Continue improving skills',
        },
      },
    },
    exam: {
      emptyHint: 'Assign exams to track student performance',
      emptyAction: 'Schedule exam',
      title: 'Exam',
      titleTeacher: 'Exam Paper',
      titleStudent: 'Exam',
      searchPlaceholder: 'Search',
      empty: 'No exams available',
      emptySearch: 'No exams found',
      loadError: 'Unable to load exam list',
      durationLabel: 'Duration',
      examDateLabel: 'Exam date',
      startTimeLabel: 'Exam time',
      totalScoreLabel: 'Total score',
      durationMinutes: '{minutes} minutes',
      duration: 'Duration',
      minutes: 'minutes',
      startExam: 'Start exam',
      viewResult: 'View result',
      listButton: 'List',
      submittedCount: '{submitted} / {total} students submitted',
      testDuration: 'Test Duration',
      testDate: 'Test Date',
      testTime: 'Test Time',
      defaultDuration: '15 minutes',
      detailTitle: 'Exam Details',
      backToClass: 'Back to class',
      countdownMessage: 'You can start the exam after:',
      endedTitle: 'The exam has ended',
      endedDescription: 'The exam time has expired according to the teacher\'s regulations.',
      contactTeacherMessage: 'If you need more time to complete, please contact the teacher for support.',
      status: {
        pending: 'Pending',
        completed: 'Completed',
        overdue: 'Overdue',
        unknown: 'Unknown',
      },
      teacherStatus: {
        graded: 'Graded',
        notGraded: 'Not graded',
      },
      completionTitle: 'Congratulations on completing the exam',
      completionDescription: 'Your exam has been submitted. You will receive the results after the teacher grades it.',
      completionButton: 'Back to class',
      completed: 'Completed',
      notCompleted: 'Not completed',
      notSubmitted: 'Not submitted',
      submitted: 'Submitted',
      notGraded: 'Not graded',
      graded: 'Graded',
      student: 'Student',
      expired: 'Expired',
      notStarted: 'Not started',
      students: 'Students',
      questions: 'Questions',
      deadline: 'Deadline',
      noDeadline: 'No deadline',
      progress: 'Progress',
      incomplete: 'Incomplete',
      completionPercentage: 'Completion Rate',
      searchStudent: 'Search student...',
      completedDate: 'Completed Date',
      createdDate: 'Created Date',
      waitingForCompletion: 'Waiting for completion',

      preview: 'Preview',
      chapter: 'Chapter',

      // Grading related translations
      resultQuestionNumber: 'Question {number}',
      resultCorrect: 'Correct',
      resultIncorrect: 'Incorrect',
      scoreDisplay: '{current}/{max}',
      accuracyPercentage: '{percentage}% accuracy',
      regradeLabel: 'Regrade',
      editAnswerLabel: 'Edit Answer',
      editAnswerPlaceholder: 'Add additional comments...',
      quickGradingLabel: 'Quick Actions',
      resultCompleteButton: 'Complete Grading',
      aiGradingButton: 'AI Grading',
      gradingCompleted: 'Grading completed successfully',
      resultsError: 'Could not load exam results',

      // AI feedback related
      aiComment: 'AI Feedback',
      detailedComment: 'Detailed Comment',
      content: 'Content',
      structure: 'Structure',
      language: 'Language',
      improvementSuggestions: 'Improvement Suggestions',
      score: 'Score',

      // Question types
      keywordLabel: 'Keyword',
      sampleAnswerLabel: 'Sample Answer',
      studentAnswerLabel: 'Student Answer',
      results: 'Result',
      waitingForExamEnd: 'Waiting for exam end',
      inProgress: 'In progress',
      remainingToViewResult: 'Remaining {time} to view results',
      cannotViewResultUntilEnd: 'You cannot view results yet. Please wait until the exam time ends.',
      score_breakdown: 'Score',
      completion_progress: 'Completion progress',
      uncompleted: 'Uncompleted',
      noResults: 'No results',
      correct: 'Correct',
      exam: 'Exam',
    },
    lessonWorkspace: {
      documents: 'Documents',
      slides: 'Slides',
      notes: 'Notes',
      exercises: 'Exercises',
      flashcards: 'Flashcards',
      whiteboard: 'Whiteboard',
      exit: 'Exit',
      documentsDescription: 'View and manage lesson documents',
      slidesDescription: 'Present slides to students',
      notesDescription: 'Take notes during teaching',
      exercisesDescription: 'Manage and assign exercises',
      flashcardsDescription: 'Use flashcards for review',
      whiteboardDescription: 'Interactive whiteboard',
      noDocuments: 'No documents available',
      comingSoon: 'Feature coming soon',
      notesPlaceholder: 'Enter your notes...',
    },
    subjectSelection: {
      title: 'Hello teacher/teacher, please select the subject to start teaching today!',
      lessons: 'lesson',
      clickToView: 'Click to view lesson',
      noSubjects: 'No subject',
    },
    lessonList: {
      title: 'Lesson of {subject}',
      startLesson: 'Start lesson',
      present: 'Presentation',
    },
    result: {
      title: 'Learning Outcomes',
      question: 'Question',
      correct: 'Correct',
      incorrect: 'Incorrect',
      completed: 'Completed',
      remaining: 'Remaining',
      totalQuestions: 'Total questions',
      score: 'Score',
      correctAnswers: 'Correct answers',
      incorrectAnswers: 'Incorrect answers',
      retry: 'Retry',
      close: 'Close',
      resultMessage: 'You have completed {correct} out of {total} questions',
      retake: 'Retry',
      explain: 'Explain question',
      complete: 'You have completed {correctAnswers} out of {totalQuestions} questions',
      averageScore: 'Average Score',
      strengths: 'Strengths',
      needsImprovement: 'Needs Improvement',
      events: 'Identify simple and compound events',
      classicalFormula: 'Apply the classical probability formula',
      frequency: 'Analyze using frequency',
      conditional: 'Conditional probability',
      additionRule: 'Calculate probability using the addition rule',
      frequencyChart: 'Interpret frequency charts',
      all: 'All',
      subjectAll: 'Subject: All',
      typeAll: 'View by: Exam and assignments',
      type: 'Type',
      studentAssessment: 'Student Assessment',
      emptyAddStudentHint: 'No students have taken the exam yet',
    },
    questionCard: {
      motivationalMessage: 'Don\'t worry, you\'re still learning!',
      showHint: 'Don\'t know?',
      viewAnswer: 'View answer',
      checkAnswer: 'Check',
    },
    lesson: {
      title: 'Lesson',
      create: 'Create lesson',
      createv2: 'Create lesson',
      createNewlesson: 'Save to new lesson',
      edit: 'Edit lesson',
      search: 'Search',
      createContent: 'Create Content',
      agentSupport: 'Support Agent',
      createAgentSupport: 'Add Support Agent',
      createFirstAgentSupport: 'Add first support assistant',
      titleDelete: 'Delete Lesson',
      contentDelete: 'The lesson will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      name: 'Lesson name',
      namePlaceholder: 'Enter lesson name',
      description: 'Lesson description',
      descriptionPlaceholder: 'Enter lesson description',
      titleDeleteAgentSupport: 'Delete assistant support',
      contentDeleteAgentSupport: 'The assistant support: will be removed. Are you sure you want to delete it?',
      shareConfirmation: 'Confirm share',
      shareConfirmationDescription: 'All lessons will be made public so that all class members can view and use them.',
      unshareConfirmation: 'Confirm unshare',
      unshareConfirmationDescription: 'All lessons will no longer be visible to class members and only you can view and use them.',
      shareConfirm: 'Confirm Share',
      shareConfirmDescription: 'The entire lesson will be made public so that class members can view and use it.',
      shareConfirmDescriptionBottom: 'Are you sure you want to share this lesson?',
      unShareConfirm: 'Cancel Lesson Sharing',
      unShareConfirmDescription: 'The entire lesson will no longer be visible to class members and only you will be able to view and use it.',
      unShareConfirmDescriptionBottom: 'Are you sure you want to cancel sharing this lesson?',
      sharedConfirm: 'Lesson Has Been Shared',
      sharedConfirmDescription: 'All materials and learning content in this lesson have been shared.',
      sharedConfirmDescriptionBottom: 'There is no additional content to share.',
      unSharedConfirm: 'The lesson has been unshared',
      unSharedConfirmDescription: 'All materials and learning content in this lesson have been unshared.',
      unSharedConfirmDescriptionBottom: 'There is no additional content to unshare.',
      share: 'Share',
      unshare: 'Unshare',
      cancel: 'Cancel',
      onlyMe: 'Only me',
      shared: 'Shared',
      assigned: 'Assigned',
      stopShare: 'Stop share',
      public: 'Public',
      agree: 'Agree',
      revoke: 'Revoke',
      emptyHint: 'Create your first lesson to get started',
      emptyHintExcercise: 'Create your first lesson to start exercises',
      noContent: 'No content',
      noContentDescription: 'Add new content to the lesson',
      bulkShareSuccess: 'Lesson content shared successfully',
      bulkShareError: 'An error occurred while sharing lesson content',
      bulkUnshareSuccess: 'Lesson content unshared successfully',
      bulkUnshareError: 'An error occurred while unsharing lesson content',

    },
    practice: {
      title: 'Practice',
      create: 'Create practice',
      search: 'Search practice',
      createContent: 'Add practice content',
      titleDelete: 'Delete practice',
      contentDelete: 'The practice will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      name: 'Practice title',
      namePlaceholder: 'Enter practice title',
      description: 'Description',
      descriptionPlaceholder: 'Description',
      progress: 'Progress',
      next: 'Next',
      questionType: {
        multipleChoice: 'Multiple Choice',
        trueFalse: 'True/False',
        fillBlank: 'Fill in the blank',
        shortAnswer: 'Short Answer',
        openEnded: 'Open Ended',
        ordering: 'Ordering',
      },
      shareConfirm: 'Confirm sharing',
      shareConfirmDescription: 'The practice exercise will be made public so that class members can view and use it.',
      shareConfirmDescriptionBottom: 'Are you sure you want to share this practice exercise?',
      unShareConfirm: 'Unshare practice exercise',
      unShareConfirmDescription: 'The practice exercise will no longer be visible to class members, and only you will be able to view and use it.',
      unShareConfirmDescriptionBottom: 'Are you sure you want to unshare this practice exercise?',
      practiceInfo: 'Enter practice information',
      shareSuccess: 'Practice exercise shared successfully',
      shareError: 'An error occurred while sharing the practice exercise',
      unShareSuccess: 'Practice exercise unshared successfully',
      unShareError: 'An error occurred while unsharing the practice exercise',
    },
    flashcard: {
      title: 'Flashcard',
      practiceTitle: 'Flashcard Practice',
      clickToFlip: 'Click to flip card',
      nextCard: 'Next Card',
      shuffle: 'Shuffle',
      allCards: 'All Cards',
      bookmarkedCards: 'Bookmarked Cards',
      flipCard: 'Flip Card',
      aiAssistantTitle: 'AI Assistant',
      aiAssistantPlaceholder: 'Ask AI about flashcard content...',
      congrats: 'Congratulations!',
      completedAll: 'You have completed all flashcard cards',
      yourProgress: 'Your Progress',
      completed: 'Completed',
      remaining: 'Remaining',
      retry: 'Retry',
      titleDelete: 'Delete Flashcard',
      contentDelete: 'The Flashcard will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      questionType: {
        multipleChoice: 'Multiple Choice',
        trueFalse: 'True/False',
        fillBlank: 'Fill in the blank',
        shortAnswer: 'Short Answer',
        openEnded: 'Open Ended',
        ordering: 'Ordering',
        flashcard: 'Flashcard',
      },
      answerSample: 'Answer Sample',
      correct: 'Correct',
      incorrect: 'Incorrect',
      pleaseTryAgain: 'Please try again',
      correctAnswerIs: 'Correct answer is',
      close: 'Close',
      check: 'Check',
      shareConfirm: 'Confirm sharing',
      shareConfirmDescription: 'The flashcard will be made public so that class members can view and use it.',
      shareConfirmDescriptionBottom: 'Are you sure you want to share this flashcard?',
      unShareConfirm: 'Unshare flashcard',
      unShareConfirmDescription: 'The flashcard will no longer be visible to class members, and only you will be able to view and use it.',
      unShareConfirmDescriptionBottom: 'Are you sure you want to unshare this flashcard?',
      shareSuccess: 'Flashcard shared successfully',
      shareError: 'An error occurred while sharing the flashcard',
      unShareSuccess: 'Flashcard unshared successfully',
      unShareError: 'An error occurred while unsharing the flashcard',
    },
    document: {
      title: 'Document',
      titleDelete: 'Delete document',
      contentDelete: 'The document will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      uploadTitle: 'Upload learning materials',
      uploadDescription: 'Upload learning materials for you lesson',
      shareConfirm: 'Confirm sharing',
      shareConfirmDescription: 'The document will be made public so that class members can view and use it.',
      shareConfirmDescriptionBottom: 'Are you sure you want to share this document?',
      unShareConfirm: 'Unshare document',
      unShareConfirmDescription: 'The document will no longer be visible to class members, and only you will be able to view and use it.',
      unShareConfirmDescriptionBottom: 'Are you sure you want to unshare this document?',
      shareSuccess: 'Document shared successfully',
      shareError: 'An error occurred while sharing the document',
      unShareSuccess: 'Document unshared successfully',
      unShareError: 'An error occurred while unsharing the document',
      uploadSuccess: 'Material uploaded successfully',
      uploadError: 'An error occurred while uploading the material',
      createSuccess: 'Lesson material created successfully',
      createError: 'An error occurred while creating the lesson material',
    },
    content: {
      smartGeneration: 'Design engaging exercises with AI-powered question generation',
      smartGenerationPractice: 'Design engaging practice exercises with AI-powered question generation',
      smartGenerationFlashcard: 'Design engaging flashcards with AI-powered automatic flashcard creation',
      uploadDocument: 'Upload Document',
      descriptionDocument: 'Upload document files or notes to share with students.',
      createPractice: 'Create Practice Quizzes',
      descriptionPractice: 'Create a quiz from the teaching content of the teacher to help students learn effectively.',
      createFlashcard: 'Create Flashcard',
      descriptionFlashcard: 'Generate quick flashcard sets from lesson content to help students review easily .',
      createExercise: 'Create Assignment',
      descriptionExercise: 'Quickly create tests based on your teaching content.',
      uploadNewDocument: 'Upload New Document',
      descriptionNewDocument: 'Upload a new document file.',
      selectKnowledge: 'Choose from Knowledge Base',
      descriptionSelectKnowledge: 'Choose documents from the uploaded Knowledge Base.',
      selectLesson: 'Choose from Lesson',
      descriptionSelectLesson: 'Reuse content from existing classes or lessons.',
      selectTool: 'Choose from tools',
      descriptionSelectTool: 'Use slides and ideas created',
      dataSource: 'Select document file',
      executeFinish: 'Check and finish',
      addKnowledge: 'Add knowledge',
      finish: 'Finish',
      contentCreated: 'Document created',
      documentCreated: 'Learning material created',
      documentCreatedSubject: '{subject} learning materials has been create successfully',
      contentCreatedDes: 'We have automatically named the document based on the file you uploaded. You can rename it at any time.',
      documentName: 'Document file name',
      createSelectKnowledge: 'Add content from knowledge base',
      descriptionCreateSelectKnowledge: 'Add content that has been uploaded in the Knowledge section',
      createSelectLesson: 'Add content from lesson',
      descriptionCreateSelectLesson: 'Add content that has been uploaded in the Lessons section',
      createBlankPage: 'Start from a blank page',
      descriptionBlankPage: 'Create flashcard from your own ideas.',
      createFromLesson: 'Create from Lesson',
      descriptionFromLesson: 'Use AI to automatically generate flashcard from the uploaded lesson.',
      next: 'Next',
      documentSource: 'Document Source',
      model: 'Choose model',
      practiceInfo: 'Practice Information',
      exerciseInfo: 'Assignment Information',
      flashcardInfo: 'Flashcard Information',
      flashcardInfoInput: 'Enter flashcard information',

      name: 'Name',
      exerciseName: 'Assignment name',
      flashcardName: 'Flashcard name',
      practiceName: 'Practice name',
      description: 'Description',
      question: 'Questions',
      questionAnswer: 'Question & Answer',
      multipleChoiceNumber: 'Multiple Choice Question',
      trueFalseNumber: 'True/False Question',
      openEndedNumber: 'Essay Question',
      blankNumber: 'Fill-in-the-Blank Question',
      shortAnswerNumber: 'Short Answer Question',
      orderingNumber: 'Ordering Question',
      difficulty: 'Difficulty',
      difficultyPlaceholder: 'Select difficulty',
      rememberLevel: 'Remembering',
      applyLevel: 'Applying',
      analyzeLevel: 'Analyzing',
      additionalRequirement: 'Requirement',
      placeholderRequirement: 'Enter your desired question creation requirement for the selected documents.',
      dueDate: 'Due Date',
      cardType: 'Card Type',
      keywordCard: 'Keyword Explanation Card',
      multipleChoiceAnswerCard: 'Multiple Choice Card',
      blankCard: 'Fill-in-the-Blank Card',
      documentList: 'Document List',
      chooseLearningSpace: 'Choose Learning Space',
      chooseLesson: 'Select lesson',
      chooseClassroom: 'Select class',
      keyword: 'Keyword',
      addImage: 'Add Image',
      addImageAI: 'Generate image automatically',
      definition: 'Definition',
      preview: 'Preview',
      addBlank: 'Add Blank',
      addAnswer: 'Add Answer',
      addCard: 'Add Card',
      answerOption: 'Answer Option',
      questionConfiguration: 'Question Configuration',
      additionalSettings: 'Additional Settings',
      addOption: 'Add Option',
      ideasCreated: 'Ideas created',
      slideCreated: 'Slide created',
      saveQuestionBank: 'Save to question bank',
      fillBankPlaceholder: 'Fill in the blank',
      uploadImage: 'Upload Image',
      messages: {
        createExerciseSuccess: 'Assignment created successfully',
        createExerciseError: 'Assignment created failed',
        updateExerciseSuccess: 'Assignment updated successfully',
        updateExerciseError: 'Assignment updated failed',
        createFlashcardSuccess: 'Flashcard created successfully',
        createFlashcardError: 'Flashcard created failed',
        updateFlashcardSuccess: 'Flashcard updated successfully',
        updateFlashcardError: 'Flashcard updated failed',
        createPracticeSuccess: 'Practice created successfully',
        createPracticeError: 'Practice created failed',
        updatePracticeSuccess: 'Practice updated successfully',
        updatePracticeError: 'Practice updated failed',
      },
    },
    question: {
      create: 'Create question',
      creating: 'Creating question',
      answer: 'Answer',
      chooseQuestionTypePlaceholder: 'Choose Question Type',
      questionPlaceholder: 'Enter Question',
      addWithAI: 'Create question with AI',
      addCardWithAI: 'Create card with AI',
      limitNumber: 'The total number of questions must be greater than 0 and less than or equal to 20.',
      checkNumber: 'The total number of questions must equal the total number of questions by level.',
      correctOrder: 'Correct Order',
      incorrect: 'Incorrect',
      correctAnswer: 'Correct Answer',
      orderPlaceholder: 'Question {n}',
      answerOrdering: 'Answer ordering',
      enterAnswerOrdering: 'Enter answers in order',
      enterAnswerOrderingNumber: 'Enter the answer in order {n}',
      question: 'Question',
      addOptionAnswer: 'Add answer option',
      questionCreatedSuccessfully: 'Questions created successfully',
      questionCreatedFailed: 'Questions created failed',
      questionCardCreatedSuccessfully: 'Cards created successfully',
      questionCardCreatedFailed: 'Cards created failed',
    },

    examPaper: {
      title: 'Library',
      createExamPaper: 'Create assessment',
      editExamPaper: 'Edit assessment',
      duplicateExamPaper: 'Duplicate assessment',
      questionLibrary: 'Question Bank',
      exam: 'Schedule',
      searchExam: 'Search Exam',
      createExam: 'Schedule assessment',
      editExam: 'Edit schedule assessment',
      examDate: 'Assessment date',
      examDatePlaceholder: 'Select assessment date',
      class: 'Class',
      classPlaceholder: 'Select class',
      nameExam: 'Assessment',
      nameExamPlaceholder: 'Select assessment',
      duration: 'Duration',
      durationPlaceholder: 'Select duration',
      status: 'Status',
      showAnswer: 'Show Answer',
      hideAnswer: 'Hide Answer',
      searchQuestion: 'Search',
      questionTypePlaceholder: 'Question Type',
      nameExamPaper: 'Assessment name',
      nameExamPaperPlaceholder: 'Enter assessment name',
      subjectPlaceholder: 'Select subject',
      questionDisplayMode: 'Show questions',
      questionDisplayModePlaceholder: 'Select show questions',
      splitExamParts: 'Split into Mutiple-choice and Essay',
      splitExamPartsCheck: 'Split into Multiple-choice and Essay',
      titleExamPaperDelete: 'Delete assessment',
      contentExamPaperDelete: 'The assessment will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      titleQuestionDelete: 'Delete question',
      contentQuestionDelete: 'The question will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      configureScore: 'Scoring settings',
      autoAIGeneration: 'Generate with AI',
      descriptionAutoAIGeneration: 'Automatically generate questions using AI.',
      subDescriptionAutoAIGeneration: 'Design engaging assessment with the AI-powered question generator',
      chooseQuestionBank: 'Select from Question Bank',
      descriptionChooseQuestionBank: 'Choose questions from the question bank.',
      examPaperInfo: 'Assessment information',
      enterExamPaperInfo: 'Enter assessment information',
      uploadedInClasses: 'Uploaded in classes',
      uploadDocument: 'Upload document',
      questionCountByLevel: 'Enter the number of questions by level',
      remembering: 'Remembering',
      understanding: 'Understanding',
      applying: 'Applying',
      highOrderApplying: 'Higher-order thinking',
      setting: 'Configure',
      score: 'Score',
      multipleChoiceSection: 'Multiple-choice',
      essaySection: 'Essay',
      enterAverageScore: 'Calculate avarage score',
      configureScoreMultiple: 'Calculate Avarage Score',
      configureScoreEssay: 'Calculate Avarage Score',
      totalScoreMultiple: 'Total Multiple-choice Score',
      totalScoreEssay: 'Total Essay Score',
      totalScorePlaceholder: 'Enter total score',
      averageScore: 'Average Score per Question:',
      numberQuestion: 'Number of Questions',
      titleConfigureScoreDelete: 'Cancel configure score',
      contentConfigureScoreDelete: 'The system will delete all previously created average score settings. Are you sure you want to delete them?',
      titleExamDelete: 'Delete schedule assessment',
      contentExamDelete: 'The schedule assessment will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      formatQuestion1: 'Question number',
      formatQuestion2: 'Question',
      formatQuestion3: 'Question',
      formatQuestion4: 'Q',
      question: 'Question',
      questions: 'questions',
      orderingItem: 'Ordering item',
      statusAssigned: 'Not Started',
      statusInProgress: 'In Progress',
      statusExpired: 'View results',
      titleConfigureScore: 'This assessment has no questions yet',
      contentConfigureScore: 'You haven’t added any questions to this assessment. Please add questions before setting up the scoring.',
      noDataBank: 'Start by adding your first question',
      primarySchool: 'Primary School',
      lowerSecondarySchool: 'Lower Secondary School',
      highSchool: 'High School',
      advancedCustomization: 'Advanced Customization',
      cancelAdvancedCustomization: 'Cancel Advanced Customization',
      examMatrixSetup: 'Setup matrix',
      setupByMatrix: 'Setup by matrix',
      totalQuestions: 'Total questions',
      emptyHint: 'Assign assessments to track students’ performance.',
      emptyCreateHint: 'Create your first assessment',
      selectCategoryHint: 'Select a category to view questions',
      emptyQuestionBankHint: 'There are no questions in the question bank',
      viewAll: 'View all',
      teacherCreated: 'Teacher created',
      selectFromClass: 'Or select from class',
      examDetail: 'Exam Detail',
      examName: 'Exam Name',
      totalScore: 'Total Score',
      questionDistribution: 'Question Distribution',
      multipleChoice: 'Multiple Choice',
      trueFalse: 'True/False',
      fillInTheBlank: 'Fill in the Blank',
      shortAnswer: 'Short Answer',
      openEnded: 'Essay',
      ordering: 'Ordering',
      createdBy: 'Created By',
      createdDate: 'Created Date',
      questionsDetail: 'Questions Detail',
      orderItem: 'Order item',
      statusDraft: 'Draft',
      statusAssignedDetail: 'Assigned',
      statusInProgressDetail: 'In Progress',
      statusCompleted: 'Completed',
      statusExpiredDetail: 'Expired',
      configure: 'Configure',
      addFirstQuestion: 'Start by adding your first question',
      addQuestion: 'Add question',
      editQuestion: 'Edit question',
      objectives: 'Assessment Goals',
      noQuestions: 'No questions yet',
      clickAddQuestion: 'Click "Create with AI" to add questions',
      complete: 'Complete',
      confirm: 'Confirm',
    },
    noSubject: 'No subject',
    noSubjectDescription: 'Currently, there are no subjects in this class. Please contact the teacher for support.',
    welcomeTeacher: 'Hello, teacher!',
    welcomeStudent: 'Welcome, {name}',
    welcomeDescriptionTeacher: 'Let\'s turn today\'s lesson into an exciting experience!',
    welcomeDescriptionStudent: 'Let’s explore a new lesson together!',

    // Dynamic headers for different tools
    headerTitles: {
      NORMAL_CHAT: 'AI accompanies teachers in every step of lesson plan preparation',
      SLIDE: 'Create captivating slides with AI that students will love',
      IMAGE: 'Vivid illustrations to make lessons more engaging with AI',
      TEACHING_EXPERIENCE_INITIATIVE: 'Save time writing initiatives with AI support',
      LESSON_PLAN: 'AI supports lesson plan preparation according to new curriculum standards',
      TEACHING_PLAN: 'AI accompanies teachers in every step of lesson plan preparation',
      WRITE: 'Write easier, faster, more effectively with AI',
      MIND_MAP: 'Help students understand better with knowledge visualization from AI',
      CHAT_PDF: 'Quickly understand PDF content through conversations with AI',
      IMAGE_TO_TEXT: 'Extract text from images with AI-powered text recognition',
      PDF_TO_TEXT: 'Extract content from PDFs with AI for easy editing',
    },
    headerTitlesStudent: {
      SLIDE: 'AI helps transform your content into clear, engaging slides',
      IMAGE: 'Enter your ideas and let AI generate illustrations instantly',
      MIND_MAP: 'Turn knowledge into visual mind maps for more effective learning',
    },
    normalChat: 'Normal Chat',
    send: 'Send',
    startChat: 'Start a conversation',
    startChatDescription: 'Send your first message to get started',
    chatHistory: 'Chat History',
    newChat: 'New Chat',
    noChatHistory: 'No chat history yet',
    confirmDeleteChat: 'Are you sure you want to delete this chat?',
    confirmDeleteConversation: 'Are you sure you want to delete this conversation?',
    loadingHistory: 'Loading history...',
    conversation: 'Conversation',
    deleteConversation: 'Delete conversation',
    back: 'Back',
    quickStart: 'Quick start with',
    smartSuggestions: 'Smart suggestions',
    loadingConversation: 'Loading conversation...',
    errorLoadingConversation: 'Unable to load conversation',
    errorSendingMessage: 'An error occurred while sending message',
    more: 'More',
    // dictate: 'Dictate',
    voiceMode: 'Voice mode',
    createSlide: 'Create Slides',
    createImage: 'Create Images',
    teachingExperienceInitiative: 'Write a Teaching Experience Initiative',
    shortTeachingExperienceInitiative: 'Write TEI',
    lessonPlan: 'Create Lesson Plan',
    shortLessonPlan: 'Create LP',
    teachingPlan: 'Create Teaching Plan',
    shortTeachingPlan: 'Create TS',
    teachingPlanForm: {
      title: 'Create Teaching Plan',
      grade: 'Grade',
      gradePlaceholder: 'Select grade',
      subject: 'Subject',
      subjectPlaceholder: 'Select subject',
      bookSeries: 'Book Series',
      bookSeriesPlaceholder: 'Select book series',
      lesson: 'Lesson',
      lessonPlaceholder: 'Select lesson to prepare',
      periods: 'Periods',
      periodsPlaceholder: 'Select periods',
      studentLevel: 'Student Level',
      studentLevelPlaceholder: 'Select student level',
      uploadTitle: 'Upload approved teaching plan for more accurate preparation',
      supportedFormats: 'Supported formats:',
      maxFileSize: 'Maximum file size: 50MB',
      chooseFile: 'Choose File',
      uploadedFiles: 'Uploaded Files',
      startCreating: 'Start Creating Plan',
      creating: 'Creating...',
      noFilesUploaded: 'No files uploaded yet',
      fileUploaded: 'Uploaded {count} file(s)',
      fileRemoved: 'File removed',
      unsupportedFormat: '{name}: Unsupported format. Only .pdf, .docx are accepted',
      fileTooLarge: '{name}: File size exceeds 50MB',
      creatingPlan: 'Creating teaching plan...',
      createSuccess: 'Teaching plan created successfully',
      createError: 'An error occurred while creating the plan',
      gradeOptions: {
        grade1: 'Grade 1',
        grade2: 'Grade 2',
        grade3: 'Grade 3',
        grade4: 'Grade 4',
        grade5: 'Grade 5',
        grade6: 'Grade 6',
        grade7: 'Grade 7',
        grade8: 'Grade 8',
        grade9: 'Grade 9',
        grade10: 'Grade 10',
        grade11: 'Grade 11',
        grade12: 'Grade 12',
      },
      subjectOptions: {
        math: 'Mathematics',
        literature: 'Literature',
        english: 'English',
        physics: 'Physics',
        chemistry: 'Chemistry',
        biology: 'Biology',
        history: 'History',
        geography: 'Geography',
        informatics: 'Informatics',
      },
      bookSeriesOptions: {
        kntt: 'Connecting Knowledge',
        cd: 'Wings',
        ctst: 'Creative Horizon',
      },
      periodsOptions: {
        period1: '1 period',
        period2: '2 periods',
        period3: '3 periods',
        period4: '4 periods',
        period5: '5 periods',
      },
      studentLevelOptions: {
        excellent: 'Excellent',
        good: 'Good',
        average: 'Average',
        weak: 'Weak',
      },
      lessonContent: {
        title: 'Lesson Content',
        periodInLesson: 'Period in Lesson',
        periodInCurriculum: 'Period in Curriculum',
        periodInCurriculumPlaceholder: 'Enter period number',
        lessonStartFrom: 'Lesson Starts From',
        lessonEndAt: 'Lesson Ends At',
        selectLesson: 'Select Lesson',
        selectActivity: 'Select Activities in Lesson',
        warmUpSection: 'Warm-up Section',
        warmUp: 'Warm-up',
        reviewOld: 'Review Previous Lesson',
        practiceSection: 'Practice/Exercise Section',
        practice: 'Practice',
        apply: 'Apply',
        none: 'Not Performed',
        conclusionSection: 'Conclusion Section',
        consolidate: 'Consolidate Lesson',
        summary: 'Summary Activity',
        selectTemplate: 'Select Teaching Plan Structure',
        viewDetail: 'View Details',
        startDrafting: 'Start Drafting Lesson Plan',
        fillAllInfo: 'Please fill in all information for all periods',
        selectTemplateWarning: 'Please select teaching plan structure',
        loadLessonsError: 'An error occurred while loading lessons',
        loadTemplatesError: 'An error occurred while loading templates',
      },
    },
    write: 'AI Write',
    writeArticle: 'Write article',
    mindMap: 'Mindmap',
    shortMindMap: 'Mindmap',
    chatPdf: 'Chat PDF',
    imageToWord: 'Convert Image to Text',
    shortImageToText: 'Convert',
    pdfToWord: 'Convert Scanned PDF to Text',
    shortPdfToText: 'Convert scanned',
    lessonAi: 'AI Lesson',
    prepareLessonTitle: 'Let’s get your lesson ready for your students!',
    lessonSupport: 'Lesson planning assistant',
    addTeacherMaterial: 'Add your documents',
    createPractice: 'Create practice quizzes',
    createFlashcard: 'Make quick flashcards',
    assignHomework: 'Assign homework',
    questionBank: 'Question bank',
    createExamPaper: 'Create assessment',
    educationalAssistant: 'Educational Assistant',
    addCompanionAssistant: 'Meet your AI assistants',
    addAssistant: 'Add assistant',
    listAssistant: 'List assistant',
    editDisplay: 'Customize view',
    customizeView: 'Customize view',
    apply: 'Apply',
    supportTools: 'Tools',
    toolSelected: 'Selected',
    allTools: 'All Tools',
    displayMode: 'Display Mode',
    horizontalCard: 'Horizontal',
    verticalCard: 'Vertical',
    iconOnly: 'Icon only',
    recentlyCreated: 'Recently created',
    filteredByTool: 'Filtered by tool',
    choose: 'Choose',
    tools: 'Tools',
    messages: 'Messages',
    suggestedMessages: 'Suggested Messages',
    addSuggestedMessage: 'Add Suggested Message',
    editSuggestedMessage: 'Edit Suggested Message',
    deleteSuggestedMessage: 'Delete Suggested Message',
    noSuggestedMessages: 'No suggested messages yet',
    enterSuggestedMessage: 'Enter suggested message',
    enterNewSuggestedMessage: 'Enter new suggested message',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    createAssistant: 'Create a new educational assistant',
    enterCreationRequest: 'Describe assistant requirements',
    enterCreationRequestPlaceholder: 'Example: Create an educational assistant that helps teach Math (Geometry) to 8th-grade students.',
    enterCreationRequestPlaceholderStudent: 'Example: Create a learning assistant to help grade 8 students review and better understand Mathematics (Geometry).',
    createAgent: 'Create manually',
    viewAll: 'View all',
    addSpace: 'Add to space',
    addSubject: 'Add to subject',
    chooseAgent: 'Select an assistant to continue',
    addAgentSuccess: 'Your assistant is ready',
    addAgentSuccessDescription: 'The AI has successfully created an educational assistant for you',
    addAgentSuccessDescriptionBottom: 'You can add it to your classroom so students can interact directly',
    createEducationalAssistant: 'Create Educational Assistant',
    assistantName: 'Assistant Name',
    addAgentToNewClassroom: 'Add assistant to new classroom',
    emptyHint: 'Start with the first classroom',
    imageDetails: {
      title: 'Image Description',
      content: 'Content',
      imageInfo: 'Image Information',
      type: 'Type',
      resolution: 'Resolution',
      aspectRatio: 'Aspect Ratio',
      model: 'Model',
      createdTime: 'Created Time',
      sourceId: 'Source ID',
      totalImages: 'Total Images',
      download: 'Download',
      share: 'Share link',
      shareCommunity: 'Share with community',
      shareCommunitySuccess: 'Shared successfully',
      shareCommunityFail: 'Share failed',
      shareCommunityDescriptionSuccess:
				'Your image has been submitted for review. Once approved, it will appear in the ',
      shareCommunityDescriptionSuccessStrong:
				'Image Library Explore section.',
      image_style: 'Style',
      image_name: 'Image name',
      imageApprove: 'Phê duyệt ảnh',
      author: 'Author',
      unapprove: 'Unapprove',
      approve: 'Approve',
      publish: 'Publish',
      unpublish: 'Unpublish',
      update: 'Update',
      copyPrompt: 'Copy prompt',
      like: 'Like',
      generateTemplate: 'Generate from template',
    },
    viewStudentList: 'View student list',
    fetchAssignments: 'Get subject assignments',
    createQuickQuiz: 'Create quick quiz',
    showAllTeachingClasses: 'Show all classes I teach',
    teacherNoClassroom: 'You haven’t joined any classes yet.',
    youNoClassroom: 'You haven\'t joined any classes yet.',
    pleaseContactAdmin: 'Please contact the administrator to be added to a class.',
    classListDescription: 'A list of classes you have created.<br/>You can edit class information right here.',
    numberMember: 'Number Members',
    chooseDataFile: 'Choose data file',
    reviewFinish: 'Review and finish',
    uploadKnowledge: 'Upload Knowledge',
    fileUpload: 'Upload file',
    imageText: 'Image to Text',
    pdfScan: 'Scan PDF',
    fileUploaded: 'File uploaded',
    imageConversionSuccessful: 'Image converted successfully',
    pdfConversionSuccessful: 'PDF file converted successfully',
    knowledgeSuccessful: 'Knowledge has been added successfully.',
    configureLink: 'Configure sharing link',
    initializeLink: 'Initialize link',
    shareLinkTitle: 'Share Assistant',
    shareLinkDescription: 'Set up sharing the assistant with students’ parents.',
    sharedLink: 'Shared Link',
    sharedLinkSubtitle: 'Configure the link that allows other users to access your assistant.',
    expiresOn: 'Expires on{date}',
    nameTask: 'Task name',
    descriptionTask: 'Task description',
    descriptionPlaceholderTask: 'Enter a brief description for the task.',
    configurationAssistant: 'Assistant configuration',
    chatInterface: 'Chat Interface',
    chatInterfaceSubtitle: 'Customize the chat interface to interact with the assistant more easily and vividly',
    chatAppearanceTitle: 'Interface Settings',
    chatAppearanceSubtitle: 'Customize the interface when interacting with the assistant',
    task: {
      titleDelete: 'Delete Task',
      titleErrorDelete: 'Failed to Delete',
      contentDelete: 'This task will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
      contentErrorDelete: 'An assistant currently using this task has been published to the store. Please unpublish the assistant before deleting the task.',
      contentDeleteLeft: 'This task is currently associated with',
      contentDeleteRight: 'If you proceed, the task will be removed from all agents using it. Are you sure you want to delete it?',
      createSuccess: 'Task created successfully',
      createFailed: 'Failed to create task',
      nameAlreadyExists: 'Task name already exists',
      updateSuccess: 'Task updated successfully',
      updateFailed: 'Failed to update task',
      deleteSuccess: 'Task deleted successfully',
      deleteFailed: 'Failed to delete task',
    },
    imageLibraryTitle: 'Explore NextSchool’s Collection',
    imageLibrarySubTitle: 'Explore NextSchool’s Collections',
    deleteAssistantSuccess: 'Assistant deleted successfully',
    deleteAssistantFailed: 'Failed to delete assistant',
    updateAssistantSuccess: 'Assistant interface updated successfully',
    updateAssistantFailed: 'Failed to update assistant interface',
    moreTool: 'More tools',
  },
  classroomTransaction: {
    uploadTypes: {
      document: 'Document',
      exercise: 'Exercise',
      exam: 'Exam',
      flashcard: 'Flashcard',
      practice: 'Practice',
    },
  },
  school: {
    title: 'Track and manage the activities of schools using Nextschool AI',
    create: 'Create school',
    search: 'Search school',
    edit: 'Edit school',
    titleDelete: 'Delete school',
    desc: 'Track the number of actors, users, usage levels, and data insights from all live fields.',
    applied: {
      title: 'Schools using AI',
      rank1: 'ABCN Secondary School',
      rank2: 'Thanh Cong Primary School',
      rank3: 'Hanh Phuc Primary School',
      rank4: 'An Nhien Kindergarten',
    },
    user: {
      title: 'User',
      infoTitle: 'User information',
      infoDesc: 'Track the number of users, user activity, user activity this month, user activity last month.',
      total: 'Total',
      activeThisMonth: 'Active this month',
      usageRateTitle: 'Usage rate of AI assistant',
      usageRateDesc: 'Track the usage rate of the user',
      usageRateGrowth: 'Usage rate',
      usageRateGrowthDesc: 'Usage rate',
      totalUser: 'Total user',
      teacher: 'Teacher',
      student: 'Student',
      other: 'Other',
    },
    userGroupBar: {
      title: 'User group',
      teacher: 'Teacher',
      student: 'Student',
      other: 'Other',
      ratio: 'Ratio',
      ratioDesc: 'Ratio of users using AI',
    },
    stats: {
      growth: 'growth',
      unitMonthAgo: 'compared to last month',
    },
    classStats: {
      classCount: 'Total number of classes',
      contentCount: 'Number of learning content',
    },
    usageFrequency: {
      title: 'Usage frequency',
      frequencyDesc: 'Track the usage frequency',
      number: 'Number of users',
    },
    trendsChart: {
      title: 'Trends of AI application',
      trendsDesc: 'Track the trends of AI application',
      number: 'Number of votes',
    },
    userReturnRateChart: {
      title: 'User return rate',
      desc: 'Track the user return rate',
    },
    appliedList: {
      title: 'Schools using AI',
      rank1: 'ABCN Secondary School',
      rank2: 'Thanh Cong Primary School',
      rank3: 'Hanh Phuc Primary School',
      rank4: 'An Nhien Kindergarten',
    },
    activeRate: {
      title: 'Active rate',
      active: 'Active',
      inactive: 'Inactive',
      rateDesc: 'Track the active rate',
      activeLabel: 'Active rate',
    },
    class: {
      title: 'Class',
      performanceTitle: 'Performance',
      performanceDesc: 'Track the performance of the class',
      lessonCount: 'Number of lessons',
      assignmentCount: 'Number of assignments',
      reviewTitle: 'Review',
      usageRateTitle: 'Usage rate of AI assistant',
      reviewSchool1: 'ABCN Secondary School',
      reviewCount1: '100',
      reviewSchool2: 'Thanh Cong Primary School',
      reviewCount2: '100',
      reviewSchool3: 'Hanh Phuc Primary School',
      reviewCount3: '100',
      usageRateDesc: 'Track the usage rate of the class',
      reviewDesc: 'Track the review of the class',
    },
    review: {
      title: 'Review',
    },
    usageRate: {
      title: 'Usage rate',
      desc: 'Track the usage rate of the class',
      lesson: 'Lesson',
      assignment: 'Assignment',
    },
    interaction: {
      interactionTitle: 'Interaction with AI',
      interactionDesc: 'Track the interaction with AI',
      usageTimeTitle: 'Usage time',
      usageTimeDesc: 'Track the usage time',
      detailAnalysisTitle: 'Detail analysis',
      detailAnalysisDesc: 'Track the detail analysis',
      usageRateTitle: 'Usage rate of AI assistant',
      usageRateDesc: 'Track the usage rate',
      interactionDurationTitle: 'Interaction duration',
      interactionDurationDesc: 'Track the interaction duration',
      student: 'Student',
      teacher: 'Teacher',
      memoryCard: 'Memory card',
      exercise: 'Exercise',
      knowledge: 'Knowledge',
      agent: 'AI Assistant',
      school: 'School',
    },
    overview: {
      title: 'Overview',
    },
    userTab: {
      title: 'User',
    },
    classTab: {
      title: 'Class',
    },
    interactionTab: {
      title: 'Interaction',
    },
  },

  agentPdf: {
    title: 'Chat PDF',
    description: 'Use the AI capabilities of Nextschool to help you read better',
    chat: 'Chat',
    explain: 'Explain',
    insight: 'Insight',
    translate: 'Translate',
    translateTo: 'Translate this content to',
    selectLanguage: 'Select language',
    copy: 'Copy',
    rendering: 'Rendering PDF...',
    pages: 'pages',
    noFile: 'Can\'t load file',
    recentFiles: 'Recent Files',
    noRecentFiles: 'No recent files',
    page: 'Page',
    noFiles: 'No files available',
    noRecentFilesDescription: 'Upload a PDF file to get started',
    viewDetail: 'View detail',
    language: {
      vi: 'Vietnamese',
      en: 'English',
      lo: 'Lao',
      kh: 'Cambodia',
      cn: 'China',
      mm: 'Myanmar',
    },
    actions: {
      explain: 'Explain this content',
      insight: 'Analyze and summarize this content',
      translate: 'Translate this content',
      help: 'Please help me understand this content',
    },
    tools: {
      title: 'PDF Tools',
      description: 'Discover powerful tools to enhance your PDF reading and analysis experience',
      summary: {
        title: 'Document Summary',
        description: 'Intelligently identify key information, quickly create concise summaries to help you grasp the essence of the document.',
      },
      qa: {
        title: 'Smart Q&A',
        description: 'Answer questions based on document content, provide professional answers to enhance understanding of the document.',
      },
      comparison: {
        title: 'Content Comparison',
        description: 'Support reference content to easily navigate to the original text, facilitating accurate comparison and improving reading efficiency.',
      },
      translation: {
        title: 'Document Translation',
        description: 'Translate a PDF file and compare it side-by-side with the original file on the left and the translated file on the right.',
      },
    },
    aiAssistant: {
      title: 'Chat PDF',
      greeting: 'Hello! I can help you create content',
      description: 'Share what you want to say',
      placeholder: 'Enter your question...',
    },
    toolbar: {
      askAI: 'Ask AI',
      explain: 'Explain',
      analyze: 'Analyze',
      translate: 'Translate',
      copy: 'Copy',
    },
  },
  aiKids: {
    clouds: {
      aiBasic: 'AI Basic',
      aiTutor: 'AI Tutor',
      findSecret: 'Find the secret of four-leaf clover',
      aiFriend: 'AI and You',
      aiWorld: 'AI World',
    },
    level: 'Select level',
    back: 'Back',
    backToForm: 'Back to form',
    backToCharacter: 'Back to character',
    backToLevel: 'Back to level',
    backToCloud: 'Back to cloud',
    aiSecret: 'AI Secret',
    chooseCharacter: 'Choose character',
    enterInfo: 'Enter your information',
    fullName: 'Full name',
    birthDate: 'Birth date',
    teacher: 'Teacher',
    className: 'Class name',
    submit: 'Save',
    backToMain: 'Back to main',
    backToMainDesc: 'Back to main',
    findSecret: 'The Secret of the Four Leaf Clover',
  },
  elearning: {
    description: 'Select the most effective learning courses in the AI era',
    aiApplication: 'AI Application',
    aiKids: 'AI for kids',
    stemRobotic: 'STEM & Robotic',
    stemKids: 'Financial for kids',
    exploreCourses: 'Explore AI ELearning',
    universityName: 'UNI ACADEMY',
    searchPlaceholder: 'Search',
    categoryAiApplication: 'AI Application',
    categoryAiKids: 'AI for Kids',
    categoryStemRobotic: 'STEM & Robotic',
    categoryFinanceKids: 'Finance for Kids',
  },
  aiApp: {
    universal: 'Universal',
    specialized: 'Specialized',
    teacher: 'Teacher',
    parent: 'Parent',
    student: 'Student',
    lecturer: 'Lecturer',
    aiBasic: 'AI Basic',
    allCourses: 'All courses',
    lessons: 'lessons',
    minutes: 'minutes',
    aiApplication: 'AI Application',
    aiInPractice: 'AI in practice',
    exploreNewCourse: 'Discover new courses',
    exploreNowPlus: '+ Explore now',
    noFreeCourses: 'No free courses found.',
    noCourses: 'No courses found.',
    viewDetail: 'View Detail',
    exploreCourse: 'Explore Course',
    exploreNow: 'Explore Now',
    at: 'at',
    price: 'Price',
  },

  ocr: {
    title: 'Document created',
    extract: 'Extract',
    extractResult: 'Extract Result',
    preparingContent: 'Preparing content...',
    uploadTitle: 'Uploaded file',
    downloadOriginal: 'Download original',
    aiWriter: 'AI Writer',
    titleDelete: 'Delete document',
    contentDelete: 'The document will be permanently deleted and cannot be undone. Are you sure you want to delete it?',
    imageToWord: {
      title: 'Image To Word',
      description: 'Convert photos, scans, or screenshots into editable text.',
    },
    pdfToWord: {
      title: 'PDF To Word',
      description: 'Convert PDF files to DOC and DOCX documents.',
    },
    exportSuccessful: 'Export successful',
    exportFailed: 'Export failed',
  },
  educationalResource: {
    free: 'Free',
    preview: 'Preview',
    addToClassroom: 'Add to Classroom',
    usage: 'usage',
    description: 'Description',
    resourceInfo: 'Resource Information',
    documentType: 'Document Type',
    subject: 'Subject',
    gradeLevel: 'Grade Level',
    author: 'Author',
    workExperience: 'Work Experience',
    awards: 'Awards',
    certificates: 'Certificates & Degrees',
    coAuthors: 'Co-authors',
    viewDocument: 'View Document',
    reviews: 'Reviews',
    writeReview: 'Write Review',
    filterByRating: 'Filter by rating:',
    reviewsCount: 'reviews',
    developing: 'Feature is under development',
    download: 'Download',
  },
  modals: {
    insufficientCredit: {
      title: 'Oops! Credits are depleted',
      subtitle: 'You need to add credits to continue using the features',
      features: {
        createExam: 'Create exams, slides and exercises',
        aiAssistant: 'Smart assistant GPT, Claude, DeepSeek',
        analyzeContent: 'Analyze, suggest & write content',
        generateImage: 'Create creative, intuitive images with AI',
        mindMap: 'Draw intelligent mind maps',
        learningTools: 'Unlimited learning support tools',
      },
      button: 'Upgrade Package',
    },
    upgradeToPro: {
      title: 'Upgrade to unlock full AI features',
      subtitle: 'Experience smooth, unlimited learning with advanced packages',
      features: {
        abundantCredits: 'Abundant credits every month – enough to create unlimited exams, exercises, and content',
        aiModels: 'Access powerful AI models: GPT-4.1, Claude 3.5, DeepSeek, Gemini 2.5...',
        imageGeneration: 'Create creative, intuitive images with AI',
        learningTools: 'Unlimited learning support tools',
      },
      button: 'Upgrade Now',
    },
    sessionExpired: {
      title: 'Session Expired',
      subtitle: 'Please login again to continue',
      button: 'Login Again',
      badge: 'Work Session',
      securityTitle: 'Account Security',
      securityDescription: 'For your safety, the system has automatically logged you out after a period of inactivity.',
      helpText: 'You will be redirected to the login page',
    },
  },
  creditDisplay: {
    free: 'Free',
    basic: 'Basic',
    advanced: 'Advanced',
    basicDescription: 'GPT 4-mini & 3, Claude...',
    advancedDescription: 'Gemini 2.5 Pro, Llama 3.1...',
    upgrade: 'Upgrade',
  },
  whiteboard: {
    title: 'Whiteboard',
    saveSuccess: 'Whiteboard saved successfully',
    exportInfo: 'Export feature is under development',
    untitled: 'Untitled whiteboard',
    description: 'Create and share your ideas visually',
    toolbar: {
      shapeProperties: 'Shape Properties',
      font: 'Font',
      size: 'Size',
      align: 'Align',
      color: 'Color',
      dashStyle: 'Dash Style',
      fillStyle: 'Fill Style',
      arrowheadStart: 'Arrowhead Start',
      arrowheadEnd: 'Arrowhead End',
      arrowKind: 'Arrow Kind',
      start: 'Start',
      end: 'End',
      // Size options
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      // Color options
      black: 'Black',
      grey: 'Grey',
      lightViolet: 'Light Violet',
      violet: 'Violet',
      blue: 'Blue',
      lightBlue: 'Light Blue',
      green: 'Green',
      lightGreen: 'Light Green',
      yellow: 'Yellow',
      orange: 'Orange',
      red: 'Red',
      lightRed: 'Light Red',
      // Dash style options
      solid: 'Solid',
      dashed: 'Dashed',
      dotted: 'Dotted',
      // Fill style options
      none: 'None',
      noFill: 'No fill',
      pattern: 'Pattern',
      // Font style options
      draw: 'Draw',
      sans: 'Sans',
      serif: 'Serif',
      mono: 'Mono',
      // Alignment options
      left: 'Left',
      center: 'Center',
      right: 'Right',
      top: 'Top',
      middle: 'Middle',
      bottom: 'Bottom',
      // Arrow options
      arc: 'Arc',
      elbow: 'Elbow',
      arrow: 'Arrow',
      triangle: 'Triangle',
      square: 'Square',
      dot: 'Dot',
      diamond: 'Diamond',
      inverted: 'Inverted',
      bar: 'Bar',
    },
  },
  creditBonus: {
    table: {
      workspace: 'Workspace',
      name: 'Bonus package',
      level: 'Level',
      baseCredit: 'Base credit',
      advanceCredit: 'Advanced credit',
      startDate: 'Start date',
      endDate: 'End date',
      status: 'Status',
    },

    status: {
      active: 'Active',
      pending: 'Pending',
      ended: 'Ended',
    },

    filter: {
      title: 'Filter',
      workspace: 'Workspace',
      level: 'Level',
      status: 'Status',
      startDate: 'Start date',
      endDate: 'End date',
      apply: 'Apply',
    },

    action: {
      addPackage: 'Add package',
    },

    confirm: {
      deleteTitle: 'Delete package',
      deleteContent: 'Are you sure you want to delete this package?',
    },

    error: {
      deleteActive: 'Active package cannot be deleted',
      deleteEnded: 'Ended package cannot be deleted',
      deleteFailed: 'Delete package failed',
    },

    form: {
      title: {
        create: 'Add package',
        edit: 'Update package',
      },
      label: {
        level: 'Level',
        name: 'Package name',
        baseCredit: 'Base credit',
        advanceCredit: 'Advanced credit',
        workspace: 'Workspace',
        startDate: 'Start date',
        endDate: 'End date',
        startEndDateLevel2: '(Level 2 package cannot have duplicate phases)',
      },
      placeholder: {
        selectLevel: 'Select level',
        selectWorkspace: 'Select workspace',
        inputName: 'Enter package name',
        selectStatus: 'Select status ',
        startDate: 'Select start date',
        endDate: 'Select end date',
      },
    },
    message: {
      createSuccess: 'Bonus package created successfully',
      createFail: 'Failed to create bonus package',
      editSuccess: 'Bonus package updated successfully',
      editFail: 'Failed to update bonus package',
    },
    validation: {
      endDateAfterStartDate: 'End date must be greater than or equal to start date',
      endDateAfterCurrentDate: 'End date must be greater than or equal to current date',
      startDateBeforeEndDate: 'Start date must be less than or equal to end date',
      startDateAfterCurrentDate: 'Start date must be greater than or equal to current date',
    },
  },

  planAndStorage: {
    title: 'Plan and Storage',
    free: 'Basic Plan',
    historyTransaction: 'Transaction History',
    upgrade: 'Upgrade',
    month: 'month',
    storage: 'Storage',
    uploadedDocs: 'Uploaded Knowledge and Documents',
    empty: 'Empty',
    documents: 'Lesson Documents',
    images: 'Images',
    assistant: 'Assistant Knowledge',
  },

  lessonPlanGenerator: {
    page: {
      title: 'Lesson plan',
    },
    assistant: {
      title: 'Lesson plan assistant',
      placeholder: 'Enter the request you want to create',
      greeting: 'Hello! I can help you write lesson plans.',
      description: 'Tell me what you want to create in the lesson plan.',
    },
    creatingPlan: {
      step1: 'Analyzing requirements and input information...',
      step2: 'Determining number of periods and lesson structure...',
      step3: 'Building the plan tree with main tasks...',
      step4: 'Creating detailed structure for each period...',
      step5: 'Finishing the lesson plan...',
      streamingDone: 'Finished creating the lesson plan. You can continue composing the next sections in the workflow below.',
      banner: 'Creating detailed lesson plan',
      editorLoading: 'Creating lesson plan...',
      pageLoading: 'Loading lesson plan...',
    },
    tasks: {
      regenerate: 'Regenerate',
      stop: 'Stop',
      continue: 'Continue',
      pending: 'Waiting',
      workflowTitle: 'Creation workflow',
    },
    messages: {
      planNotFound: 'Lesson plan data not found',
      downloadNotReady: 'Export feature is under development',
      infoNotReady: 'Showing detailed information',
      useAgentPanel: 'Use the panel on the right to generate or analyze the selected text.',
      chatReply: 'I have received your message. To create content, please use the "Continue composing" button below.',
      mcpWriting: 'Executing: {name}',
      demoContent: 'Collecting related detailed content',
      researchContent: 'Successfully collected information and retrieved relevant documents. Next, I will create the lesson plan.',
    },
    mcp: {
      searchTitle: 'Search',
      writeTitle: 'Write',
    },
  },
  // Add to en-US.ts
  payment: {
    title: 'Payment',
    plan: {
      basic: 'Basic',
      advanced: 'Advanced',
    },
    cycle: {
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
    discount: 'Discount',
    discountCode: 'Discount code',
    enterDiscount: 'Enter discount code...',
    apply: 'Apply',
    cancel: 'Cancel',
    chooseMethod: 'Choose payment method',
    method: {
      bank: 'Bank Transfer',
      card: 'Credit/Debit Card',
      wallet: 'E-Wallet',
    },
    agreePrefix: 'I agree to the',
    terms: 'terms and conditions',
    agreeSuffix: 'of service',
    pay: 'Pay Now',
    backHome: 'Back to Home',
    success: {
      title: 'Payment Successful!',
      subtitle: 'Thank you for upgrading your account. Here are your transaction details:',
      txId: 'Transaction ID',
      amount: 'Amount',
      method: 'Method',
      time: 'Time',
      account: 'Account',
      basicCredit: 'Basic Credit',
      advancedCredit: 'Advanced Credit',
    },
    failure: {
      title: 'Payment Failed',
      reason: 'Reason',
      defaultReason: 'Transaction was declined',
      retry: 'Try Again',
    },
  },
}
